import Command from './remote/Command';
import CommandHelper from './remote/CommandHelper';
import ServiceHelper from './remote/ServiceHelper';
import AjaxRemoteUtil from './utils/AjaxRemoteUtil';
import AuthorityUtil from './utils/AuthorityUtil';
import CommandResolver from './utils/CommandResolver';
import FormLoadHelper from './utils/FormLoadHelper';
import TreeViewMainMenu from './components/menu/TreeViewMainMenu';
import ListTreeViewMainMenu from './components/menu/ListTreeViewMainMenu';
import ListMainMenu from './components/menu/ListMainMenu';
import ReInitAPPComponent from './components/ReInitAPPComponent';
import React from 'react';
import ReactDOM from 'react-dom';

import Fade from './utils/Fade';
import Warning from './utils/Warn';
import IndexedDBUtil from './utils/IndexedDBUtil';
import WebSocketManager from './websocket/WebSocketManager';
import GOTUtil from './utils/GOTUtil';
import CommonUtil from './utils/CommonUtil';
import LogUtil from './utils/LogUtil';
import JobsForm from "./jobs/JobsForm";
import GlobalUserSetForm from "./globalUserSet/GlobalUserSetForm";
import FormItemUtil from './utils/FormItemUtil';
import FormResourceUtil from './utils/FormResourceUtil';
import UserFormUtil from './utils/UserFormUtil';
import GOTXML2Json from './remote/GOTXML2Json';
import NetWorkErrorLog from './networkerror/NetWorkErrorLog';
import OnLineUser from './onlineuser/OnLineUser';
import CommandArg from './forms/sys/remote/CommandArg';
import CustomMenu from './menuCustom/CustomMenu';
import CommandTask from './forms/sys/remote/CommandTask';
import Cmd from './forms/sys/remote/Cmd';
import HookUtil from './utils/HookUtil';
import LicenseUpLoad from './utils/LicenseUpLoad';
import FormItemConst from './formItem/FormItemConst';
import RemotePasteDialog from './utils/RemotePasteDialog';
import PerformanceTiming from './utils/PerformancTiming'
import BusinessMapUtil from './utils/BusinessMapUtil';
import PrintReportDialog from './components/dialogPrintReport/PrintReportDialog';
import { i, tr } from 'react/lib/ReactDOMFactories';
import { func } from 'react/lib/ReactPropTypes';
import DataSetUtil from './universalView/dataSet/DataSetUtil';
import QueryTableUtil from './universalView/QueryTableUtil';

import DoMainAppInfo from './components/doMainAppInfo/DoMainAppInfo';

var base64js = require('base64-js');
var pako = require('pako');


/*var command = {};command.classType = "service";
command.className = userSessionPackage;
command.instanceType = null;
command.instanceId = null;
command.methodName = "getCurrentUserSession";
command.returnType = "UserSession";*/




/*var data = JSON.stringify(command);
var postdata = {request:data};
$.ajax({
    type:'post',
    url:urlBase+"/GongqiERP/ServiceController",
    dataType:"json",
    data:postdata,
    async:false,
    //暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
    xhrFields:{withCredentials:true},

    success:function(data)
    {
      //alert(JSON.stringify(data));

    },
    error:function(data)
    {

    }
});*/



var fromOrig = CommonUtil.getUrlParam("openfrom");
//如果不是从OS打开的
if (fromOrig != "oshome") {

  setInterval(function () {
    if(window.formOSopenDataSetViewId){
      return;
    }
    LogUtil.upLog("");

  }, 60000);
}

window.executeCommandResult = function(commandResult) {
  CommandResolver.resolve(commandResult.tasks, window.formModuleInstance);
}

window.executeCommandForApp = function(commandResult,formModuleInstance) {
  CommandResolver.resolve(commandResult.tasks, formModuleInstance);
}

window.showWarn = function (options) {
  Warning.show(options);
}

window.setGlobalErrorLog = function (options) {
  LogUtil.setGlobalError(options);
}

window.setRpcLog = function (options) {
  LogUtil.setRpcLog(options);
}

window.setOperate = function (options) {
  LogUtil.setOperate(options);
}

window.onerror = function (msg, url, line, col, error) {
  window.setGlobalErrorLog({ stackInfo: msg + "\n" + error ? error.stack : '无异常栈' });
}



//初始化层控制相关结构 {std:{PurchTable:{classDef:function},ProdTable:{classDef:Object}}}
window.layerConfigs = {};

window.userQueryList = {};
window.userExportList = {};
window.flatMainMenuToMenuItem = {};
window.isSelfFrameRoot = true;
function getQueryString (name, url) {
  var arr = url.split("?");
  if (arr != null && arr.length > 1) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = arr[1].match(reg);
    if (r != null) {
      return decodeURI(unescape(r[2]));
    }

  }
  return null;
}
function getQueryStringStr (name, url) {
  var arr = url.split("?");
  if (arr != null && arr.length > 1) {
    var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
    var r = arr[1].match(reg);
    if (r != null) {
      return decodeURI(r[2]);
    }

  }
  return null;
}
function osUrl (url) {
  var arr = url.split("?");
  if (arr != null && arr.length > 1) {
      return arr[0];

  }
  return null;
}

window.appId = getQueryString("appId", window.location.search);
window.didomain = getQueryString("domain", window.location.search);
window.formOSopenUniversal = getQueryString("formOSopenUniversal", window.location.search);
window.formOSopenDataSetView = getQueryString("formOSopenDataSetView", window.location.search);
window.formOSopenDataSetViewId = getQueryStringStr("formOSopenDataSetViewId", window.location.search);
//图表设计器需求  需要获取sesion内历史
window.fromTB = getQueryStringStr("fromTB", window.location.search);

// 所有域 万能视图设计器
window.formOSopenAllUniversal = getQueryString("formOSopenAllUniversal", window.location.search);
window.osUrl = window.location.origin;

window.formOSdsScript = getQueryStringStr("formOSdsScript", window.location.search);

// window.formOSdsScript=true;
// window.formOSopenUniversal = "true";
// window.formOSopenDataSetView = false;
// window.formOSopenDataSetViewId = "";
// 所有域 万能视图设计器
// window.formOSopenAllUniversal = true;
// window.osUrl = "http://127.0.0.1:60000";
// window.didomain = "MIX";

// window.formOSopenDataSetView = true;
// window.formOSopenDataSetViewId = "qa";
window.fixedMenuId = getQueryString("fixedMenuId",window.location.search);

window.toolExportDrop=false;
window.toolPivotDrop=false;
window.toolQueryDrop =false;
window.openFindDrop = false;
window.toolAttachmentDrop = false;

if(window.appId && window.didomain){
  if($(window.frameElement).is('iframe')){
    setTimeout(() => {
      $(window.frameElement).parent().parent().find('.layui-layer-setwin .icon-zuixiaohua').css('color','black');
      $(window.frameElement).parent().parent().find('.layui-layer-setwin .icon-huanyuan').css('color','black');
      $(window.frameElement).parent().parent().find('.layui-layer-setwin .icon-guanbi').css('color','black');
      let elementEv = $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max')[0]
      if(elementEv){
        elementEv.addEventListener('click', function() {
          setTimeout(() => {
            $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').children().first().css('color','black');
            $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display','inline-block').css('height','42px').addClass('layui-layer-ico');
            if(window.toolbarBig){
              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display','flex').css('align-items','center').css('height','58px').removeClass('layui-layer-ico');
              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display','flex').css('align-items','center').css('height','58px').removeClass('layui-layer-ico');
            }else{
              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display','inline-block').css('height','42px').addClass('layui-layer-ico');
              $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display','inline-block').css('height','42px');
            }
          }, 100);
        });
      }
    }, 200);
  }
}

document.addEventListener("click", function(event) {
  // 当点击除了div元素之外的任何地方时，移除标题栏下拉列表类名
  try{
    if(event ){
      if($(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_print' || $(event.target.parentElement.parentElement).attr('id') =='toolbar_print' ){
        $('#toolbarExportLi .dropdown-menu').remove()
        $('#toolbarPivotLi .dropdown-menu').remove()
        $('#toolbarQueryLi .dropdown-menu').remove()
        $('#toolbarAttchmentLi .dropdown-menu').remove()
        $('#selectT .dropdown-menu').hide()
        if($('#toolbarPrintLi .dropdown-menu').hasClass('dropdown-menu')){
          setTimeout(() => {
            $('#toolbarPrintLi .dropdown-menu').remove()
            $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
            $("#toolbar_print .toolbar_print_sml").removeClass('drop');
            $("#toolbar_print .toolbar_print_big").removeClass('drop');
            $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
          }, 150);
        }



        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
        $("#toolbar_export .toolbar_print_big").removeClass('drop');
        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        
        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');


        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
        $("#toolbar_find .toolbar_print_big").removeClass('drop');
        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');


        window.toolExportDrop=false;
        window.toolPivotDrop=false;
        window.toolAttachmentDrop = false;
        return;
      }
      if($(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_export' || $(event.target.parentElement.parentElement).attr('id') =='toolbar_export' ){
        $('#toolbarPrintLi .dropdown-menu').remove()
        $('#toolbarPivotLi .dropdown-menu').remove()
        $('#toolbarQueryLi .dropdown-menu').remove()
        $('#toolbarAttchmentLi .dropdown-menu').remove()
        $('#selectT .dropdown-menu').hide()
        // if($('#toolbarExportLi .dropdown-menu').hasClass('dropdown-menu')){
        //   setTimeout(() => {
        //     $('#toolbarExportLi .dropdown-menu').remove()
        //     $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
        //     $("#toolbar_export .toolbar_print_sml").removeClass('drop');
        //     $("#toolbar_export .toolbar_print_big").removeClass('drop');
        //     $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
            
        //   }, 150);
        // }

        if(window.toolExportDropRemove){
          $('#toolbarExportLi .dropdown-menu').remove()
          $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#toolbar_export .toolbar_print_sml").removeClass('drop');
          $("#toolbar_export .toolbar_print_big").removeClass('drop');
          $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
          window.toolExportDropRemove=false;
          window.toolExportDrop=false;
        }

        if($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')){
          $('#toolbarExportLi .dropdown-menu').remove()
          $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#toolbar_export .toolbar_print_sml").removeClass('drop');
          $("#toolbar_export .toolbar_print_big").removeClass('drop');
          $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
          window.toolExportDropRemove=false;
          window.toolExportDrop=false;
        }

        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
        $("#toolbar_print .toolbar_print_big").removeClass('drop');
        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
        $("#toolbar_find .toolbar_print_big").removeClass('drop');
        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');


        window.toolPivotDrop=false;
        window.toolAttachmentDrop = false;

        return;
      }
      if($(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_Da'  || $(event.target.parentElement.parentElement).attr('id') =='toolbar_Da' ){
        $('#toolbarPrintLi .dropdown-menu').remove()
        $('#toolbarExportLi .dropdown-menu').remove()
        $('#toolbarQueryLi .dropdown-menu').remove()
        $('#toolbarAttchmentLi .dropdown-menu').remove()
        $('#selectT .dropdown-menu').hide()
        // if($('#toolbarPivotLi .dropdown-menu').hasClass('dropdown-menu')){
        //   setTimeout(() => {
        //     $('#toolbarPivotLi .dropdown-menu').remove()
        //     $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
        //     $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
        //     $("#toolbar_Da .toolbar_print_big").removeClass('drop');
        //     $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        //   }, 150);
        // }

        if(window.toolPivotDropRemove){
            $('#toolbarPivotLi .dropdown-menu').remove()
            $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
            $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
            $("#toolbar_Da .toolbar_print_big").removeClass('drop');
            $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
            window.toolPivotDropRemove=false;
            window.toolPivotDrop=false;
        }

        if($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')){
          $('#toolbarPivotLi .dropdown-menu').remove()
          $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
          $("#toolbar_Da .toolbar_print_big").removeClass('drop');
          $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
          window.toolPivotDropRemove=false;
          window.toolPivotDrop=false;
        }

        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
        $("#toolbar_print .toolbar_print_big").removeClass('drop');
        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
        $("#toolbar_export .toolbar_print_big").removeClass('drop');
        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
        $("#toolbar_find .toolbar_print_big").removeClass('drop');
        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');


        window.toolExportDrop=false;
        window.toolAttachmentDrop = false;

        return;

      }
      if($(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_Queryopen' ||$(event.target.parentElement.parentElement).attr('id') =='toolbar_Queryopen'){
        $('#toolbarPrintLi .dropdown-menu').remove()
        $('#toolbarExportLi .dropdown-menu').remove()
        $('#toolbarPivotLi .dropdown-menu').remove()
        $('#toolbarAttchmentLi .dropdown-menu').remove()
        $('#selectT .dropdown-menu').hide()
        if(!window.toolQueryDrop){
          $('#toolbarQueryLi .dropdown-menu').remove()
          
          window.toolQueryDrop=false;

        }
        // if((!window.toolbarBig && $(event.target.parentElement.parentElement).attr('id') =='toolbar_Queryopen') || (window.toolbarBig && $(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_Queryopen') && $(event.target).hasClass('icon-container') ) {
        //   $('#toolbarQueryLi .dropdown-menu').remove()
        //   window.toolQueryDrop=false;
        //   $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
        //   $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
        //   $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
        //   $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        // }

        if($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')){
          $('#toolbarQueryLi .dropdown-menu').remove()
          $("#toolbarQueryLi .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#toolbarQueryLi .toolbar_print_sml").removeClass('drop');
          $("#toolbarQueryLi .toolbar_print_big").removeClass('drop');
          $("#toolbarQueryLi .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
          window.toolQueryDrop=false;
        }

        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
        $("#toolbar_print .toolbar_print_big").removeClass('drop');
        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
        $("#toolbar_export .toolbar_print_big").removeClass('drop');
        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
        $("#toolbar_find .toolbar_print_big").removeClass('drop');
        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');


        window.toolExportDrop=false;
        window.toolPivotDrop=false;
        window.toolAttachmentDrop = false;

        return;
      }

      if($(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_Attchment' || $(event.target.parentElement.parentElement).attr('id') =='toolbar_Attchment' ){
        $('#toolbarPrintLi .dropdown-menu').remove()
        $('#toolbarExportLi .dropdown-menu').remove()
        $('#toolbarPivotLi .dropdown-menu').remove()
        $('#toolbarQueryLi .dropdown-menu').remove()
        $('#selectT .dropdown-menu').hide()
        // if($('#toolbarAttchmentLi .dropdown-menu').hasClass('dropdown-menu')){
        //   setTimeout(() => {
        //     $('#toolbarAttchmentLi .dropdown-menu').remove()
        //     $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
        //     $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
        //     $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
        //     $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        //     window.toolAttachmentDrop=false;
        //   }, 100);
        // }
        if(window.toolAttachmentDrop){
          $('#toolbar_Attchment .dropdown-menu').remove()
          // window.toolAttachmentDrop=false;
          $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        }

        if($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')){
          $('#toolbar_Attchment .dropdown-menu').remove()
          // window.toolAttachmentDrop=false;
          $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        }

        // if((!window.toolbarBig && $(event.target.parentElement.parentElement).attr('id') =='toolbar_Attchment') || (window.toolbarBig && $(event.target.parentElement.parentElement.parentElement).attr('id')  =='toolbar_Attchment') && $(event.target).hasClass('icon-container') ) {
        //   $('#toolbarQueryLi .dropdown-menu').remove()
        //   window.toolAttachmentDrop=false;
        //   $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
        //   $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
        //   $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
        //   $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        // }

        if($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')){
          $('#toolbar_Attchment .dropdown-menu').remove()
          // window.toolAttachmentDrop=false;
          $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
          $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        }


        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
        $("#toolbar_print .toolbar_print_big").removeClass('drop');
        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
        $("#toolbar_export .toolbar_print_big").removeClass('drop');
        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_find .toolbar_print_sml").removeClass('drop');
        $("#toolbar_find .toolbar_print_big").removeClass('drop');
        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        return;
      }





      if($(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_find' ||$(event.target.parentElement.parentElement).attr('id') =='toolbar_find'){
        $('#toolbarPrintLi .dropdown-menu').remove()
        $('#toolbarExportLi .dropdown-menu').remove()
        $('#toolbarPivotLi .dropdown-menu').remove()
        $('#toolbarQueryLi .dropdown-menu').remove()
        $('#toolbarAttchmentLi .dropdown-menu').remove()
        if(!window.openFindDrop){
          $('#selectT .dropdown-menu').hide()
          window.openFindDrop=false;
        }

        // if((!window.toolbarBig && $(event.target.parentElement.parentElement).attr('id') =='toolbar_find') || (window.toolbarBig && $(event.target.parentElement.parentElement.parentElement).attr('id') =='toolbar_find') && $(event.target).hasClass('icon-container') ) {
        //   $('#selectT .dropdown-menu').hide()
        //   window.openFindDrop=false;
        //   $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
        //   $("#toolbar_find .toolbar_print_sml").removeClass('drop');
        //   $("#toolbar_find .toolbar_print_big").removeClass('drop');
        //   $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        // }

        
        if($(event.target.parentElement).hasClass('toolbar_sml_text') || $(event.target.parentElement).hasClass('toolbar_print_big_Icon')){
          $('#selectT .dropdown-menu').hide()
          window.openFindDrop=false;
          $("#selectT .toolbar_print_sml .icon-drop").removeClass('drop');
          $("#selectT .toolbar_print_sml").removeClass('drop');
          $("#selectT .toolbar_print_big").removeClass('drop');
          $("#selectT .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');
        }
        $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_print .toolbar_print_sml").removeClass('drop');
        $("#toolbar_print .toolbar_print_big").removeClass('drop');
        $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_export .toolbar_print_sml").removeClass('drop');
        $("#toolbar_export .toolbar_print_big").removeClass('drop');
        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big").removeClass('drop');
        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');


        window.toolExportDrop=false;
        window.toolPivotDrop=false;
        window.toolAttachmentDrop = false;
        
        return;
      }
      $('#toolbarPrintLi .dropdown-menu').remove()
      $('#toolbarExportLi .dropdown-menu').remove()
      $('#toolbarPivotLi .dropdown-menu').remove()
      $('#toolbarQueryLi .dropdown-menu').remove()
      $('#toolbarAttchmentLi .dropdown-menu').remove()
      $('#selectT .dropdown-menu').hide()

      $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_print .toolbar_print_sml").removeClass('drop');
      $("#toolbar_print .toolbar_print_big").removeClass('drop');
      $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_export .toolbar_print_sml").removeClass('drop');
      $("#toolbar_export .toolbar_print_big").removeClass('drop');
      $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
      $("#toolbar_Da .toolbar_print_big").removeClass('drop');
      $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
      $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
      $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_find .toolbar_print_sml").removeClass('drop');
      $("#toolbar_find .toolbar_print_big").removeClass('drop');
      $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
      $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
      $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      window.toolQueryDrop=false;
      window.toolAttachmentDrop=false;
      window.openFindDrop=false;
      
      window.toolExportDrop=false;
      window.toolPivotDrop=false;


    }else{
      $('#toolbarPrintLi .dropdown-menu').remove()
      $('#toolbarExportLi .dropdown-menu').remove()
      $('#toolbarPivotLi .dropdown-menu').remove()
      $('#toolbarQueryLi .dropdown-menu').remove()
      $('#toolbarAttchmentLi .dropdown-menu').remove()
      $('#selectT .dropdown-menu').hide()

      $("#toolbar_print .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_print .toolbar_print_sml").removeClass('drop');
      $("#toolbar_print .toolbar_print_big").removeClass('drop');
      $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_export .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_export .toolbar_print_sml").removeClass('drop');
      $("#toolbar_export .toolbar_print_big").removeClass('drop');
      $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_Da .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_Da .toolbar_print_sml").removeClass('drop');
      $("#toolbar_Da .toolbar_print_big").removeClass('drop');
      $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_Queryopen .toolbar_print_sml").removeClass('drop');
      $("#toolbar_Queryopen .toolbar_print_big").removeClass('drop');
      $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_find .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_find .toolbar_print_sml").removeClass('drop');
      $("#toolbar_find .toolbar_print_big").removeClass('drop');
      $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      $("#toolbar_Attchment .toolbar_print_sml .icon-drop").removeClass('drop');
      $("#toolbar_Attchment .toolbar_print_sml").removeClass('drop');
      $("#toolbar_Attchment .toolbar_print_big").removeClass('drop');
      $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").removeClass('drop');

      window.toolQueryDrop=false;
      window.toolAttachmentDrop=false;
      window.openFindDrop=false;

      
      window.toolExportDrop=false;
      window.toolPivotDrop=false;


    }

  }catch(e){

  }
});

window.fadeInfo = function (options) {
  Fade.show(options);
}

window.print = function (event,flag) {
  // $(event.target).hasClass("menubtnLable") 
  
  if(($(event.target).hasClass("icon-container"))&& flag=='drop'){
    return;
  }

  if(flag=='drop'){
    if(window.toolbarBig ){
      $("#toolbar_print .toolbar_print_big").addClass('drop');
      $("#toolbar_print .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
    }else{
      $("#toolbar_print .toolbar_print_sml .icon-drop").addClass('drop');
      $("#toolbar_print .toolbar_print_sml").addClass('drop');
    }
  }

  var _id_ = $("#g_tab_content>.active>iframe").attr("id");
  if(flag=="print"){
    //alert(_id_);
    callIFrameFunc(_id_, 'print_gongqi', 'print_gongqi');

  }else{
    callIFrameFunc(_id_, 'print_gongqi', 'drop');
  }
  // console.log("1111");
}

window.openHelp = function(event){
  window.open("./help/help.html","help","")
  // window.open("http://gongqi.info/video/c29.html","help","")
}

window.toobarFunc = function (event, funcName, funcArg) {
  try{
    if(("#g_tab_content>.active>iframe")[0] && $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0]){
      $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0].remove();
    }
  }catch(err){

  }

  //来自于bootstrap等三方框架的esc监听 直接返回不能做处理
  if (event && event.isTrigger == 3)
    return;
  var popIframes = $("#formModal iframe");
  var _id_;
  if (popIframes.length > 0) {
    var iframe = popIframes.get(popIframes.length - 1);
    _id_ = $(iframe).attr("id");

  }
  else {
    _id_ = $("#g_tab_content>.active>iframe").attr("id");
  }

  if(funcName=='attachment'){
    if( $("#toolbar_Attchment").hasClass('disable'))return;
  }

  if (_id_) {
    callIFrameFunc(_id_, funcName, funcArg);
  }
  if(funcName == 'groupExport'){
    let remark ={"title":'打开导出'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'003',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'da'){
    let remark ={"title":'打开数据分析'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'004',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);

  }
  if(funcName == 'queryOpen'){
    let remark ={"title":'打开筛选'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'005',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'queryRemove'){
    let remark ={"title":'移除筛选'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'006',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'attachment'){
    let remark ={"title":'打开附件'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'007',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'recordNew'){
    let remark ={"title":'工具栏新增记录'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'010',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == ' recordSave'){
    let remark ={"title":'工具栏保存记录'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'014',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'groupExport'){
    let remark ={"title":'打开导出'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'003',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'da'){
    let remark ={"title":'打开数据分析'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'004',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);

  }
  if(funcName == 'queryOpen'){
    let remark ={"title":'打开筛选'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'005',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'queryRemove'){
    let remark ={"title":'移除筛选'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'006',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }
  if(funcName == 'attachment'){
    let remark ={"title":'打开附件'}
		var data ={
			'dataArea':'dynamic',
			'userId':window.userInfos.userId,
			'userName':window.userInfos.userName,
			'clientSessionId':window.userInfos.userSessionId,
			'dateTime':new Date().getTime()+'',
			'operationId':'007',
			'formId':'',
			'formDataSourceName':'',
			'formItemName':'',
			'remark':JSON.stringify(remark)
		};
		window.setOperate(data);
  }

  if (funcName == "mainMenuToggle") {

    if (window.userSettingEntry && window.userSettingEntry.showLeftListMenu == true) {
      if ($(".listtree-sidebar").css("display") == "none") {
        $(".listtree-sidebar").css("display", "block");
        //$(".listtree-sidebar").slideToggle(500);
        $("#g_nav_tab_close").css("left", "161px");
        $(".content-wrapper").css("margin-left", "160px ");
        $(".main-footer").css("margin-left", "160px ");
        $('#g_main_header #g_title_area').css('background-color','#1C69DB')
        $('#g_main_header #g_title_area .appSpan').css('color','white')
        $('#g_main_header #g_title_area .doMainSpan').css('color','#eae4e4db')
        $('#g_main_header #g_title_area .icon-xinxi').css('color','white')
      }
      else {
        $(".listtree-sidebar").css("display", "none");
        //$(".listtree-sidebar").slideToggle(500);
        $(".content-wrapper").css("margin-left", "0px ");
       //$("#g_nav_tab_close").css("left", "1px");
        var styleElement = document.getElementById('g_nav_tab_close');
        styleElement.setAttribute('style', 'left: 1px !important;position: fixed;width: 30px;');
        $(".main-footer").css("margin-left", "0px ");
        $('#g_main_header #g_title_area').css('background-color','white')
        $('#g_main_header #g_title_area span').css('color','black')
        $('#g_main_header #g_title_area .icon-xinxi').css('color','#4f4f4f')
      }

    }

    if (window.userSettingEntry && window.userSettingEntry.showLeftMenu == true) {
      if ($(".main-sidebar").css("display") == "none") {
        $(".main-sidebar").css("display", "block");
        //$(".listtree-sidebar").slideToggle(500);
        $(".content-wrapper").css("margin-left", "200px");
        $(".main-footer").css("margin-left", "200px");
        var styleElement = document.getElementById('g_nav_tab_close');
        styleElement.setAttribute('style', 'left: 201px !important;position: fixed;width: 30px;');

        var contentWrapper = document.getElementById('contentWrapper');
        contentWrapper.classList.remove("treeMune_contentClose");
        var wrappers = document.getElementsByClassName("wrapper");
        var wrapper = wrappers[0];
        wrapper.classList.remove("treeMune_wrapperClose");
        $('#g_main_header #g_title_area').css('background-color','#1C69DB')
        $('#g_main_header #g_title_area .appSpan').css('color','white')
        $('#g_main_header #g_title_area .doMainSpan').css('color','#eae4e4db')
        $('#g_main_header #g_title_area .icon-xinxi').css('color','white')
      }
      else {
        $(".main-sidebar").css("display", "none");
        //$(".listtree-sidebar").slideToggle(500);
        $(".content-wrapper").css("margin-left", "0px ");
        $("#contentWrapper").css("margin-left", "0px ");
        var contentWrapper = document.getElementById('contentWrapper');
        contentWrapper.className += ' treeMune_contentClose';
        var wrappers = document.getElementsByClassName("wrapper");
        var wrapper = wrappers[0];
        wrapper.className += ' treeMune_wrapperClose';

        $(".main-footer").css("margin-left", "0px ");
        var styleElement = document.getElementById('g_nav_tab_close');
        styleElement.setAttribute('style', 'left: 1px !important;position: fixed;width: 30px;');
        $('#g_main_header #g_title_area').css('background-color','white')
        $('#g_main_header #g_title_area span').css('color','black')
        $('#g_main_header #g_title_area .icon-xinxi').css('color','#4f4f4f')
      }
    }

    if ($("#toolBarMainMenuToggleA i").hasClass("fa-rotate-180")) {
      $("#toolBarMainMenuToggleA i").removeClass("fa-rotate-180")
    }
    else {
      $("#toolBarMainMenuToggleA i").addClass("fa-rotate-180")
    }
  }
}

window.callIFrameFunc = function () {
  var args = arguments;
  var iframeId = args[0];
  var funcName = args[1];
  var funcArg = args[2];
  var ifr = document.getElementById(iframeId);
  var win = ifr.window || ifr.contentWindow;
  var fn = win[funcName];
  if (typeof fn === 'function') {
    return fn.apply(null, [funcArg]);
  }
  //win.refresh(arg);
}


window.openMenuItem = function (args) {
  //alert(menuItemId+JSON.stringify(argCaller));


  if (isIE) {
    //if(!window.ieOpenMenuItemArgsMQ)window.ieOpenMenuItemArgsMQ = [];
    //window.ieOpenMenuItemArgsMQ.push(args);
    var key = args.menuItemId + "." + args.formId;
    if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
      initFormWholeObject(args);
    }
    else {
      let _window = window;
      IndexedDBUtil.getDataById(key, IndexedDBUtil.DB.name, function (e) {
        var data = e.target.result;
        if (data)
          _window.FormsWholeObjectCache[key] = data.data;
        _window.initFormWholeObject(args);
      });
    }
    return;
  }

  if (!$.isEmptyObject(args.argCaller))
    sessionStorage.setItem("callerArg", JSON.stringify(args.argCaller));
  testOpenForm(args);
}

window.initFormWholeObject = function (openArgs) {
  var _parentWindow = window;
  var userId = _parentWindow.userInfos.userId;

  var wholeObject = _parentWindow.getFormWholeObjectCache(window.menuItemId, window.formId);
  var formObjectStandardMd5 = null; var formObjectUserSetMd5 = null; var md5prefetchCommandResult = null; var formObjectAuthorityMd5s = {};
  let userGroups = _parentWindow.userInfos.userGroups;


  if (wholeObject) {
    formObjectStandardMd5 = wholeObject.formObjectStandard.md5; formObjectUserSetMd5 = wholeObject.formObjectUserSet.md5; md5prefetchCommandResult = wholeObject.formPrefetchCommandResult.md5;
    for (let i = 0; i < userGroups.length; i++) {
      let _userGroupId = userGroups[i];
      let formObjectAuthority = wholeObject.mapFormObjectAuthority[_parentWindow.userInfos.subSysId + "." + window.menuItemId + "." + _userGroupId];
      if (formObjectAuthority) formObjectAuthorityMd5s[userGroupId] = formObjectAuthority.md5;
      else formObjectAuthorityMd5s[_userGroupId] = "";
    }
  }
  else {
    for (let i = 0; i < userGroups.length; i++) {
      let userGroupId = userGroups[i];
      formObjectAuthorityMd5s[userGroupId] = "";
    }
  }

  var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", "loadFormWhole", "FormWholeObject");


  command.appendArg(openArgs.menuItemId);
  command.appendArg(openArgs.formId);
  command.appendArg(userId);
  //standard
  command.appendArg(formObjectStandardMd5);
  //userset
  command.appendArg(formObjectUserSetMd5);
  command.appendArg(md5prefetchCommandResult);

  command.appendArg(formObjectAuthorityMd5s, "java.util.Map");

  var _faultHandler = function (data) {
    $("#loading").css('display', 'none');
    Warning.show({text:"页面初始化失败 请检查网络是否正常或联系管理员"});
  };

  var _resultHandler = function (data) {
    syncFormWholeObjectIE(wholeObject, data.result, openArgs);
  }
  var remoteArg = { command: command, lockText: "正在初始页面结构 请稍后...", resultFunction: _resultHandler, faultFunction: _faultHandler, sync: false };
  ServiceHelper.addTokenWithCommand(remoteArg);
}

window.syncFormWholeObjectIE = function (wholeObject, data, openArgs) {
  var _parentWindow = window;
  var formObjectStandard; var formPrefetchCommandResult; var formObjectUserSet;

  if (data.sameFormObjectStandard)//如果same 则wholeObject一定不为空
  {
    formObjectStandard = wholeObject.formObjectStandard; data.formObjectStandard = wholeObject.formObjectStandard;
  }
  else {
    formObjectStandard = data.formObjectStandard;
  }
  if (data.sameFormPrefetchCommandResult) {
    formPrefetchCommandResult = wholeObject.formPrefetchCommandResult; data.formPrefetchCommandResult = wholeObject.formPrefetchCommandResult;
  }
  else {
    formPrefetchCommandResult = data.formPrefetchCommandResult;
  }
  if (data.sameFormObjectUserSet) {
    formObjectUserSet = wholeObject.formObjectUserSet; data.formObjectUserSet = wholeObject.formObjectUserSet;
  }
  else {
    formObjectUserSet = data.formObjectUserSet;
  }
  var xmlDoc = GOTXML2Json.getXMLDoc(formObjectStandard.formXML);
  var formXML = GOTXML2Json.parseForm(xmlDoc);

  _parentWindow.origFormXMLDoc = xmlDoc;
  _parentWindow.formXML = formXML;
  _parentWindow.formId = formXML.id;
  var forms = _parentWindow.got.DataDictionary.Forms;
  if (forms == null)
    _parentWindow.got.DataDictionary["Forms"] = [formXML];
  else
    forms.push(formXML);
  var _key = FormItemUtil.getFormStoresKey(openArgs.menuItemId, formXML.id);

  if (formObjectStandard.listRemoteMethods && formPrefetchCommandResult && formPrefetchCommandResult.commandResults) {
    let _cmdResults = formPrefetchCommandResult.commandResults;
    let _listRemoteMethods = formObjectStandard.listRemoteMethods;
    for (let i = 0; i < _listRemoteMethods.length; i++) {
      let item = _listRemoteMethods[i];
      if (item.prefetch == true) {
        if (_cmdResults.hasOwnProperty(item.methodName)) {
          item.commandResult = _cmdResults[item.methodName];
        }
      }
    }
  }

  _parentWindow[_key] = {
    mapItemProperty: formObjectStandard.mapItemProperty,
    listRemoteMethods: formObjectStandard.listRemoteMethods,
    listTmpTable: formObjectStandard.listTmpTable,
    listAggregateTable: formObjectStandard.listAggregateTable,
    mapQueryTable: formObjectStandard.mapQueryTable
  };


  if (formPrefetchCommandResult && formPrefetchCommandResult.commandResults) {
    let listRemoteMethods = _parentWindow[_key].listRemoteMethods;
    if (listRemoteMethods) {
      for (let i = 0; i < listRemoteMethods.length; i++) {
        let remoteMethod = listRemoteMethods[i];
        if (formPrefetchCommandResult.commandResults.hasOwnProperty(remoteMethod.methodName)) {
          remoteMethod.commandResult = formPrefetchCommandResult.commandResults[remoteMethod.methodName];
        }
      }
    }
  }
  //TODO IE 暂不考虑自定义查询 导出
  /*if(formObjectUserSet.mapUserQueryDefault)
  {
    for(let key in formObjectUserSet.mapUserQueryDefault)
    {
      let holeKey = key+"."+window.menuItemId;

      if(!formObjectUserSet.mapUserQueryDefault[key]
        || !formObjectUserSet.mapUserQueryDefault[key].xml
      )
      {
        delete QueryUtil.userQueryList[holeKey];
      }
      else
      {
        var obj = formObjectUserSet.mapUserQueryDefault[key];
        //如果有默认的话 obj.xml是后台保存的xml
        //如果obj.xml不是JSON 那就调用转换函数转换成JSON
        obj.xml = QueryUtil.xmlQuery2JsonQuery(obj.xml);
        QueryUtil.userQueryList[holeKey] = obj.xml;
      }
    }


  }

  if(formObjectUserSet.mapUserExportDefault)
  {

    for(let key in formObjectUserSet.mapUserExportDefault)
    {
      if(!formObjectUserSet.mapUserExportDefault[key]
        || formObjectUserSet.mapUserExportDefault[key] == ""
        || !formObjectUserSet.mapUserExportDefault[key].xml
      )
      {

      }
      else
      {
        let holeKey = key + "." + window.menuItemId;
        let obj = formObjectUserSet.mapUserExportDefault[key];
        FormDataSources.userExportList[holeKey] = obj.xml;
      }
    }
  }*/
  _parentWindow[_key].mapFormObjectAuthority = data.mapFormObjectAuthority;
  //setFormAuthority(data.mapFormObjectAuthority,formXML,window.menuItemId);

  if (formObjectUserSet.userFormDefault && formObjectUserSet.userFormDefault.xml) {
    if (!_parentWindow.userSetForms || !_parentWindow.userSetForms.hasOwnProperty(openArgs.menuItemId + "." + formXML.id)) {
      let getxml = new DOMParser();
      let formDefaultDoc = getxml.parseFromString(formObjectUserSet.userFormDefault.xml, "text/xml");
      let mergedXML = UserFormUtil.mergeXML(formDefaultDoc.documentElement, xmlDoc, formObjectStandard.formNodeList);
      if (mergedXML) {
        if (!_parentWindow.userProperties)
          _parentWindow.userProperties = {};
        _parentWindow.userProperties[window.menuItemId + "." + window.formId] = {};
        let userFormXML = GOTUtil.parseUserForm2Form(xmlDoc, mergedXML);
        let formDesign = xmlDoc.children[2];
        xmlDoc.removeChild(formDesign);
        xmlDoc.appendChild(userFormXML);
        let defaultForm = GOTXML2Json.parseForm(xmlDoc);
        if (!_parentWindow.userSetForms) _parentWindow.userSetForms = {};
        _parentWindow.userSetForms[openArgs.menuItemId + "." + formXML.id] = defaultForm;
      }
    }
  }


  _parentWindow.setFormWholeObjectCache(openArgs.menuItemId, openArgs.formId, data)

  //window.ieOpenMenuItemArgsMQ.push(args);

  if (!$.isEmptyObject(openArgs.argCaller))
    sessionStorage.setItem("callerArg", JSON.stringify(openArgs.argCaller));
  testOpenForm(openArgs);

}


window.exeParentCommandResult = function (formUUId, commandResult) {
  var hasRelatedForm = false;
  $("#g_tab_content .tab-pane iframe").each(
    function () {
      var iframeSrc = this.src;
      if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
        return true;
      }
      if (this.contentWindow && this.contentWindow.formModuleInstanceuuId && this.contentWindow.formModuleInstanceuuId == formUUId) {
        this.contentWindow.exeCommandResult(commandResult);
        return false;
      }
    }
  );

  var popIframes = $("#formModal iframe");
  for (var i = 0; i < popIframes.length; i++) {
    var iframe = popIframes.get(i);
    var iframeSrc = iframe.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      return true;
    }
    if (iframe.contentWindow && iframe.contentWindow.formModuleInstanceuuId && iframe.contentWindow.formModuleInstanceuuId== formUUId) {
      iframe.contentWindow.exeCommandResult(commandResult);
      return false;
    }
  }
}

window.switchToRelatedForm = function (callerKey, formUUId) {
  var hasRelatedForm = false;
  $("#g_tab_content .tab-pane iframe").each(
    function () {
      var iframeSrc = this.src;
      if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
        return true;
      }
      if (this.contentWindow.formModuleInstance && this.contentWindow.argCaller) {
        var _argCaller = this.contentWindow.argCaller;
        if (_argCaller.calleruuId == formUUId && callerKey != null && callerKey == _argCaller.callerKey) {
          $("#g_nav_tabs>li.active").each(function () {
            $(this).removeClass("active");
            var origtabpaneid = $(this).attr("tabpaneid")
            $("#" + origtabpaneid).removeClass("active");
          });
          hasRelatedForm = true;

          $(this).parent().addClass("active");
          var _tabpaneid = $(this).parent().attr("id");
          $("#g_nav_tabs>li").each(function () {
            if ($(this).attr("tabpaneid") == _tabpaneid) {
              $(this).addClass("active");
              return false;
            }
          });

          return false;
        }
      }

    }
  );
  return hasRelatedForm;
}

$('#g_tab_content .tab-pane iframe').each(function(){if(this.id==''){window.formModuleInstance=this.contentWindow.formModuleInstance;}})

window.getJoinGroupObject = function (groupAlias, uuid) {
  var joinGroup = null;
  $("#g_tab_content .tab-pane iframe").each(function () {
    var iframeSrc = this.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      return true;
    }
    //if(this.contentWindow!=_window && typeof(this.contentWindow.linkGroupActiveHandler)=="function")
    if (this.contentWindow.formModuleInstance && this.contentWindow.formModuleInstanceuuId == uuid) {
      if (this.contentWindow.formModuleInstance.formDataSources) {
        var groups = this.contentWindow.formModuleInstance.formDataSources.groups;
        if (groups && groups.hasOwnProperty(groupAlias)) {
          joinGroup = groups[groupAlias];
          return false;
        }

      }
    }

  });

  var popIframes = $("#formModal iframe");
  for (var i = 0; i < popIframes.length; i++) {
    var iframe = popIframes.get(i);
    var iframeSrc = iframe.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      continue;
    }
    if (iframe.contentWindow.formModuleInstance && iframe.contentWindow.formModuleInstanceuuId == uuid) {
      if (iframe.contentWindow.formModuleInstance.formDataSources) {
        var groups = iframe.contentWindow.formModuleInstance.formDataSources.groups;
        if (groups && groups.hasOwnProperty(groupAlias)) {
          joinGroup = groups[groupAlias];
          break;
        }
      }
    }
  }

  return joinGroup;
}

window.linkGroupActiveJoin = function (group, formModuleInstanceuuId, delay = true, updateRelatedPart = false) {
  try {
    $("#g_tab_content .tab-pane iframe").each(function () {
      var iframeSrc = this.src;
      if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
        return true;
      }
      //if(this.contentWindow!=_window && typeof(this.contentWindow.linkGroupActiveHandler)=="function")
      if (this.contentWindow.formModuleInstance) {
        this.contentWindow.formModuleInstance.formReinitHandler(group, formModuleInstanceuuId, delay, updateRelatedPart);
      }

    });

    var popIframes = $("#formModal iframe");
    for (var i = 0; i < popIframes.length; i++) {
      var iframe = popIframes.get(i);
      var iframeSrc = iframe.src;
      if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
        continue;
      }
      if (iframe.contentWindow.formModuleInstance)
        iframe.contentWindow.formModuleInstance.formReinitHandler(group, formModuleInstanceuuId, delay, updateRelatedPart);
    }
  }
  catch (e) {
    //个别需求如嵌入三方网页时存在跨域如果不捕获会导致该函数中断影响功能
  }
}

window.closeFormWithSameId = function (formId) {


  $("#formModal iframe").each(function () {
    var iframeSrc = this.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      return true;
    }
    if (this.contentWindow.formId == formId) {
      closePopUpForm(null, formId);
    }
  });

  /*var popIframes = $("#formModal iframe");
  for(let i = 0;i<popIframes.length;i++)
  {

  }
  if(popIframes.length>0)
  {
    var iframe = popIframes.get(0);
    if(iframe.contentWindow.formId == formId)
      closePopUpForm(null,formId);
  }*/

  var activeFormUUId = null;
  $("#g_tab_content .tab-pane iframe").each(function () {
    var iframeSrc = this.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      return true;
    }
    if (this.contentWindow.formId == formId) {
      var formUUId = this.contentWindow.formModuleInstanceuuId;
      var tabPane = $(this).parent();
      if (tabPane.hasClass("active")) {
        activeFormUUId = formUUId;
      }
      else {
        closeForm(formUUId);
      }
    }
  });
  if (activeFormUUId) closeForm(activeFormUUId);
}

window.getFormInstanceByUUID = function (formUUId) {
  var formInstance = null;
  $("#g_tab_content .tab-pane iframe").each(function () {
    var iframeSrc = this.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      return true;
    }
    if (this.contentWindow.formModuleInstanceuuId == formUUId) {
      formInstance = this.contentWindow.formModuleInstance;
      return false;
    }
  });
  if (!formInstance) {
    $("#formModal iframe").each(function () {
      if (this.contentWindow.formModuleInstanceuuId == formUUId) {
        formInstance = this.contentWindow.formModuleInstance;
        return false;
      }
    });
  }
  return formInstance;
}

window.closeForm = function (formUUId, check = false ,byKeyBoard = null) {
  var hasClosed = false;
  $("#formModal iframe").each(function () {
    var iframeSrc = this.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      return true;
    }
    if (this.contentWindow.formModuleInstanceuuId == formUUId) {
      closePopUpFormByUUId(formUUId, check);
      return false;
    }
  });
  //TODO_YL ESC 不关闭 画面
  if(byKeyBoard ==27){
    return;
  }

  $("#g_tab_content .tab-pane iframe").each(function () {
    var iframeSrc = this.src;
    if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
      return true;
    }
    if (this.contentWindow.formModuleInstanceuuId == formUUId) {
      if (!this.contentWindow.formModuleInstance) {
        doCloseForm(this);
        return;
      }
      let _menuItemId = this.contentWindow.menuItemId;
      let _formId = this.contentWindow.formId;
      let _formName = this.contentWindow.formModuleInstance.formName;
      if (check) {
        var _result = this.contentWindow.allowClose();
        if (!_result.allow) {
          if (_result.text) {
            let _that = this;
            Warning.show({
              confirm: _result.noContinue ? {} : {
                isShow: true, text: "继续关闭", event: function () {

                  doCloseForm(_that);

                  var mi = FormResourceUtil.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
                  if (mi) {
                    if (mi.prefetch == true) {
                      if (mi.commandResult) {
                        CommandResolver.resolve(mi.commandResult.tasks, null);
                      }
                    }
                    else {
                      var arg = new CommandArg();
                      var command = CommandHelper.createFormInstance(_formName, "doFormClosed", "void");
                      command.appendArg(arg, "CommandArg");

                      ServiceHelper.addTokenWithCommand({
                        command: command,
                        resultFunction: function (result) {
                          if (result.result && result.result.tasks && result.result.tasks.length > 0)
                            CommandResolver.resolve(result.result.tasks, null);
                        }
                      });
                    }
                  }

                }
              }, cancel: { isShow: true, event: '' }, text: _result.text
            });
          }

          return;
        }
      }

      doCloseForm(this);

      var mi = FormResourceUtil.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
      if (mi) {
        if (mi.prefetch == true) {
          if (mi.commandResult) {
            CommandResolver.resolve(mi.commandResult.tasks, null);
          }
        }
        else {
          var arg = new CommandArg();
          var command = CommandHelper.createFormInstance(_formName, "doFormClosed", "void");
          command.appendArg(arg, "CommandArg");

          ServiceHelper.addTokenWithCommand({
            command: command,
            resultFunction: function (result) {
              if (result.result && result.result.tasks && result.result.tasks.length > 0)
                CommandResolver.resolve(result.result.tasks, null);
            }
          });
        }
      }

      return false;
    }
  });
}

window.doCloseForm = function (_this) {
  if(window.parent.window.isCanSave != undefined && window.parent.window.isCanSave==true){
    alert("请先保存业务导图");
    return;
  }
  var tabPane = $(_this).parent();
  if (tabPane.hasClass("active")) {
    var arr = $("#g_tab_content>div.tab-pane");

    var nextIndexTemp = -1;
    if (window.previousGlobalTabPageId) {
      var pagearrTemp = $("#g_nav_tabs>li");
      for (let i = 0; i < pagearrTemp.length; i++) {
        let pageTemp = pagearrTemp[i];
        if ($(pageTemp).attr("tabpaneid") == window.previousGlobalTabPageId) {
          nextIndexTemp = i;
          break;
        }
      }
    }

    var nextIndex = nextIndexTemp;
    var childIndex = tabPane.index();
    if (nextIndex == -1 || nextIndex == childIndex) {
      if (childIndex - 1 < 0) {
        if (childIndex + 1 < arr.length)
          nextIndex = childIndex + 1;
      }
      else {
        nextIndex = childIndex - 1;
      }
    }


    var pagearr = $("#g_nav_tabs>li");
    var liWillRemoved = $("#g_nav_tabs>li.active");
    var nextpage = pagearr[nextIndex];
    $(nextpage).addClass("active");
    $(arr[nextIndex]).addClass("active");
    var nextIframe = $(arr[nextIndex]).find("iframe");
    if (nextIframe.length != 0) {
      var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
      $("#ActiveRecordCount").text("");
      if (typeof (win.closeToCurrent) == 'function')
        win.closeToCurrent();
    }
    else {
      setToolBar(clearToolbarObject); $("#ActiveRecordCount").text("");
    }
    tabPane.remove();
    liWillRemoved.remove();
  }
  else {
    var tabpaneid = tabPane.attr("id");
    var $li;
    $("#g_nav_tabs>li").each(
      function () {
        if ($(this).attr("tabpaneid") == tabpaneid) {
          $li = $(this);
          return false;
        }
      }
    );
    if ($li) $li.remove();
    tabPane.remove();
  }

  if ($("#g_nav_tabs>li").length < 1)
    $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
}

window.setFormLabel = function (formUUId, label) {
  var i = window.hasMenuMap?1:0;
  var k = -1;
  $("#g_tab_content .tab-pane iframe").each(function () {
    try {
      if (this.contentWindow.formModuleInstanceuuId == formUUId) {
        k = i;
        return false;
      }
    }
    catch (e) {

    }
    i++;
  });
  var j = window.hasMenuMap?1:0;
  if (k != -1) {
    var as = $("#g_nav_tabs>li>a");
    if (as.length > k-j) {
      $(as[k-j]).html(label);
    }
  }
}

window.closePopUpFormByUUId = function (uuid, check = false) {
  var modalList = $("#formModal .modal");
  var modalForm;
  if (modalList.length == 0)
    return;
    //存在异常提醒 不关闭画面
  if($(".gongqi-warn").hasClass('gongqi-warn')){
    return;
  }
  let _menuItemId; let _formId; let _formName;
  for (let i = 0; i < modalList.length; i++) {
    let item = modalList.get(i);
    let itemFrame = $(item).find("iframe");
    let contentWindow = itemFrame.get(0).window || itemFrame.get(0).contentWindow;
    if (contentWindow.formModuleInstanceuuId == uuid) {
      if (check) {
        let closeResult = contentWindow.allowClose();
        if (!closeResult.allow) {
          if (closeResult.text) {
            let _that = this;
            Warning.show({
              confirm: {
                isShow: true, text: "继续关闭", event: function () {

                  if (!modalForm) return;
                  $(modalForm).remove();

                  var mi = FormResourceUtil.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
                  if (mi) {
                    if (mi.prefetch == true) {
                      if (mi.commandResult) {
                        CommandResolver.resolve(mi.commandResult.tasks, null);
                      }
                    }
                    else {
                      var arg = new CommandArg();
                      var command = CommandHelper.createFormInstance(_formName, "doFormClosed", "void");
                      command.appendArg(arg, "CommandArg");

                      ServiceHelper.addTokenWithCommand({
                        command: command,
                        resultFunction: function (result) {
                          if (result.result && result.result.tasks && result.result.tasks.length > 0)
                            CommandResolver.resolve(result.result.tasks, null);
                        }
                      });
                    }
                  }

                  $("#ActiveRecordCount").text("");
                  modalList = $("#formModal .modal");
                  if (modalList.length > 0) {
                    var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
                  }
                  else {
                    var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
                  }

                  if (nextIframe.length != 0) {
                    var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
                    if (typeof (win.closeToCurrent) == 'function')
                      win.closeToCurrent();
                  }

                }
              }, cancel: { isShow: true, event: '' }, text: closeResult.text
            });
          }
          modalForm = item; _menuItemId = contentWindow.menuItemId; _formId = contentWindow.formId; _formName = contentWindow.formModuleInstance.formName;
          return;
        }
      }
      modalForm = item; _menuItemId = contentWindow.menuItemId; _formId = contentWindow.formId; _formName = contentWindow.formModuleInstance.formName;
      break;
    }
  }
  if (!modalForm) return;
  //modalForm = modalList.get(modalList.length-1);
  $(modalForm).remove();

  var mi = FormResourceUtil.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
  if (mi) {
    if (mi.prefetch == true) {
      if (mi.commandResult) {
        CommandResolver.resolve(mi.commandResult.tasks, null);
      }
    }
    else {
      var arg = new CommandArg();
      var command = CommandHelper.createFormInstance(_formName, "doFormClosed", "void");
      command.appendArg(arg, "CommandArg");

      ServiceHelper.addTokenWithCommand({
        command: command,
        resultFunction: function (result) {
          if (result.result && result.result.tasks && result.result.tasks.length > 0)
            CommandResolver.resolve(result.result.tasks, null);
        }
      });
    }
  }

  $("#ActiveRecordCount").text("");
  modalList = $("#formModal .modal");
  if (modalList.length > 0) {
    var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
  }
  else {
    var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
  }

  if (nextIframe.length != 0) {
    var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
    if (typeof (win.closeToCurrent) == 'function')
      win.closeToCurrent();
  }
}

window.closePopUpForm = function (menuItemId, formId, check = false) {
  var modalList = $("#formModal .modal");
  var modalForms = []; var modalFormsInfo = [];
  if (modalList.length == 0)
    return;

  for (let i = 0; i < modalList.length; i++) {
    let item = modalList.get(i);
    let itemFrame = $(item).find("iframe");
    let contentWindow = itemFrame.get(0).window || itemFrame.get(0).contentWindow;
    if (!menuItemId) {
      if (contentWindow.formId == formId) {
        if (check) {
          let closeResult = contentWindow.allowClose();
          if (!closeResult.allow) {
            if (closeResult.text)
              Warning.show({
                confirm: {
                  text: "继续关闭", event: function () {
                    modalForms.push(item);
                    modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName })
                    window.doModalFormClose(modalForms, modalFormsInfo);
                    window.setNextCurrentFormAfterClosePopUpForm();
                    closePopUpForm(menuItemId, formId, check);
                  }
                },
                cancel: { isShow: true, text: "取消" }, text: closeResult.text
              });
            return;
          }
        }
        modalForms.push(item);
        modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName })
      }
    }
    else {
      if (contentWindow.menuItemId == menuItemId && contentWindow.formId == formId) {
        if (check) {
          let closeResult = contentWindow.allowClose();
          if (!closeResult.allow) {
            if (closeResult.text)
              Warning.show({
                confirm: {
                  text: "继续关闭", event: function () {
                    modalForms.push(item);
                    modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName })
                    window.doModalFormClose(modalForms, modalFormsInfo);
                    window.setNextCurrentFormAfterClosePopUpForm();
                  }
                },
                cancel: { isShow: true, text: "取消" }, text: closeResult.text
              });
            return;
          }
        }
        modalForms.push(item);
        modalFormsInfo.push({ menuItemId: contentWindow.menuItemId, formId: contentWindow.formId, formName: contentWindow.formModuleInstance.formName })
        break;
      }
    }
  }
  if (modalForms.length == 0) return;

  //modalForm = modalList.get(modalList.length-1);
  window.doModalFormClose(modalForms, modalFormsInfo);
  window.setNextCurrentFormAfterClosePopUpForm();

}

window.setNextCurrentFormAfterClosePopUpForm = function () {
  var modalList = $("#formModal .modal");
  if (modalList.length > 0) {
    var nextIframe = $(modalList.get(modalList.length - 1)).find("iframe");
  }
  else {
    var nextIframe = $("#g_tab_content>div.tab-pane.active").find("iframe");
  }

  if (nextIframe.length != 0) {
    var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
    if (typeof (win.closeToCurrent) == 'function')
      win.closeToCurrent();
  }
}

window.doModalFormClose = function (modalForms, modalFormsInfo) {
  for (let i = 0; i < modalForms.length; i++) {
    let modalForm = modalForms[i];
    $(modalForm).remove();
    let modalFormInfo = modalFormsInfo[i];
    var mi = FormResourceUtil.getCommandArgMethodInfo("formClosed", modalFormInfo.menuItemId, modalFormInfo.formId);
    if (mi) {
      if (mi.prefetch == true) {
        if (mi.commandResult) {
          CommandResolver.resolve(mi.commandResult.tasks, null);
        }
      }
      else {
        var arg = new CommandArg();
        var command = CommandHelper.createFormInstance(modalFormInfo.formName, "doFormClosed", "void");
        command.appendArg(arg, "CommandArg");

        ServiceHelper.addTokenWithCommand({
          command: command,
          resultFunction: function (result) {
            if (result.result && result.result.tasks && result.result.tasks.length > 0)
              CommandResolver.resolve(result.result.tasks, null);
          }
        });
      }
    }

    $("#ActiveRecordCount").text("");
  }
}

window.getCurrentFormLabel = function (e) {
  return $("#g_nav_tabs>li.active>a").text();
}

window.reOpenCurrentForm = function (e,arg=null) {
  var popIframes = $("#formModal iframe");
  if (popIframes.length > 0) {
    iframe = popIframes.get(popIframes.length - 1);
    let win = iframe.window || iframe.contentWindow;
    //var argCallerString = sessionStorage.getItem("callerArg");
    //if(argCallerString != undefined && argCallerString != null)
    //{
    //    sessionStorage.removeItem("callerArg");
    //    var argCaller = JSON.parse(argCallerString);
    //    window.argCaller = argCaller;
    //}
    if (win.argCaller) {
      let argCallerString = JSON.stringify(win.argCaller);
      sessionStorage.setItem("callerArg", argCallerString);
    }
    win.location.reload();
  }
  else {
    var arr = $("#g_tab_content>div.tab-pane.active iframe");
    if (arr.length > 0) {
      var iframe = arr.get(0);
      let win = iframe.window || iframe.contentWindow;
      if (win.argCaller) {
        let argCallerString = JSON.stringify(win.argCaller);
        sessionStorage.setItem("callerArg", argCallerString);
      }

      /*if(arg)
      {
        win[arg.injectName]=arg.injectValue;
      }*/

      win.location.reload();
    }
  }
}

//TODO 画面关闭是否需要React卸载
window.closeCurrentForm = function (e) {
  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
  var tabpaneEl = document.getElementById(tabpaneid);
  var $iframe = $(tabpaneEl).find(">iframe");
  //var $iframe = $("#"+tabpaneid+" >iframe");

  if ($iframe.length > 0) {
    var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
    if (win)
      closeForm(win.formModuleInstanceuuId, false);
  }
}
window.closeAllForm = function (e) {
  $("#g_nav_tabs").children("li:not(.menumap)").remove();
  //打开画面 把content的背景隐藏 避免二次开发设置了带颜色的背景而造成显示问题 当都关掉的时候 需要再行恢复
  if(window.hasMenuMap){
    $("#g_nav_tabs").children(".menumap").addClass('active');
    $("#g_tab_content").children(".menumap").addClass('active');
    $("#g_tab_content").children("div:not(.menumap)").remove();
  }else{
    $("#g_tab_content").empty().css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
  }
}
window.closeOtherForm = function (e) {
  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
  $("#g_tab_content>div.tab-pane").each(function () {
    if($(this).hasClass("menumap"))return;
    if ($(this).attr("id") != tabpaneid) {
      var $iframe = $(this).find("iframe");

      if ($iframe.length > 0) {
        var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
        if (win)
          closeForm(win.formModuleInstanceuuId, false);
      }
    }

  });
}
window.closeRightForms = function (e) {
  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
  $("#g_tab_content>div.tab-pane").each(function () {

    if ($(this).attr("id") != tabpaneid) {
      if ($(e.currentTarget).index() < $(this).index()) {
        var $iframe = $(this).find("iframe");
        if ($iframe.length > 0) {
          var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
          if (win)
            closeForm(win.formModuleInstanceuuId, false);
        }
      }
    }

  });
}
window.closeLeftForms = function (e) {
  var tabpaneid = $(e.currentTarget).attr("tabpaneid");
  $("#g_tab_content>div.tab-pane").each(function () {
    if($(this).hasClass("menumap"))return;
    if ($(this).attr("id") != tabpaneid) {
      if ($(e.currentTarget).index() > $(this).index()) {
        var $iframe = $(this).find("iframe");
        if ($iframe.length > 0) {
          var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
          if (win)
            closeForm(win.formModuleInstanceuuId, false);
        }
      }
    }

  });
}

var globalStep = 0;

var tabpageContextMenuItems =
  [{ label: '关闭标签页', icon: '', action: closeCurrentForm }, { label: '关闭所有标签页', icon: '', action: closeAllForm }, { label: '关闭其它标签页', icon: '', action: closeOtherForm },
  { label: '关闭右侧标签页', icon: '', action: closeRightForms }, { label: '关闭左侧标签页', icon: '', action: closeLeftForms }];

window.testOpenForm = function (args) {
  //label,formId,menuItemId,onlyQuery,popUp,fixedUrl

  var _label_ = args.label; var _tid_ = args.formId; var _mid_ = args.menuItemId;
  var onlyQuery = args.onlyQuery; var popUp = args.popUp; var fixedUrl = args.fixedUrl;
  var _onlyQuery = onlyQuery == true ? true : false; var _fromMainMenu = args.fromMainMenu ? true : false;
  var _tidid_ = _tid_ + globalStep; globalStep++;
  if (args.manual) {
    var menuItem = args.menuItem;
    var htmlName = GOTUtil.getPropertyValue(menuItem, "RefObject") || GOTUtil.getPropertyValue(menuItem, "Source");
    if (htmlName) {
      fixedUrl = "html/" + htmlName + "/" + htmlName + ".html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu;
    }
  }

  /*if(popUp)
  {
    var modalDiv = $("<div>").addClass("modal").css("display","block").css("top","50px").css("z-index","900");
    var iframe = $("<iframe>").css("width","100%").css("height","100%").css("border","none").attr("id","iframe"+_tidid_);
    if(!fixedUrl)
        {iframe.attr("src","form.html?menuItemId="+_mid_+"&formId="+_tid_+"&popUp=true&onlyQuery="+_onlyQuery);}
    else
        {iframe.attr("src",fixedUrl);iframe.attr("id","iframe"+_mid_);setToolBar(clearToolbarObject);}
    $("#formModal").append(modalDiv.append(iframe));
    return;
  }*/
  // 万能视图设计器 预览form
  if (popUp && args.isDataSetPreview) {
    var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "2000").css("align-items", "center").css("justify-content", "center");
    if (window.userSettingEntry && window.userSettingEntry.hideToolBar == true) {
      modalDiv.css("top", "28px")
    }
    //if(ugse.hideToolBar == true)
    //  ugse.innerToolBar = true;
    var iframe = $("<iframe>").css("border", "none").attr("id", "iframe" + _tidid_).css("width", "100%").css("height", "100%").css("background-color","transparent");
    if (!fixedUrl) { iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&popUp=true&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu); }
    else { iframe.attr("src", fixedUrl); iframe.attr("id", "iframe" + _mid_); setToolBar(clearToolbarObject); }
    $("#formModal").append(modalDiv.append(iframe));
    return;
  }
  if (popUp && args.datasetSeting) {
    var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("top", "50px").css("z-index", "1051").css("align-items", "center").css("justify-content", "center");
    if (window.userSettingEntry && window.userSettingEntry.hideToolBar == true) {
      modalDiv.css("top", "28px")
    }
    //if(ugse.hideToolBar == true)
    //  ugse.innerToolBar = true;
    var iframe = $("<iframe>").css("border", "none").attr("id", "iframe" + _tidid_).css("width", "100%").css("height", "100%");
    if (!fixedUrl) { iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&popUp=true&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu); }
    else { iframe.attr("src", fixedUrl); iframe.attr("id", "iframe" + _mid_); setToolBar(clearToolbarObject); }
    $("#formModal").append(modalDiv.append(iframe));
    return;
  }


  if (popUp) {
    var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("top", "50px").css("z-index", "900").css("align-items", "center").css("justify-content", "center");
    if (window.userSettingEntry && window.userSettingEntry.hideToolBar == true) {
      modalDiv.css("top", "28px")
    }
    //if(ugse.hideToolBar == true)
    //  ugse.innerToolBar = true;
    var iframe = $("<iframe>").css("border", "none").attr("id", "iframe" + _tidid_).css("width", "100%").css("height", "100%");
    if (!fixedUrl) { iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&popUp=true&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu); }
    else { iframe.attr("src", fixedUrl); iframe.attr("id", "iframe" + _mid_); setToolBar(clearToolbarObject); }
    $("#formModal").append(modalDiv.append(iframe));
    return;
  }






  if (window.openAlreadyExsistMenu == true) {
    let has = false;
    $("#g_tab_content .tab-pane iframe").each(
      function () {
        var iframeSrc = this.src;
        if (iframeSrc.indexOf(urlBase) != 0 && iframeSrc.indexOf("http://127.0.0.1:8000") != 0) {
          return true;
        }
        if (this.contentWindow.menuItemId == _mid_) {
          $("#g_nav_tabs>li.active").each(function () {
            $(this).removeClass("active");
            var origtabpaneid = $(this).attr("tabpaneid")
            $("#" + origtabpaneid).removeClass("active");
          });

          $(this).parent().addClass("active");
          var _tabpaneid = $(this).parent().attr("id");
          $("#g_nav_tabs>li").each(function () {
            if ($(this).attr("tabpaneid") == _tabpaneid) {
              $(this).addClass("active");
              return false;
            }
          });
          try {
            if (typeof (this.contentWindow.switchToCurrent) == 'function'){
              this.contentWindow.switchToCurrent();
              if(window.openAlreadyExsistMenuReload){
                this.contentWindow.location.reload();
              }
            }

          }
          catch (ee) {
            //第三方跨域系统页面切换
            setToolBar(clearToolbarObject);
          }
          has = true;
          return false;
        }
      }
    );
    if (has == true) {
      return;
    }
  }
  // <li class="active"><a href="#tab_1" data-toggle="tab" aria-expanded="true" style="padding:5px 15px;">Tab 1</a>
  //  <i class="fa fa-close" style="position: absolute;top: 1px;right: 3px;"></i>
  //  </li>
  //var origtabpaneid;var origtabliactive;
  $("#g_nav_tabs>li.active").each(function () {
    /*if($(this).hasClass("active"))
    {
      origtabliactive = this;
      origtabpaneid = $(this).attr("tabpaneid");
      return false;
    }*/
    window.previousGlobalTabPageId = $(this).attr("tabpaneid");
    $(this).removeClass("active");
    var origtabpaneid = $(this).attr("tabpaneid")
    //$("#"+origtabpaneid).removeClass("active");
    var origtabpaneElement = document.getElementById(origtabpaneid);
    $(origtabpaneElement).removeClass("active");
  });
  //var dotChangeReg = new RegExp("\.","g");
  var tidid_changed = _tidid_ ? _tidid_.replace(/\./g, "_") : "";
  var mid_changed = _mid_ ? _mid_.replace(/\./g, "_") : "";
  var li = $("<li>").addClass("active").attr("tabpaneid", (!fixedUrl ? tidid_changed : mid_changed)).contextPopup({ items: tabpageContextMenuItems });
  var a = $("<a>").attr("href", "#" + (!fixedUrl ? tidid_changed : mid_changed)).attr("data-toggle", "tab").attr("aria-expanded", "true").addClass("gongqi_tabpage").html(_label_);
  var i = $("<i>").addClass("fa fa-close").css({ position: "absolute", top: "1px", right: "3px" });
  li.append(a).append(i);
  var childrenArray =   $("#g_nav_tabs").children().toArray();
  var targetIndex = childrenArray.length - 1 - 1; // 最后第二个位置的索引
  var targetElement = childrenArray[targetIndex];
  $(targetElement).after(li);


  var gnavtab = $("#g_nav_tabs");
  var leftDiff = li.offset().left - gnavtab.width();
  if (leftDiff > 0) {
    gnavtab.scrollLeft(gnavtab.scrollLeft() + leftDiff + li.width());
  }

  /*li.on('dragstart',function(e){
    var data=e.originalEvent.dataTransfer;
    data.setData('text/plain',$(this).index());
  });

  li.on('dragover',function(e){
    e.originalEvent.preventDefault();
  });
  li.on('dragend',function(e){
    e.originalEvent.preventDefault();
  });
  li.on('drop',function(e){
    var origIndex=e.originalEvent.dataTransfer.getData('text/plain');
    var nowIndex = $(this).index();
    var parent = $(this).parent();
    if(nowIndex+"" == origIndex+"")
      return;
    if(((nowIndex-1)+"") == origIndex+"")
      return;
    var origJqueryEle = $($("#g_nav_tabs > li")[origIndex]);
    var nowJqueryEle = $($("#g_nav_tabs > li")[nowIndex]);
    origJqueryEle.insertBefore(nowJqueryEle);
  });*/


  /*
  <div class="tab-content" style="width:100%;height:100%;overflow:hidden" id="g_tab_content">
          <div class="tab-pane active" id="tab_1" style="width:100%;height:100%">
      <iframe style="width:100%;height:100%;padding-bottom:30px;" src="testInlineblock.html">
      </iframe>
          </div>
  */
  var divtabpane = $("<div>").addClass("tab-pane active").css({ width: "100%", height: "100%" }).attr("id", tidid_changed);
  var iframe = $("<iframe>").css("width", "100%").css("height", "100%").css("border", "none").attr("id", "iframe" + _tidid_);
  if (!fixedUrl) { iframe.attr("src", "form.html?menuItemId=" + _mid_ + "&formId=" + _tid_ + "&onlyQuery=" + _onlyQuery + "&fromMainMenu=" + _fromMainMenu); }
  else { iframe.attr("src", fixedUrl); iframe.attr("id", "iframe" + _mid_); divtabpane.attr("id", _mid_); setToolBar(clearToolbarObject); }

  /*li.on('click',function(e){
    var tabpaneId = a.attr("href");
    var preActiveLi = $("#g_nav_tabs>li.active");
    preActiveLi.removeClass("active");
    $(this).addClass("active");
    var activepane = $("#g_tab_content>"+tabpaneId);
    $("#g_tab_content>.tab-pane.active").removeClass("active");
    activepane.addClass("active");

    var win = iframe.get(0).window || iframe.get(0).contentWindow;
    window.previousGlobalTabPageId = preActiveLi.attr("tabpaneid");
    try
    {
      if(typeof(win.switchToCurrent) == 'function')
        win.switchToCurrent();
    }
    catch(ee)
    {
      //第三方跨域系统页面切换
      setToolBar(clearToolbarObject);
    }

  });*/

  a.on("shown.bs.tab", function (e) {

    var win = iframe.get(0).window || iframe.get(0).contentWindow;
    // 获取已激活的标签页的名称
    var activeTab = $(e.target);
    // 获取前一个激活的标签页的名称
    var previousTab = $(e.relatedTarget).text();
    window.previousGlobalTabPageId = $(e.relatedTarget).parent().attr("tabpaneid");
    try {
      if (typeof (win.switchToCurrent) == 'function')
        win.switchToCurrent();
    }
    catch (ee) {
      //第三方跨域系统页面切换
      setToolBar(clearToolbarObject);
    }

  });

  $("#g_tab_content").append(divtabpane.append(iframe));
  i.click(function () {
    var iframeSrc = iframe[0].src;
    let _formId; let _menuItemId; let _formName;
    /*if(iframeSrc.indexOf(urlBase)!=0 && iframeSrc.indexOf(urlBase) != 0)
    {
      divtabpane.remove();
      li.remove();
      return;
    }*/
    //非跨域或者开发环境下 判断是否可关闭
    if (iframeSrc.indexOf(urlBase) == 0 || iframeSrc.indexOf("http://127.0.0.1:8000") == 0) {
      var _contentWindow = iframe[0].contentWindow;

      //_contentWindow.beforeClose();

      _formId = _contentWindow.formId;
      _menuItemId = _contentWindow.menuItemId;
      if (_contentWindow.formModuleInstance) {
        _formName = _contentWindow.formModuleInstance.formName;
        //if(_contentWindow.isFormOpening == true)
        //  return;
        var _result = typeof (_contentWindow.allowClose) == "function" ? _contentWindow.allowClose() : null;
        if (_result && !_result.allow) {
          if (_result.text)
            Warning.show({
              confirm: _result.noContinue ? {} : {
                isShow: true, text: "继续关闭", event: function () {

                  if (li.hasClass("active")) {
                    var arr = $("#g_tab_content>div.tab-pane");

                    var nextIndexTemp = -1;
                    if (window.previousGlobalTabPageId) {
                      var pagearrTemp = $("#g_nav_tabs>li");
                      for (let i = 0; i < pagearrTemp.length; i++) {
                        let pageTemp = pagearrTemp[i];
                        if ($(pageTemp).attr("tabpaneid") == window.previousGlobalTabPageId) {
                          nextIndexTemp = i;
                          break;
                        }
                      }
                    }

                    var nextIndex = nextIndexTemp;
                    var childIndex = divtabpane.index();
                    if (nextIndex == -1 || nextIndex == childIndex) {
                      if (childIndex - 1 < 0) {
                        if (childIndex + 1 < arr.length)
                          nextIndex = childIndex + 1;
                      }
                      else {
                        nextIndex = childIndex - 1;
                      }
                    }

                    var pagearr = $("#g_nav_tabs>li");
                    var nextpage = pagearr[nextIndex];
                    $(nextpage).addClass("active");
                    $(arr[nextIndex]).addClass("active");
                    var nextIframe = $(arr[nextIndex]).find("iframe");
                    try {
                      if (nextIframe.length != 0) {
                        var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
                        $("#ActiveRecordCount").text("");
                        if (typeof (win.closeToCurrent) == 'function')
                          win.closeToCurrent();
                      }
                      else {
                        setToolBar(clearToolbarObject);
                        $("#ActiveRecordCount").text("");
                      }
                    }
                    catch (ee) {
                      setToolBar(clearToolbarObject);
                    }
                  }
                  window.destroyIframe(divtabpane.find("iframe").get(0));
                  divtabpane.remove();
                  li.remove();

                  var mi = FormResourceUtil.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
                  if (mi) {
                    if (mi.prefetch == true) {
                      if (mi.commandResult) {
                        CommandResolver.resolve(mi.commandResult.tasks, null);
                      }
                    }
                    else {
                      var arg = new CommandArg();
                      var command = CommandHelper.createFormInstance(_formName, "doFormClosed", "void");
                      command.appendArg(arg, "CommandArg");

                      ServiceHelper.addTokenWithCommand({
                        command: command,
                        resultFunction: function (result) {
                          if (result.result && result.result.tasks && result.result.tasks.length > 0)
                            CommandResolver.resolve(result.result.tasks, null);
                        }
                      });
                    }
                  }

                  if ($("#g_nav_tabs>li").length < 1)
                    $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
                }
              }, cancel: { isShow: true }, text: _result.text
            });
          return;
        }
      }
    }

    if (li.hasClass("active")) {
      var arr = $("#g_tab_content>div.tab-pane");
      var nextIndexTemp = -1;
      if (window.previousGlobalTabPageId) {
        var pagearrTemp = $("#g_nav_tabs>li");
        for (let i = 0; i < pagearrTemp.length; i++) {
          let pageTemp = pagearrTemp[i];
          if ($(pageTemp).attr("tabpaneid") == window.previousGlobalTabPageId) {
            nextIndexTemp = i;
            break;
          }
        }
      }

      var nextIndex = nextIndexTemp;
      var childIndex = divtabpane.index();
      if (nextIndex == -1 || nextIndex == childIndex) {
        if (childIndex - 1 < 0) {
          if (childIndex + 1 < arr.length)
            nextIndex = childIndex + 1;
        }
        else {
          nextIndex = childIndex - 1;
        }
      }

      var pagearr = $("#g_nav_tabs>li");
      var nextpage = pagearr[nextIndex];
      $(nextpage).addClass("active");

      var nextIframe = $(arr[nextIndex]).find("iframe");
      let cont=nextIndex;
      if(nextIframe[0] && nextpage.getAttribute('tabpaneid') && nextIframe[0].id !=nextpage.getAttribute('tabpaneid')){
        for(let i =0;i<arr.length;i++){
          if( $(arr[i]).find("iframe")[0]&& $(arr[i]).find("iframe")[0].id=="iframe"+nextpage.getAttribute('tabpaneid')){
            nextIframe =  $(arr[i]).find("iframe");
            cont = i;
          }
        }
      } 
      $(arr[cont]).addClass("active");
      try {
        if (nextIframe.length != 0) {
          var win = nextIframe.get(0).window || nextIframe.get(0).contentWindow;
          $("#ActiveRecordCount").text("");
          if (typeof (win.closeToCurrent) == 'function')
            win.closeToCurrent();
        }
        else {
          setToolBar(clearToolbarObject);
          $("#ActiveRecordCount").text("");
        }
      }
      catch (ee) {
        setToolBar(clearToolbarObject);
        $("#ActiveRecordCount").text("");
      }
    }

    window.destroyIframe(divtabpane.find("iframe").get(0));

    divtabpane.remove();
    li.remove();

    if (_formId && _menuItemId && _formName) {
      var mi = FormResourceUtil.getCommandArgMethodInfo("formClosed", _menuItemId, _formId);
      if (mi) {
        if (mi.prefetch == true) {
          if (mi.commandResult) {
            CommandResolver.resolve(mi.commandResult.tasks, null);
          }
        }
        else {
          var arg = new CommandArg();
          var command = CommandHelper.createFormInstance(_formName, "doFormClosed", "void");
          command.appendArg(arg, "CommandArg");

          ServiceHelper.addTokenWithCommand({
            command: command,
            resultFunction: function (result) {
              if (result.result && result.result.tasks && result.result.tasks.length > 0)
                CommandResolver.resolve(result.result.tasks, null);
            }
          });
        }
      }
    }

    if ($("#g_nav_tabs>li").length < 1)
      $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;");
  });

  //$(origtabliactive).removeClass("active");
  //$("#"+origtabpaneid).removeClass("active");
  $("#g_tab_content").css("cssText", "width:100%;height:100%;overflow:hidden;flex-grow:100;background-size:0px!important");
}

window.destroyIframe = function (iframe) {
  //把iframe指向空白页面，这样可以释放大部分内存。
  //第三方页面的内存则无法释放
  iframe.src = null;//'about:blank';
  try {
    $(iframe.contentWindow.document).unbind().die();    //remove listeners on document
    $(iframe.contentWindow.document).find('*').unbind().die(); //remove listeners on all nodes
    iframe.contentWindow.document.write('');
    iframe.contentWindow.document.clear();
    iframe.contentWindow.location.reload();
    iframe.contentWindow.close();
    $(iframe).empty();
  } catch (e) { }
  //把iframe从页面移除
  iframe.parentNode.removeChild(iframe);
}


var clearToolbarObject = { MainMenu: false, Print: false, Export: false, Da: false, Attachment: false, WorkFlowDetail: false, QueryOpen: false, QueryRemove: false, FindOpen: false, CursorPrev: false, CursorNext: false, RecordNew: false, RecordSave: false, EditModeChange: false, RecordRestore: false, RecordDelete: false };


window.setToolBar = function (obj) {
  if(!obj)return;
  window.lastToolBarObject = obj;
  /*obj.MainMenu == true ? 
    $("#toolbar_mainMenu").attr("onclick", "mainMenu(event)").attr("en", "true").find("i").css("color", "#FFFFFF") : 
    $("#toolbar_mainMenu").removeAttr("onclick").removeAttr("en").find("i").css("color", "#3782BB");*/
  obj.MainMenu == true ?
    $("#toolbar_mainMenu").attr("onclick", "mainMenu(event)").attr("en", "true").removeClass("disable").addClass("enable"):
    $("#toolbar_mainMenu").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

  // $("#toolbar_print").attr("onclick", "print(event)").attr("en", "true").find("i").css("color", "#1D85ED") ;

 // obj.Export == true ? $("#toolbar_export").attr("onclick", "toobarFunc(event,'groupExport','')").attr("en", "true").find("i").css("color", "#1D85ED") : $("#toolbar_export").removeAttr("onclick").removeAttr("en").find("i").css("color", "#c2c2c2");

//  obj.Export == true ? 
//     $("#toolbar_export").attr("onclick", "toobarFunc(event,'groupExport','')").attr("en", "true").removeClass("disable").addClass("enable"):
//     $("#toolbar_export").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

obj.Export == true ? 
    $("#toolbar_export").attr("en", "true").removeClass("disable").addClass("enable"):
    $("#toolbar_export").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
 
    if(!obj.Export){
      $("#toolbar_export  .icon-container").addClass("disable");
      $("#toolbar_export  .menubtnLable").addClass("disable");
    }else{
      $("#toolbar_export .icon-container").removeClass("disable");
      $("#toolbar_export  .menubtnLable").removeClass("disable");
    }
 //obj.Da == true ? $("#toolbar_Da").attr("onclick", "toobarFunc(event,'da','')").attr("en", "true").find("i").css("color", "#1D85ED") : $("#FFFFFF").removeAttr("onclick").removeAttr("en").find("i").css("color", "#c2c2c2");

//  obj.Da == true ?
//     $("#toolbar_Da").attr("onclick", "toobarFunc(event,'da','')").attr("en", "true").removeClass("disable").addClass("enable"):
//     $("#toolbar_Da").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
 obj.Da == true ?
    $("#toolbar_Da").attr("en", "true").removeClass("disable").addClass("enable"):
    $("#toolbar_Da").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

    if(!obj.Da){
      $("#toolbar_Da  .icon-container").addClass("disable");
      $("#toolbar_Da  .menubtnLable").addClass("disable");
    }else{
      $("#toolbar_Da .icon-container").removeClass("disable");
      $("#toolbar_Da  .menubtnLable").removeClass("disable");
    }

  if (obj.Attachment == true) {
    $("#toolbar_Attchment").attr("en", "true").removeClass("disable").addClass("enable"); 
    // $("#attachmentNum").show();
    // $("#attachmentNum2").show();
  }
  else {
    $("#toolbar_Attchment").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
    $("#attachmentNum").hide();
    $("#attachmentNum2").hide();
  }
  if (obj.Attachment == true) {
    $("#toolbar_Attchment").removeClass("disable");
    $("#toolbar_Attchment .icon-container").removeClass("disable");
    $("#toolbar_Attchment  .menubtnLable").removeClass("disable");
  }
  else {
    $("#toolbar_Attchment").addClass("disable");
    $("#toolbar_Attchment  .icon-container").addClass("disable");
    $("#toolbar_Attchment  .menubtnLable").addClass("disable");
  }

  //obj.WorkFlowDetail == true ? $("#toolbar_Workflow").attr("onclick", "toobarFunc(event,'workFlow','')").attr("en", "true").find("i").css("color", "#1D85ED") : $("#toolbar_Workflow").removeAttr("onclick").removeAttr("en").find("i").css("color", "#c2c2c2");
  obj.WorkFlowDetail == true ?
    $("#toolbar_Workflow").attr("onclick", "toobarFunc(event,'workFlow','')").attr("en", "true").removeClass("disable").addClass("enable"):
    $("#toolbar_Workflow").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

  // obj.QueryOpen == true ? 
  //   $("#toolbar_Queryopen").attr("onclick", "toobarFunc(event,'queryOpen','')").attr("en", "true").removeClass("disable").addClass("enable") : 
  //   $("#toolbar_Queryopen").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
    obj.QueryOpen == true ? 
    $("#toolbar_Queryopen").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_Queryopen").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

    if(!obj.QueryOpen){
      $("#toolbar_Queryopen  .icon-container").addClass("disable");
      $("#toolbar_Queryopen  .menubtnLable").addClass("disable");
    }else{
      $("#toolbar_Queryopen .icon-container").removeClass("disable");
      $("#toolbar_Queryopen  .menubtnLable").removeClass("disable");
    }


  obj.QueryRemove == true ? 
    $("#toolbar_queryRemove").attr("onclick", "toobarFunc(event,'queryRemove','')").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_queryRemove").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

  if(!obj.QueryRemove){
    $("#toolbar_queryRemove  .icon-container").addClass("disable");
    $("#toolbar_queryRemove  .menubtnLable").addClass("disable");
  }else{
    $("#toolbar_queryRemove .icon-container").removeClass("disable");
    $("#toolbar_queryRemove  .menubtnLable").removeClass("disable");
  }
  obj.FindOpen == true ? 
    $("#toolbar_find").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_find").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

    if(!obj.FindOpen){
      $("#toolbar_find  .icon-container").addClass("disable");
      $("#toolbar_find  .menubtnLable").addClass("disable");
    }else{
      $("#toolbar_find .icon-container").removeClass("disable");
      $("#toolbar_find  .menubtnLable").removeClass("disable");
    }
  obj.CursorPrev == true ? 
    $("#toolbar_recordPrev").attr("onclick", "toobarFunc(event,'recordPrev','')").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_recordPrev").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

  obj.CursorNext == true ? 
    $("#toolbar_recordNext").attr("onclick", "toobarFunc(event,'recordNext','')(event)").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_recordNext").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

  obj.RecordNew == true ? 
    $("#toolbar_recordNew").attr("onclick", "toobarFunc(event,'recordNew','')").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_recordNew").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

    if(!obj.RecordNew){
      $("#toolbar_recordNew  .icon-container").addClass("disable");
      $("#toolbar_recordNew  .menubtnLable").addClass("disable");
      $("#toolbar_recordNew  .menubtnCut").addClass("disable");
    }else{
      $("#toolbar_recordNew .icon-container").removeClass("disable");
      $("#toolbar_recordNew  .menubtnLable").removeClass("disable");
      $("#toolbar_recordNew  .menubtnCut").removeClass("disable");
    }
  obj.RecordSave == true ? 
    $("#toolbar_save").attr("onclick", "toobarFunc(event,'recordSave','')").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_save").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

    if(!obj.RecordSave){
      $("#toolbar_save  .icon-container").addClass("disable");
      $("#toolbar_save  .menubtnLable").addClass("disable");
      $("#toolbar_save  .menubtnCut").addClass("disable");
    }else{
      $("#toolbar_save .icon-container").removeClass("disable");
      $("#toolbar_save  .menubtnLable").removeClass("disable");
      $("#toolbar_save  .menubtnCut").removeClass("disable");
    }
  obj.EditModeChange == true ? 
    $("#toolbar_switchEditMode").attr("onclick", "toobarFunc(event,'switchEditMode','')").attr("en", "true").removeClass("disable").addClass("enable") :
    $("#toolbar_switchEditMode").removeAttr("onlick").removeAttr("en").removeClass("enable").addClass("disable");

  obj.RecordRestore == true ? 
    $("#toolbar_recordRestore").attr("onclick", "toobarFunc(event,'recordRestore','')").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_recordRestore").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");

    if(!obj.RecordRestore){
      $("#toolbar_recordRestore  .icon-container").addClass("disable");
      $("#toolbar_recordRestore  .menubtnLable").addClass("disable");
      $("#toolbar_recordRestore  .menubtnCut").addClass("disable");
    }else{
      $("#toolbar_recordRestore .icon-container").removeClass("disable");
      $("#toolbar_recordRestore  .menubtnLable").removeClass("disable");
      $("#toolbar_recordRestore  .menubtnCut").removeClass("disable");
    }



  obj.RecordDelete == true ? 
    $("#toolbar_recordDelete").attr("onclick", "toobarFunc(event,'recordDelete','')").attr("en", "true").removeClass("disable").addClass("enable") : 
    $("#toolbar_recordDelete").removeAttr("onclick").removeAttr("en").removeClass("enable").addClass("disable");
    if(!obj.RecordDelete){
      $("#toolbar_recordDelete  .icon-container").addClass("disable");
      $("#toolbar_recordDelete  .menubtnLable").addClass("disable");
      $("#toolbar_recordDelete  .menubtnCut").addClass("disable");
    }else{
      $("#toolbar_recordDelete .icon-container").removeClass("disable");
      $("#toolbar_recordDelete  .menubtnLable").removeClass("disable");
      $("#toolbar_recordDelete  .menubtnCut").removeClass("disable");
    }
}


window.replaceBaseUrl = function (url) {
  //urlBase.substring(0,urlBase.lastIndexOf("/"))+url.substr(9);
  let domain = window.didomain;
  if (domain) {
    url = url.replace("GongqiERP", "GongqiERP/" + domain);

  }
  return urlBase + url.substr(9);
}

window.getLoginMode = function () {
  var reg = new RegExp("(^|&)" + "loginMode" + "=([^&]*)(&|$)", "i");
  var r = window.location.search.substr(1).match(reg);
  if (r != null)
    return unescape(r[2]);
  else
    return null;
}

window.shoLogoArea = function (imageBack) {
  // if (window.logo_Mode == "text") {
  //   $("#g_title_area .logo-lg>b").html(logo_Text).css("color", imageBack == 2 ? "#fff" : "#000");

  // }
  // else if (window.logo_Mode == "image") {
  //   if (imageBack == 2)
  //     $("#g_title_area").css({
  //       'background-image': 'url(customdev/images/' + logo_Image_BackBlue + ')',
  //       'background-repeat': 'no-repeat', 'background-position': 'center'
  //     });
  //   else
  //     $("#g_title_area").css({
  //       'background-image': 'url(customdev/images/' + logo_Image_BackWhite + ')',
  //       'background-repeat': 'no-repeat', 'background-position': 'center'
  //     });
  // }
}

window.initUGS = function (ugse) {
  if (ugse) {
    //ugse.showLeftListMenu = true;
    //Object.assign({remoteClass:"gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity"},window.userSettingEntry);
    window.userSettingEntryOrig = Object.assign({ remoteClass: "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity" }, ugse);
    if (window.userSettingEntryOrig.menuCustomObject) {
      if (typeof (window.userSettingEntryOrig.menuCustomObject) == "string") {
        try {
          window.userSettingEntryOrig.menuCustomObject = JSON.parse(window.userSettingEntryOrig.menuCustomObject);
        }
        catch (e) {
          //TODO 在删除自定义菜单中全部常用及分组后 保存 后台传回的字符串不是有效JSON
          window.userSettingEntryOrig.menuCustomObject = null;
        }

      }
    }
    window.userSettingEntry = ugse;
    if (ugse.hideToolBar == true)
      ugse.innerToolBar = true;
    ugse.showBottomSum = true;

    if (window.userSettingEntry.showLeftMenu == true && window.userSettingEntry.showLeftListMenu == true)
      window.userSettingEntry.showLeftMenu = false;
    else if (!window.userSettingEntry.showLeftMenu && !window.userSettingEntry.showLeftListMenu && !window.userSettingEntry.showToolMenu){
      $("#g_nav_tabs").css('margin-left','0px');
      $("#g_nav_tab_close").css('display','none');
      var content_Wrapper = document.getElementById("contentWrapper");
      content_Wrapper.className += ' NoMune_content';
    }
      // window.userSettingEntry.showLeftListMenu = true;
    /*window.userSettingEntry.showLeftListMenu = true;
    window.userSettingEntry.showLeftMenu = false;
    window.userSettingEntry.showToolMenu = true;*/

  }
  else {
    window.userSettingEntry = {
      autoEnterList: false,
      //clickEnterList:false,
      //flickerTime:800,
      isAutoSavePrompt: false,
      isDelPrompt: true,
      isEditMode: true,
      isEditModeHelp: true,
      isRecSavePrompt: false, isReportBrowser: true, isShowBusyRemote: true,
      showOprInfo: false, downNewRec: false, showLeftMenu: true, showToolMenu: false,
      innerToolBar: false, hideToolBar: false, showBottomSum: false
    };

    window.userSettingEntryOrig = Object.assign({ remoteClass: "gongqi.erp.gotmodel.userset.global.UserGlobalSetEntity" }, window.userSettingEntry);
  }

  /*全屏设置的优先级高于用户自定义设置 一旦全屏 菜单的设置将无意义*/
  if (window.autoFullScreen) {
    window.userSettingEntry.showLeftMenu = false;
    window.userSettingEntry.showLeftListMenu = false;
    window.userSettingEntry.showToolMenu = false;
  }

  $("#g_nav_tabs").addClass("g_nav_tabs_background");//css("background","#CAD7E3");
  $("#toolBarMainMenuToggleA>button").show();
  //window.userSettingEntry.hideToolBar = true;
  if (window.userSettingEntry.hideToolBar == true) {
    $(".main-header").css("display", "none");
    $(".content-wrapper").css("padding-top", "0px");
    $('.main-sidebar').css('padding-top', '0px');
  }
  else {
    if (window.userSettingEntry.showLeftListMenu == true) {
      $(".main-header").css("display", "block");
      // $(".navbar-static-top").css("border-bottom", "1px solid rgba(151,151,151,0.5)");
    }
    else {
      $(".main-header").css("display", "block")//.css("border-bottom", "1px solid rgba(151,151,151,0.5)");
    }

    $(".content-wrapper").css("padding-top", "");
    $(".main-sidebar").css("padding-top", '');
  }

  if (window.userSettingEntry.showLeftMenu == false) {
    $(".main-sidebar").css("display", "none");
    $(".content-wrapper").css("margin-left", '0px');
    $(".main-footer").css("margin-left", '0px');
    $(".content-wrapper").css("padding-top", '80px');
    $("#g_nav_tab_close").css("left",'161px');
    if(window.userSettingEntry.showLeftListMenu == true){
      var wrappers = document.getElementsByClassName("wrapper");
      var wrapper = wrappers[0];
      wrapper.className += ' listMune_weapper';
      var content_Wrapper = document.getElementById("contentWrapper");
      content_Wrapper.className += ' listMune_content';
    }
  }
  else {
    $(".main-sidebar").css("display", "block");
    $(".content-wrapper").css("margin-left", '200px');
    $(".main-footer").css("margin-left", '200px');
    $("#g_nav_tab_close").css("left",'201px');
    $(".content-wrapper").css("padding-top", '42px');
    var content_Wrapper = document.getElementById("contentWrapper");
    content_Wrapper.className += ' treeMune_content';
    var wrappers = document.getElementsByClassName("wrapper");
    var wrapper = wrappers[0];
    wrapper.className += ' treeMune_wrapper';
  }

  if (window.userSettingEntry.showLeftListMenu == true) {
    let htmlStyleAttr = $('html').attr('style');
    if (htmlStyleAttr)
      $('html').attr('style', htmlStyleAttr.replace('height: auto;', ''));
    let bodyStyleAttr = $('body').attr('style');
    if (bodyStyleAttr)
      $('body').attr('style', bodyStyleAttr.replace('height: auto;', ''));
    let _wrapperAttr = $("body>div.wrapper").attr('style');
    if (!_wrapperAttr) _wrapperAttr = "";
    $("body>div.wrapper").addClass("listtree-sidebar-wrapper").attr('style', _wrapperAttr.replace('height: auto;', ''));;
    $(".listtree-sidebar").css("display", "block");

    $(".content-wrapper").css("margin-left", '160px').css("padding-top", '0px');

    if (window.userSettingEntry.showToolMenu == true) {
      $("#listMainMenu").css("margin-left", '100px'); $('.navbar-static-top').css('margin-left', '100px');
      $('.logo-minihide').css({ width: '100px', position: 'absolute', top: '-30px', height: '30px', 'background-color': '#0078D4' });
      $('.logo-minihide>.logo-lg').css({ height: '30px', 'line-height': '30px' });
      $('.logo-minihide>.logo-lg>b').css('color', '#fff');
    }
    else {
      $("#listMainMenu").css("margin-left", '100px'); $('.navbar-static-top').css('margin-left', '100px');
      $('.logo-minihide').css({ width: '160px', position: 'absolute', height: '42px' });
      $('.logo-minihide>.logo-lg>b').css('color', '#fff');
    }


    if (window.userSettingEntry.hideToolBar == true && window.userSettingEntry.showToolMenu == false) {
      $(".listtree-sidebar").css("top", "0px");
      $('.content-wrapper').css('top', '0px');
    }
    else if (window.userSettingEntry.hideToolBar == true && window.userSettingEntry.showToolMenu == true) {
      $(".listtree-sidebar").css("top", "30px");
      $('.content-wrapper').css('top', '30px');
    }
    else if (window.userSettingEntry.hideToolBar == false && window.userSettingEntry.showToolMenu == true) {
      $(".listtree-sidebar").css("top", "80px");
      $('.content-wrapper').css('top', '80px');
    }
    else if (window.userSettingEntry.hideToolBar == false && window.userSettingEntry.showToolMenu == false) {
      $(".listtree-sidebar").css("top", "42px");
      $('.content-wrapper').css('top', '42px');
    }
    $(".main-footer").css("margin-left", '160px');
    /*$(".slimScrollDiv").css("overflow",'').on('mousewheel',
      function(e)
      {
        $(".sidebar").css("overflow",'hidden');$(".slimScrollDiv").css("overflow",'hidden');
        //alert(223);
      }
    );
    $(".sidebar").css("overflow",'');

    var timer;
    var mainMenu_sidebar = document.getElementById("mainMenu_sidebar");
    mainMenu_sidebar.onscroll = function(e2)
    {
      clearTimeout(timer);
      //alert("onscroll");
      //$(".sidebar").css("overflow",'hidden');$(".slimScrollDiv").css("overflow",'hidden');
      var t1 = mainMenu_sidebar.scrollTop;
      timer = setTimeout(function(e3){

        var t2 = mainMenu_sidebar.scrollTop;
        if(t2 === t1)
        {
          $(".sidebar").css("overflow",'');
          $(".slimScrollDiv").css("overflow",'');
          mainMenu_sidebar.scrollTop = t2;
        }
      }, 500);
    }*/

    /*$(".main-sidebar").css({display:"block",width:"80px"}).find(".sidebar-form").css({display:"none"});
    $(".content-wrapper").css("margin-left",'80px');
    $(".main-footer").css("margin-left",'80px');*/
  }

  if (window.userSettingEntry.showToolMenu == true) {
    //.$("#toolMenuControl").show();
    //$("#toolMenuControl").attr("href","javascript:listMainMenuState();").append($("<i class='fa fa-bars'></i>"));

    var content_Wrapper = document.getElementById("contentWrapper");
    content_Wrapper.className += ' hasToolMenuControl';
    var content_Wrapper = document.getElementById("mainFooterId");
    content_Wrapper.className += ' hasToolMenuFooter';

    
    let _caidanlan_;
    if (window.userSettingEntry.showLeftListMenu) {
      _caidanlan_ = $("<a title='菜单栏' id='toolMenuControl' href='javascript:listMainMenuState();' class='logo' style='font-size:12px;width: 160px;text-align: left;padding: 0 0 0 44px;background:rgb(53, 68, 93,0.95);'><i class='fa fa-bars' style='color:#474747'></i><i class='fa menuControl-i fa-long-arrow-up' style='color: #474747;'></i></a>");
      //$("#g_title_area").css("width", "100px").after(_caidanlan_);
    }
    else {
      _caidanlan_ = $("<a title='菜单栏' id='toolMenuControl' href='javascript:listMainMenuState();' class='logo' style='font-size:12px;width: 40px;text-align: left;padding: 0 0 0 3px;'><i class='fa fa-bars' style='color:#474747'></i><i class='fa menuControl-i fa-long-arrow-up' style='color: #474747;'></i></a>");
      //$("#g_title_area").css("width", "160px").after(_caidanlan_);
    }


    if (!window.userSettingEntry.hideToolBar) {
      $('.main-header').css('top', '30px');
      $('.main-sidebar').css('top', '30px');

      if (!window.userSettingEntry.showLeftListMenu)
        $('.content-wrapper').css('padding-top', '80px');

      $("#listMainMenu").addClass('listMainMenuShow').show();
      //$("#g_nav_tabs").addClass("listMainMenuShowUL").show();
      $("#g_nav_tabs").css('margin-left','0px');
      $("#g_nav_tab_close").css('display','none');
    }
    else {
      if (!window.userSettingEntry.showLeftListMenu)
        $('.content-wrapper').css('padding-top', '30px');

      $('.main-sidebar').css('top', '30px');
      $("#listMainMenu").addClass('listMainMenuShow').show();
      $("#g_nav_tabs").css('margin-left','0px');
      $("#g_nav_tab_close").css('display','none');
    }
  }
  if (window.autoFullScreen) {
    $(".main-header").css("display", 'none');
    $(".content-wrapper").css("padding-top", "0px");
    $('.main-sidebar').css('padding-top', '0px');
    $('#g_nav_tabs').css("display", 'none');
    $('.main-footer').css("display", 'none');
    $('#contentWrapper').addClass('autoFullScreenContent')
    try {
      $.AdminLTE.layout.fix();
    }
    catch (e) {

    }
  }

  if (window.userSettingEntry.showLeftListMenu == true) {
    if (window.userSettingEntry.showToolMenu == true) {
      shoLogoArea(2);
    }
    else {
      shoLogoArea(1);
    }
  }
  else {
    shoLogoArea(1);
  }

}

/**
   * 动态加载JS
   * @param {string} url 脚本地址
   * @param {function} callback  回调函数
   */
window.dynamicLoadJs = function (url, callback) {
  var head = document.getElementsByTagName('head')[0];
  var script = document.createElement('script');
  script.type = 'text/javascript';
  var newurl = url;
  script.src = newurl;
  if (typeof (callback) == 'function') {
    script.onload = script.onreadystatechange = function () {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        if (callback) callback();
        script.onload = script.onreadystatechange = null;
      }
    };
  }
  head.appendChild(script);
}

/**
   * 动态加载Css
   * @param {string} url 脚本地址
   * @param {function} callback  回调函数
*/
window.dynamicLoadCss = function (url, callback) {
  //<link rel="stylesheet" href="externals/styles/GongqiERP6.css"></link>
  var head = document.getElementsByTagName('head')[0];
  var _css_ = document.createElement('link');
  _css_.rel = "stylesheet";
  _css_.href = url;
  if (typeof (callback) == 'function') {
    script.onload = script.onreadystatechange = function () {
      if (!this.readyState || this.readyState === "loaded" || this.readyState === "complete") {
        if (callback) callback();
        script.onload = script.onreadystatechange = null;
      }
    };
  }
  head.appendChild(_css_);
}

window.getUserInfosHandler = function (data) {
  if (data.status != 0) {
    alert(data.msg);
    return;
  }
  data = data.result;
  //console.log(data);
  var userInfos = {};
  if (data != null) {

    userInfos.userId = data.userId;
    userInfos.userName = data.userName;
    userInfos.loginDate = new Date(data.loginDate);
    userInfos.loginTime = data.loginTime;
    userInfos.userSessionId = data.userSessionId;
    var propertyMap = data.propertyMap;
    if (propertyMap != null && propertyMap != undefined) {

      userInfos.canEnterMainform = propertyMap.allowEnterMainForm;
      userInfos.serverDebug = propertyMap.serverDebug;
    
      if (propertyMap.hasOwnProperty("clientCommandAfterLogin")) {
        var clientCommandAfterLogin = propertyMap["clientCommandAfterLogin"];
        userInfos.clientCommandAfterLoginResult = clientCommandAfterLogin;
      }
      // 框架版本返回
      if(propertyMap.hasOwnProperty("frameworkVersion")){
        var frameworkVersion = propertyMap["frameworkVersion"];
        window.frameworkVersion = frameworkVersion;
      }

      var list = data.userGroups;
      userInfos.userGroups = (list == null || list == undefined) ? [] : list;

      if (userInfos.userGroups.indexOf("admin") != -1 || userInfos.userGroups.indexOf("Admin") != -1) {
        userInfos.isAdmin = true;
      }

      var _loginMode = window.getLoginMode();
      if (_loginMode == "embed") {
        userInfos.toolBarInForm = true;
        userInfos.showStatusBar = false;
      }
      //
      window.userInfos = userInfos;
      if(window.formOSopenUniversal){
        $("#overallSituationDiv").css("height","1000px");
        $("#overallSituationDiv").css("z-index","1031");
        $("#overallSituationDiv").css("position","fixed");
        $("#overallSituationDiv").css("background-color","white");
        $("#overallSituationDiv").css("width","100%");
        if(window.formOSopenAllUniversal){
          setTimeout(function(){window.showUniversalView();},1500);
        }else{
          window.showUniversalView();
        }
      }
      //TODO 
      if(window.formOSopenDataSetView){
       $("#dataSetViewReportDiv").css("display",'block');
        setTimeout(function(){window.fromOSopenDataSetViewes();},1500);
      }
      //用户设置
      var ugse = propertyMap["userSettingProperties"];
      initUGS(ugse);

      userInfos.daoMaxListSize = propertyMap["daoMaxListSize"];


      //if(Version.CLIENT_VERSION  != propertyMap["frameworkVersion"])
      //  alert("当前使用的客户端版本与最新版本不一致，为保证正常使用，请清除浏览器缓存或与管理员联系");
      var license = propertyMap["license"];
      if (license != "" && license != null) {
        userInfos.licenseInfo = license;
      }

      //userInfos.messageURL = replaceBaseUrl(propertyMap["messageURL"]);
      userInfos.resourceURL = replaceBaseUrl(propertyMap["resourceURL"]);
      userInfos.serviceURL = replaceBaseUrl(propertyMap["serviceURL"]);

      userInfos.pivotURL = userInfos.serviceURL;
      userInfos.useHttps = false;
      userInfos.subSysId = propertyMap["Gongqi_ERP_Data_Area"];
      userInfos.subSystem = propertyMap["dataAreaLabel"];
      userInfos.licenseXML = propertyMap.license;
      userInfos.WILDCARD = propertyMap["queryWildcardCharacter"];
      //FormItemConst.WILDCARD = 

      $(document).attr('title', userInfos.subSystem);
      userInfos.userAus = {};
      let uAus = propertyMap.UserAuthoritys;
      if (uAus) {
        for (let i = 0; i < uAus.length; i++) {
          let o = uAus[i];
          let uAuKey = o.authorityMenuItemId + "." + o.authorityFormItemId;
          let node = userInfos.userAus[uAuKey];
          var type = o.authorityNodeType;
          var visible; var query; var exp; var edit; var save; var _new; var del;
          var isForbidden = true;
          visible = o.authorityType_Visible;
          if (o.authorityType_Visible && isForbidden) isForbidden = false;
          query = o.authorityType_Query;
          if (o.authorityType_Query && isForbidden) isForbidden = false;
          exp = o.authorityType_Export;
          if (o.authorityType_Export && isForbidden) isForbidden = false;
          edit = o.authorityType_Edit;
          if (o.authorityType_Edit && isForbidden) isForbidden = false;
          save = o.authorityType_Save;
          if (o.authorityType_Save && isForbidden) isForbidden = false;
          _new = o.authorityType_New;
          if (o.authorityType_New && isForbidden) isForbidden = false;
          del = o.authorityType_Delete;
          if (o.authorityType_Delete && isForbidden) isForbidden = false;
          if (node) {
            AuthorityUtil.setUniqueKey(node, visible, query, exp, edit, save, _new, del);
          }
          else {
            node = {}; node.type = type; node.key = uAuKey; node.visible = visible;
            node.query = query; node["exp"] = exp; node.edit = edit; node.save = save; node._new = _new; node.del = del; node.isForbidden = isForbidden;
            userInfos.userAus[uAuKey] = node;
          }
        }
      }

      var userMenuMap = propertyMap["businessMaps"];
      window.userMenuMap = "";
      if(userMenuMap  &&  !$.isEmptyObject(userMenuMap))
      {
        window.hasMenuMap = true;
        try{
          let appId = window.appId;
          if(userMenuMap[appId])window.userMenuMap = userMenuMap[appId];
        }catch(err){
           console.log(err)
        }
   
      }
      if (window.didomain && !loginToken && !loginDataArea){
         window.hasMenuMap = true;
      }

      if (window.didomain && !loginToken && !loginDataArea){
        
      }else{
       var forceChangePassword = propertyMap["ForceChangePassword"];
       if(forceChangePassword){
         window.showPasswordModal();
         $('#but_PasswordModalClose').css('display','none');
         $('#but_PasswordModalCancel').css('display','none');
       }
     }

    }
  }
  if(window.uselayersLevelesConfig != undefined && window.uselayersLevelesConfig == true){
    var layerLevelConfig = window.layerLevelConfig;
    for (let i = 0; i < layerLevelConfig.length; i++) 
    {
      let _layerName = layerLevelConfig[i].name;
      window.layerConfigs[_layerName] = {};
      //dynamicLoadJs(urlBase+"/layers/"+_layerName+"/"+_layerName+".js");
      let jsConfig = layerLevelConfig[i].js;
      if(typeof(jsConfig) == "boolean")
      {
        if (layerLevelConfig[i].js)
          dynamicLoadJs("layers/" + _layerName + "/" + _layerName + ".js");
      }
      else if(typeof(jsConfig) == "object")
      {
        for(let jsKey in jsConfig)
        {
          let jsName = jsKey;//jsConfig[jsKey];
          let jsPath = jsConfig[jsKey];
          //if(jsName == true)
          dynamicLoadJs("layers/" + _layerName + "/" + jsPath + jsName + ".js");
        }
      }
      
      
      if (layerLevelConfig[i].css && typeof (layerLevelConfig[i].css) == true)
        dynamicLoadCss("layers/" + _layerName + "/" + _layerName + ".css");
    }
  }else{
    var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", 
                    "getClientDevConfigure", "String");
    var remoteArg = { command: command, resultFunction: window.getLayerConfigHandler, 
      faultFunction: window.getLayerConfigFaultHandler, sync: false };
    ServiceHelper.addTokenWithCommand(remoteArg)
  }
  window.userInfos = userInfos;
  $("#userId").html(userInfos.userName ? userInfos.userName : userInfos.userId);
  $(".pull-left.info p").text(userInfos.userId);
  $("body").addClass("userClass_" + userInfos.userId);

}


window.getCurrentUserInfoHandler = function (data) {
  if (data.status == 2) 
  {
    if (window.didomain && !loginToken && !loginDataArea){
      if(typeof(window.layui.request.loginOut()) == 'function'){
        var _parentWindow =window;
      }else if(typeof(window.parent.window.layui.request.loginOut()) == 'function'){
        var _parentWindow =window.parent.window;
      }else{
        var _parentWindow =window.parent.parent.window;
      }
      _parentWindow.layui.request.loginOut();
      let UserId_desktopData = _parentWindow.localStorage.getItem("userId") + "desktopData";
      _parentWindow.localStorage.removeItem("username");
      _parentWindow.localStorage.removeItem("userId");
      _parentWindow.localStorage.removeItem("permission");
      _parentWindow.localStorage.removeItem("userToken");
      _parentWindow.localStorage.removeItem(UserId_desktopData);
    }else{
      window.location.href = loginPath;
    }
  }
  else if (data.status != 0)
  {
    alert(JSON.stringify(data));
  }
  else 
  {
    window.getUserInfosHandler(data);


    if(window.appId){
        // app 默认首页
      var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", "loadSolutionWhole", "Map");

      command.appendArg(window.appId);

      var remoteArg = { command: command, resultFunction: window.rpc_loadSolutionWholeSucess, faultFunction: window.rpc_loadSolutionWholeError, sync: false };
      ServiceHelper.addTokenWithCommand(remoteArg)
    }



    if (window.userInfos.isAdmin == true) {
      $("#extendLi").css("display", "block");
    } else {
      $("#extendLi").css("display", "block");
      $("#extendLi .menu>li").hide();
      $("#extendLi #extendLi_importManager").show();
      // $("#extendLi #extendLi_universalView").show();
      //系统维护按钮
      // $("#extendLi #extendLi_systemStart").css('display','none')
      // $("#extendLi #extendLi_systemClose").css('display','none')
    }

    //权限
    var command = Command.createService("gongqi.erp.gotmodel.form.load.FormAuthorityManager", "findMenuByUser", "List");
    command.appendArg(window.userInfos.userId);
    if (sessionStorage.getItem("fixedUserGroups")) {
      let fixedUserGroups = sessionStorage.getItem("fixedUserGroups");
      sessionStorage.removeItem("fixedUserGroups");
      command.appendArg(fixedUserGroups);
      //command.appendArg(fixedUserGroups.split(","),"String[]");
    }
    else {
      let fixedUserGroups = CommonUtil.getUrlParam("fixedUserGroups");
      if (fixedUserGroups) {
        command.appendArg(fixedUserGroups);
      }
    }
    var remoteArg = { command: command, resultFunction: window.getMenuListAuHandler, faultFunction: window.getMenuListAuFaultHandler, sync: false };
    ServiceHelper.addTokenWithCommand(remoteArg);

    WebSocketManager.initWebSocket();
    IndexedDBUtil.openDB(window.userInfos.subSysId, window.dbOpenSuccess);

  }
}

window.rpc_loadSolutionWholeSucess = function(data){
  var resultdata = data.result;
  if(resultdata.AfterLoadingCommand){
    for( let i in resultdata.AfterLoadingCommand.tasks){
      if(resultdata.AfterLoadingCommand.tasks[i].cmd == "openForm"){
        window.hasAppOpenFormFixed = true;
        break
      }
    }
    window.userInfos.clientCommandAfterLoginResult = resultdata.AfterLoadingCommand
    // CommandResolver.resolve(window.userInfos.clientCommandAfterLoginResult.tasks);
  }

  
}
window.rpc_loadSolutionWholeError = function(data){

}

window.switchLayerConfigServerToClient = function(config)
{
  let result = [];
  for(let i = 0;i<config.length;i++)
  {
    let _layer = config[i];

    if(_layer.name == "app")
    {
      let appConfig = {name:"app",css:{},js:{}};
      if(window.appId && _layer.hasOwnProperty(window.appId))
      {
        Object.assign(appConfig,_layer[window.appId]);
        
        if(appConfig.js == true)
        {
          appConfig.js = {};
          appConfig.js[window.appId] = window.appId+"/";
        }
        else
        {
          appConfig.js = {};
        }
      }
      else if(!window.appId)
      {
        for(let key in _layer)
        {
          if(key == "name")continue;
          if(!appConfig)appConfig = {name:"app",css:{},js:{}};
          let item = _layer[key];
          Object.assign(appConfig.css,item.css);
          if(item.js == true)
            appConfig.js[key] = key+"/";
        }
      }

      result.push(appConfig);
    }
    else if(_layer.name == "plg")
    {
      let plgConfigClient = {name:"plg",css:{},js:{}};
      if(window.appId && _layer.hasOwnProperty(window.appId))
      {
        let plgLayerAppConfig = _layer[window.appId];
        for(let key in plgLayerAppConfig)
        {
          let plgConfig = plgLayerAppConfig[key];
          if(!plgConfig.css)plgConfig.css={};
          if(!plgConfigClient.css[window.appId])plgConfigClient.css[window.appId]={};
          if(!plgConfigClient.css[window.appId][key])plgConfigClient.css[window.appId][key]={};
          Object.assign(plgConfigClient.css[window.appId][key],plgConfig.css);
          if(plgConfig.js == true)
          plgConfigClient.js[key] = window.appId+"/"+key+"/";
        }
      }
      else if(!window.appId)
      {
        for(let key1 in _layer)
        {
          if(key1 == "name")continue;
          let item1 = _layer[key1];
          for(let key2 in item1)
          {
            let item2 = item1[key2];
            if(!plgConfigClient.css[key1])plgConfigClient.css[key1]={}
            if(!plgConfigClient.css[key1][key2])plgConfigClient.css[key1][key2]={};
            Object.assign(plgConfigClient.css[key1][key2],item2.css);

            if(item2.js == true)
              plgConfigClient.js[key2] = key1+"/"+key2+"/";
          }
        }
      }
      result.push(plgConfigClient);
    }
    else if(_layer.name == "ext")
    {
      let extConfigClient = {name:"ext",css:{},js:{}};
      if(window.appId && _layer.hasOwnProperty(window.appId))
      {
        
        let extLayerAppConfig = _layer[window.appId];
        Object.assign(extConfigClient.css,extLayerAppConfig.css);
        if(extLayerAppConfig.js == true)
          extConfigClient.js[window.appId] = window.appId+"/";
      }
      else if(!window.appId)
      {
        for(let key in _layer)
        {
          if(key == "name")continue;
          let item = _layer[key];
          Object.assign(extConfigClient.css,item.css);
          if(item.js == true)
            extConfigClient.js[key] = key+"/";
        }
      }
      result.push(extConfigClient);
    }
    else
    {
      result.push(_layer);
    }
  }
  return result;

}
window.dynamicCssHand = function(data){
  window.dynamicCssLoad={};
  try {
    for(let i =0;i<data.length;i++){
      let _layerName = data[i].name;
      if(_layerName =='ext'){
        for(let j in data[i]){
          if(j != 'name'){
            for(let h in data[i][j].css){
              if(data[i][j].css[h]== true){
                window.dynamicCssLoad[h] =j;
              }
            }
          }
        }
      }
    }
    
  } catch (error) {
    
  }
}

window.getLayerConfigHandler = function(data)
{
  let layerLevelConfigServer = JSON.parse(data.result);
  window.dynamicCssHand(layerLevelConfigServer);
  window.layerLevelConfig = window.switchLayerConfigServerToClient(layerLevelConfigServer);
  var layerLevelConfig = window.layerLevelConfig;
  for (let i = 0; i < layerLevelConfig.length; i++) 
  {
    let _layerName = layerLevelConfig[i].name;
    window.layerConfigs[_layerName] = {};
    //dynamicLoadJs(urlBase+"/layers/"+_layerName+"/"+_layerName+".js");
    let jsConfig = layerLevelConfig[i].js;
    if(typeof(jsConfig) == "boolean")
    {
      if (layerLevelConfig[i].js)
        dynamicLoadJs("layers/" + _layerName + "/" + _layerName + ".js");
    }
    else if(typeof(jsConfig) == "object")
    {
      for(let jsKey in jsConfig)
      {
        let jsName = jsKey;//jsConfig[jsKey];
        let jsPath = jsConfig[jsKey];
        //if(jsName == true)
        dynamicLoadJs("layers/" + _layerName + "/" + jsPath + jsName + ".js");
      }
    }

    let cssConfig = layerLevelConfig[i].css;
    if(typeof(cssConfig) == "boolean")
    {
      if (layerLevelConfig[i].css)
      dynamicLoadCss("layers/" + _layerName + "/" + _layerName + ".css");
    }
    else if(typeof(cssConfig) == "object")
    {
      if(_layerName == 'plg'){
        for(let cssKey in cssConfig)
        {
          let appName = cssKey;//jsConfig[jsKey];
          let appCssConfig = cssConfig[cssKey];
          for(let plgKey in appCssConfig){
            let plgPath= appCssConfig[plgKey];
            for(let pcss in plgPath)
            {
              dynamicLoadCss("layers/" + _layerName + "/"+ appName+"/"+plgKey+"/"+ pcss + ".css");
            }
          }
          //if(jsName == true)
        }
      }else{
        for(let cssKey in cssConfig)
        {
          let cssName = cssKey;//jsConfig[jsKey];
          let cssPath = cssConfig[cssKey];
          //if(jsName == true)
          if(cssName.indexOf('.') != -1){
            let indexof = cssName.lastIndexOf('.');
            let app = cssName.substring(0,indexof);
            dynamicLoadCss("layers/" + _layerName + "/" +app+"/"+ cssName + ".css");
          }else{
            dynamicLoadCss("layers/" + _layerName + "/" + cssName + ".css");
          }
        }

      }
    }
  }
}

window.getLayerConfigFaultHandler = function(data)
{
    if(layerLevelConfig)
  {
    for(let i = 0;i<layerLevelConfig.length;i++)
    {
      let _layerName = layerLevelConfig[i].name;
      window.layerConfigs[_layerName] = {};
      //dynamicLoadJs(urlBase+"/layers/"+_layerName+"/"+_layerName+".js");
      if(layerLevelConfig[i].js)
        dynamicLoadJs("layers/"+_layerName+"/"+_layerName+".js");
  
      if(layerLevelConfig[i].css && typeof(layerLevelConfig[i].css) == true)
        dynamicLoadCss("layers/"+_layerName+"/"+_layerName+".css");
    }  
  } 
}

window.extendLiDown = function(){
  var command2 = Command.createService("gongqi.erp.layers.sys.services.MaintenanceService", "isMaintenance", "boolean");
  var remoteArg2 = { command: command2, resultFunction: window.isMaintenanceResult ,faultFunction: window.isMaintenanceResult, sync: false};
  ServiceHelper.addTokenWithCommand(remoteArg2);
}


window.doOrderOverallSituationModel = function(){
  let overallTime = $('#overallSituationDialogTime').val();
  let overallTimeL = overallTime.replace(new RegExp("-","gm"),"/");
  let overallTimeN = (new Date(overallTimeL)).getTime();
  var command2 = Command.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance",'void');
  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult ,faultFunction: window.setMaintenanceResultStart, sync: false };
  command2.appendArg('true','boolean');
  command2.appendArg('true','boolean');
  command2.appendArg(overallTimeN,'long');
  ServiceHelper.addTokenWithCommand(remoteArg2);
}

window.doOverallSituationModel = function(){
  var command2 = Command.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance",'void');
  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult ,faultFunction: window.setMaintenanceResultStart, sync: false };
  command2.appendArg('true','boolean');
  command2.appendArg('false','boolean');
  command2.appendArg(0,'long');
  ServiceHelper.addTokenWithCommand(remoteArg2);
}

window.showSystemStart = function(){
  var command2 = Command.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance",'void');
  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult ,faultFunction: window.setMaintenanceResultStart, sync: false };
  command2.appendArg('true','boolean');
  ServiceHelper.addTokenWithCommand(remoteArg2);
  // $("#overallSituationDialog").show();
}

window.showSystemClose = function(){
  var command2 = Command.createService("gongqi.erp.layers.sys.services.MaintenanceService", "setMaintenance",'void');
  var remoteArg2 = { command: command2, resultFunction: window.setMaintenanceResult ,faultFunction: window.setMaintenanceResultClose, sync: false };
  command2.appendArg('false','boolean');
  // command2.appendArg('false','boolean');
  // command2.appendArg(0,'long');
  ServiceHelper.addTokenWithCommand(remoteArg2);
}


window.isMaintenanceResult = function (data){
  if (window.userInfos.isAdmin == true) {
    if (data.status == 0) {
      if(data.result == false || data.result == 'false'){
        // $("#extendLi #extendLi_systemStart").css('display','')
        // $("#extendLi #extendLi_systemClose").css('display','none')
      }else{
        // $("#extendLi #extendLi_systemStart").css('display','none')
        // $("#extendLi #extendLi_systemClose").css('display','');
      }
    }
    else {
      //alert(data);
    }
  }
}


window.setMaintenanceResultStart = function (data){
  if (window.userInfos.isAdmin == true) {
    if (data.status == 0) {
      if(data.result == null){
        // $("#extendLi #extendLi_systemStart").css('display','')
        // $("#extendLi #extendLi_systemClose").css('display','none')
      }
    }
    else {
      alert(data.msg);
    }
  }
}

window.setMaintenanceResultClose = function (data){
  if (window.userInfos.isAdmin == true) {
    if (data.status == 0) {
      if(data.result == null){
        // $("#extendLi #extendLi_systemStart").css('display','none')
        // $("#extendLi #extendLi_systemClose").css('display','close')
      }
    }
    else {
      alert(data.msg);
    }
  }
}


window.dbOpenSuccess = function () {
  window.getClientLogNetWorkErrorData(LogUtil.upNetWorkErrorLog);
}
window.getCurrentUserInfoError = function (data) {
  if (window.didomain && !loginToken && !loginDataArea){
    window.location.href = window.errorPath;
  }else{
    window.location.href = loginPath;
  }

}


window.getCurrentUserInfo = function () {
  var command = {}; command.classType = "service"; command.className = userSessionPackage; command.instanceType = null;
  command.instanceId = null; command.methodName = "getCurrentUserSession"; command.returnType = "UserSession";

  var data = JSON.stringify(command); var postdata = { request: data };
  let _urlBase = "";
  if (window.urlBase)
    _urlBase = window.urlBase;
  let path; let _headers = {};
  if (window.didomain) 
  {
    path = "/GongqiERP/" + window.didomain + "/ServiceController";

    if(!window.loginToken)
    {
      let _token = localStorage.getItem("userToken");
      if (_token)
        _headers.token = _token;
    }
    
  }
  else {
    path = "/GongqiERP/ServiceController";
  }

  $.ajax({
    type: 'post',
    url: _urlBase + path,
    dataType: "json",
    headers: _headers,
    data: postdata,
    //暂时在跨域请求时强制浏览器携带cookie not surpport by fireFox>20
    xhrFields: { withCredentials: true },

    success: window.getCurrentUserInfoHandler,
    error: window.getCurrentUserInfoError
  });
}

window.autoLoginByTokenHandler = function (data) {
  window.autoFullScreen = CommonUtil.getUrlParam("autoFullScreen");
  window.getCurrentUserInfo();
}

window.autoLoginByTokenError = function (data) {
  //alert("无法自动登录 点击转入手动登录");
  window.location.href = loginPath;
  var faultString;var reqHandler = "";
  if (data && data.successButNot0) {
    faultString = data.errText;

  }
  else {
    faultString = "无法自动登录 点击转入手动登录";
    reqHandler = locationToLoginPath;
  }
  Warning.show({ text: faultString, title: "登录失败",confirm:{
      isShow:true,
      event:reqHandler,
      text:'去登录' 
  }});
}

window.locationToLoginPath = function()
{
  window.location.href = loginPath;
}

window.autoLoginByToken = function () {
  let browserInfo = "";
  try {
    var browser = {
      ie: 0,
      firefox: 0,
      safari: 0,
      konq: 0,
      opera: 0,
      chrome: 0,
    }
    var ua = navigator.userAgent
    if (window.opera) {
      browser.opera = window.opera.version()
    } else if (/AppleWebKit\/(\S+)/.test(ua)) {
      // 判断是 Chrome 还是 safari
      if (/Chrome\/(\S+)/.test(ua)) {
        browser.chrome = RegExp['$1']
      } else if (/Version\/(\S+)/.test(ua)) {
        // 仅使用于 safari 3 及其更高版本
        browser.safari = RegExp['$1']
      } else {
        // 个别情况-未获取到 safari 版本号的处理
      }
    } else if (/KHTML\/(\S+)/.test(ua) || /Konqueror\/([^;]+)/.test(ua)) {
      browser.konq = RegExp['$1']
    } else if (/rv:([^\)]+)\) Gecko\/\d{8}/.test(ua)) {
      if (/Firefox\/(\S+)/.test(ua)) {
        // 火狐浏览器
        browser.firefox = RegExp['$1']
      } else {
        // 其他情况
      }
    } else if (/MSIE ([^;]+)/.test(ua)) {
      browser.ie = RegExp['$1']
    }
    for(let k in browser){
      if(browser[k] !=0){
        browserInfo = k+"/"+browser[k];
      }
    }
  } catch (error) {
    
  }

  var command = Command.createService("gongqi.erp.framework.services.UserSessionService", "loginByToken", "UserSession");
  command.appendArg(loginToken); command.appendArg(
    { Status: 1, browserInfo: browserInfo, Mac: "", Type: 71, ComputerName: "" }, 
    "java.lang.Object");
  command.appendArg(loginDataArea);
  var remoteArg = {
    command: command, resultFunction: window.autoLoginByTokenHandler,
    faultFunction: window.autoLoginByTokenError, lockText: "系统正在自动登录..."
  };
  ServiceHelper.addTokenWithCommand(remoteArg);
}



var loginToken = CommonUtil.getUrlParam("token");
window.loginToken = loginToken;
var loginDataArea = CommonUtil.getUrlParam("dataArea");
window.loginDataArea = loginDataArea;


if (fromOrig != "oshome") {
  if (loginToken && loginDataArea) {
    window.autoLoginByToken();
  }
  else {
    window.getCurrentUserInfo();

  }
}



window.getMenuListAuHandler = function (data) {
  if (data.status == 0) {
    var authority = data.result;


    AuthorityUtil.initMenuListCache(authority);

    var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", "getGOT", "byte[]");
    var remoteArg = { command: command, resultFunction: window.gotSuccessHandler, faultFunction: window.gotErrorHandler, sync: false };
    ServiceHelper.addTokenWithCommand(remoteArg);
  }
  else {
    alert(data.msg);
  }
}

window.getMenuListAuFaultHandler = function (faultEvent) {
  var faultString;
  if (faultEvent && faultEvent.successButNot0) {
    faultString = faultEvent.errText;

  }
  else {
    faultString = "可能是网络错误 请检查网络是否正常";
  }
  Warning.show({ text: faultString, title: "未能正确获取到菜单相关权限" });
}





function unzip (b64Data) {
  var strData = atob(b64Data);

  // Convert binary string to character-number array
  var charData = strData.split('').map(function (x) { return x.charCodeAt(0); });


  // Turn number array into byte-array
  var binData = new Uint8Array(charData);


  // // unzip
  var data = pako.inflate(binData);


  // Convert gunzipped byteArray back to ascii string:
  strData = String.fromCharCode.apply(null, new Uint16Array(data));
  return strData;
}

window.dynamicLoadJs = function (url, callback) {
  var script = document.createElement('script');
  script.type = "text/javascript";
  if (typeof (callback) != "undefined") {
    if (script.readyState) {
      script.onreadystatechange = function () {
        if (script.readyState == "loaded" || script.readyState == "complete") {
          script.onreadystatechange = null;
          callback();
        }
      }
    }
    else {
      script.onload = function () {
        callback();
      };
    }
  }
  var newurl = url;
  script.src = newurl;
  document.body.appendChild(script);
}

window.openForm = function (arg) {
  FormLoadHelper.openMenuItem(arg);
}

window.hideGOTMainMenuByAppId = function (mainMenu) {
  let items = mainMenu.items;
  for (var i = 0; i < items.length; i++) {
    var item = items[i];
    let _id = item.id;
    if (_id && _id.indexOf(".") != -1 && _id.indexOf(window.appId) != 0) {
      item.Properties.Visible.V = false;
    }
  }
}

window.gotSuccessHandler = function (data) {


  var iframe = $("<iframe>").css("border", "none").attr("id", "SupcanFrame").css("width", "5px").css("height", "5px").css("background", "none");
  iframe.attr("src", "./supcan/print.html");
  $("#SupcanFrameIf").append(iframe);



  //alert("获取GOT");
  //TODO 根据window.got的licenseInfo 与 showGongqi变量值 来显示版本号
  if (data.status == 0) {
    var compressedByteArray = base64js.toByteArray(data.result);
    var s = pako.inflate(compressedByteArray, { to: 'string' });
    window.got = JSON.parse(s);

    let licenseInfo = window.got.licenseInfo;
    if (licenseInfo) {
      let infoArray = licenseInfo.split("|");
      let versionTxt = infoArray[0];
      $("#versionTxtDiv").html(versionTxt).on("click", window.showLicenseModal);
      //let customInfo = infoArray[1];
      //$("#customInfoDiv").html("3.0.99");
    }

    /*if(window.userInfos.menuCustomObject)
    {
      let customMenu = {
          id: "60102002",
          createdLayer: "bug",
          items: [],
          nextInnerId: "10023",
          name: "RD",
          Properties: {ModifiedDate: {V: ""},CreatedTime: {V:""},Visible: {V: "true"},ModifiedBy: {V: ""},CreatedBy: {V: ""},CreatedDate: {V: ""},ModifiedTime: {V: ""},Label: {V: ""},Icon: {V: "fa fa-user-plus"},HelpText: {V: ""}},
          modifiedLayer: "bug",
          version: "1"
      };


      for(let key in window.userInfos.menuCustomObject)
      {
        let customMenuItem = {
          id: "50213357",
          createdLayer: "bug",
          qname: "MenuItem",
          idInMenu: "10016",
          nextInnerId: "10001",
          name: "RD_MyBugList",
          Properties: {Source: {V: "Form"},Parameters: {V: ""},Visible: {V: "true"},IconType: {V: "Display"},Popup: {V: "false"},Label: {V: "我的问题"},RefObject: {refentityid: "40213347",V: "RD_MyBugList"},HelpText: {V: "iconfont icon-wentiguanli"}},modifiedLayer: "bug",version: "4"
        }
      }
    }*/

    //alert(licenseInfo);
    if (window.treeViewMainMenuPath) {
      /*import(window.treeViewMainMenuModule).then((Component) => {
          //do something with TheComponent = Component.default
          let Module = Component.default;
          ReactDOM.render(<Module data={window.got.MainMenu}/>,document.getElementById('mainMenu'));
      });*/
      //var page = window.treeViewMainMenuModuleName;
      //let Module = require("./customdev/menu/${page}");
      //ReactDOM.render(<Module data={window.got.MainMenu}/>,document.getElementById('mainMenu'));
      dynamicLoadJs(window.treeViewMainMenuPath);
    }
    else 
    {
      if (window.appId) 
      {
        //如果是操作系统 获取应用菜单访问管控中心
        // if (window.didomain && !loginToken && !loginDataArea)
        // {
        //   AjaxRemoteUtil.ajaxPost("../../"+window.didomain+"/web/art/application/appMenu",{appId:window.appId},
        //   "json",false,window.rpc_result_loadApplicationMainMenu,null,false,
        //   {domain:window.didomain,loginToken:window.loginToken,loginDataArea:window.loginDataArea,relativeUrl:true});
        // }
        // else

        var command = Command.createService(window.servicePath?window.servicePath:"gongqi.erp.gotmodel.services.GOTService", "loadSolutionWhole", "Map");
        var remoteArg = {command:command,resultFunction:window.rpc_result_loadApplicationMainMenu,sync:false};
        command.appendArg(window.appId);
        ServiceHelper.addTokenWithCommand(remoteArg);
        //}
        return;
        //hideGOTMainMenuByAppId(window.got.MainMenu);
      }
      window.doRenderMainMenu();
    }
    window.doAfterMainMenu();
    //setTimeout(function(){window.testOpenAllWindowAndDelayClose();},10000);

   

  //window.getClientLogNetWorkErrorData(LogUtil.upNetWorkErrorLog);
  }
  else 
  {
    alert(data.msg);
  }
}

window.rpc_result_loadApplicationMainMenu = function(data)
{
  var resultdata = data.result;
  window.got.MainMenu = JSON.parse(resultdata.MainMenu);
  window.doRenderMainMenu();
  window.doAfterMainMenu();
}

window.doRenderMainMenu = function()
{

  if(window.fixedMenuId)
  {
    var mainMenu = window.got.MainMenu;
    if(mainMenu && mainMenu.items && mainMenu.items.length>0)
    {
      for(var i = 0;i<mainMenu.items.length;i++)
      {
        var item = mainMenu.items[i];
        if(item.id != window.fixedMenuId)
        {
          item.Properties.Visible.V = "false";
        }
      }
    }
  }
  if (window.userSettingEntry.showLeftMenu == true) 
  {
    window.getUserDataSettings("showLeftMenu");
  }
  else 
  {
    if (window.userSettingEntry.showLeftListMenu == true)
    window.getUserDataSettings("showLeftListMenu");
    else
      $("#toolBarMainMenuToggleA").hide();
  }

  if(window.hasMenuMap && !window.hasAppOpenFormFixed)
  {
    
    let liE =$('<li class="active menumap" tabpaneid="menunavmap" style="position: relative; left: 0px; top: 0px;"><a href="#menunavmap" data-toggle="tab" aria-expanded="true" class="gongqi_tabpage">业务地图</a></li>')
    
    
    var childrenArray =   $("#g_nav_tabs").children().toArray();
    var targetIndex = childrenArray.length - 1 - 1; // 最后第二个位置的索引
    var targetElement = childrenArray[targetIndex];
    $(targetElement).after(liE);
    
    //$('<div class="tab-pane active menumap" id="menunavmap"  style="width: 100%; height: 100%;"><canvas id="menunavmapcanvas">222</canvas></div>')
    var tabpane = $('<div class="tab-pane active menumap" id="menunavmap"  style="width: 100%; height: 100%;"></div>');
    tabpane.appendTo($("#g_tab_content"));
    //let _menuMap = JSON.parse(window.userMenuMap);

    $("<iframe>").css("border", "none").css("width", "100%").css("height", "100%")
      .attr("src","./html/menuMap/index.html#/render?businessMapId="+window.userMenuMap)
      .appendTo(tabpane);



   /* CommonUtil.drawCanvas(
      _menuMap.cells,
      //JSON.parse(localStorage.getItem("json")).cells,
      "menunavmap","menunavmapcanvas"
    );*/
  }
  
}

window.getBusinessMapJSON = function(){
  var res ={};
  if (window.didomain && !loginToken && !loginDataArea){
    let mainmenu = window.got.MainMenu;
    let mainmenuString = JSON.stringify(window.got.MainMenu);
    let appId = window.appId;
    res = BusinessMapUtil.BusinessMapJSON(appId,mainmenuString);    
  }
  return res;
}

window.openLuckySheet = function(arg){
  var preActiveLi = $("#g_nav_tabs>li.active");
  preActiveLi.removeClass("active");
  var preActiveDiv= $("#g_tab_content>div.active");
  preActiveDiv.removeClass("active");
  let labelSheet = arg.lable == null?"luckySheet":arg.lable;
  let timestamp=new Date().getTime();
  $('<li class="active" tabpaneid="'+timestamp+'" style="position: relative; left: 0px; top: 0px;"><a href="#'+timestamp+'" data-toggle="tab" aria-expanded="true" class="gongqi_tabpage">'+labelSheet+'</a>'
  +'<i class="fa fa-close" style="position: absolute; top: 1px; right: 3px;" onClick="closeLuckySheet('+timestamp+')"></i>'
  +'</li>')
  .appendTo($("#g_nav_tabs"));
  var tabpane = $('<div class="tab-pane active " id="'+timestamp+'"  style="width: 100%; height: 100%;"></div>');
  tabpane.appendTo($("#g_tab_content"));
  let filed = arg.luckysheetFileId == null?"":arg.luckysheetFileId;
  let actionStr = arg.action == null?"":arg.action;
  let appIdStr = arg.appId == null?"":arg.appId;
  let modelId = arg.modelId == null?"":arg.modelId;
  $("<iframe>").css("border", "none").css("width", "100%").css("height", "100%")
    .attr("src","./html/fileManage/index.html#/templateDesign?luckysheetFileId="+filed+"&"+"action="+actionStr+"&appId="+appIdStr+"&modelId="+modelId+"")
    .appendTo(tabpane);
}

window.closeLuckySheet = function (e) {
  var tabpaneid = e;
  var tabpaneEl = document.getElementById(tabpaneid);
  var $iframe = $(tabpaneEl).find(">iframe");
  //var $iframe = $("#"+tabpaneid+" >iframe");

  if ($iframe.length > 0) {
    var win = $iframe.get(0).window || $iframe.get(0).contentWindow;
    if (win)
      closeForm(win.formModuleInstanceuuId, false);
  }
}

window.isH5 = true;

window.exeCommandResult = function(commandResult)
{
  if(commandResult.commandTasks && commandResult.tasks && commandResult.tasks[0] && !commandResult.tasks[0].cmd){
    CommandResolver.resolve(commandResult.commandTasks, window.formModuleInstance);
  }else{
    CommandResolver.resolve(commandResult.tasks, window.formModuleInstance);
  }
}


//加载 万能视图 可用导出数据
window.getUserDataSettings = function(flag){
  if (window.rightSidebarClicked){
    if(flag ==='showLeftMenu'){
      ReactDOM.render(<TreeViewMainMenu data={window.got.MainMenu} dataSettings={window.userDataSettingsContent} />, document.getElementById('mainMenu'));
    }
    if(flag ==='showLeftListMenu'){
      ReactDOM.render(<ListTreeViewMainMenu data={window.got.MainMenu} dataSettings={window.userDataSettingsContent}/>, document.getElementById('listtree-mainMenu'));
    }
    return;
  };
  let content = [];

  var domain = window.didomain;
  // var url = window.parent.window.osUrl+"/manage/dataSetViewsqlPreview";
  // var url = window.osUrl+"/"+domain+"/web/apps/gongqi.tool.datasetDesign/dsDesign/loadUserDataSetSetting";
  var url = window.osUrl+"/"+"MIX"+"/web/apps/gongqi.tool.datasetDesign/dsDesign/loadUserDataSetSetting";
  let _headers = {"Content-type":"application/json"};
  if(!window.loginToken)
  {
    let _token = localStorage.getItem("userToken");
    if (_token)
    _headers.token = _token;
  }		
  var _that = this;
  var param = {
    "domain":window.didomain,
    "appId":window.appId,
    "userId":userInfos.userId,
    }; 
  $.ajax({
    type:'get',
    url:url,
    dataType:"json",
    headers: _headers,
    data:param,
    success:function(data){
      var dataSettings =data;
      if (!dataSettings || dataSettings.length == 0) {
        if(flag =='showLeftMenu'){
          ReactDOM.render(<TreeViewMainMenu data={window.got.MainMenu} dataSettings="" />, document.getElementById('mainMenu'));
        }
        if(flag =='showLeftListMenu'){
          ReactDOM.render(<ListTreeViewMainMenu data={window.got.MainMenu} dataSettings="" />, document.getElementById('listtree-mainMenu'));
        }
        return;
      }
      window.userDataSettings = dataSettings;

      if(dataSettings && dataSettings != []){
        for (let i = 0; i < dataSettings.length; i++) {
          let ds = dataSettings[i];
          if(!ds.menuLabel){
            continue;
          }
          var _clsName = "iconfont  icon-yingyong-dianjihou text-blue";
          var _clsName2 = "iconfont  icon-yingyong-dianjihou";
          if(flag ==='showLeftMenu'){
            content.push(
              <li className="treeview menuItem" key={'menuItem-li'+i} data-formLabel={ds.menuLabel}>
              <a title={ds.menuLabel} style={{cursor:"pointer",display:'flex',alignItems:'center',paddingTop:'1px',paddingBottom:'1px'}}  onDoubleClick={window.dataSettingClick} data-SetId={ds.dataSetId} data-SetUniqueId={ds.recId} data-menuLabel ={ds.menuLabel}>
                <i className={_clsName} style={{flexShrink:0,marginRight:'4px',marginTop:'2px',fontSize:'14px'}}></i> 
                <div  data-SetId={ds.dataSetId} data-SetUniqueId={ds.recId} data-menuLabel ={ds.menuLabel} >{ds.menuLabel}</div>
              </a>
              </li>
            );
          }
          if(flag ==='showLeftListMenu'){
            content.push(
              <li data-SetId={ds.dataSetId} data-SetUniqueId={ds.recId} data-menuLabel ={ds.menuLabel}>
              <a  className={"listtree-menu-title "}  onClick={window.dataSettingClick} data-SetId={ds.dataSetId} data-SetUniqueId={ds.recId} data-menuLabel ={ds.menuLabel}>
                <div style={{display:'flex'}} data-SetId={ds.dataSetId} data-SetUniqueId={ds.recId} data-menuLabel ={ds.menuLabel}>
                  <div className={"listtree-menu-icon "+_clsName2}></div>
                  <span data-SetId={ds.dataSetId} data-SetUniqueId={ds.recId} data-menuLabel ={ds.menuLabel}>{ds.menuLabel}</span>
                </div>
              </a>
              </li>
            );
          }
        }
      }
    window.userDataSettingsContent = content;
    if(flag ==='showLeftMenu'){
      ReactDOM.render(<TreeViewMainMenu data={window.got.MainMenu} dataSettings={content}/>, document.getElementById('mainMenu'));
    }
    if(flag ==='showLeftListMenu'){
      ReactDOM.render(<ListTreeViewMainMenu data={window.got.MainMenu} dataSettings={content}/>, document.getElementById('listtree-mainMenu'));
    }
    window.rightSidebarClicked = true;
    },
    error:function(data){
      if(flag ==='showLeftMenu'){
        ReactDOM.render(<TreeViewMainMenu data={window.got.MainMenu} dataSettings='' />, document.getElementById('mainMenu'));
      }
      if(flag ==='showLeftListMenu'){
        ReactDOM.render(<ListTreeViewMainMenu data={window.got.MainMenu} dataSettings=''/>, document.getElementById('listtree-mainMenu'));
      }
    }
  })

  // var command = Command.createService(
  // "gongqi.erp.gotmodel.services.UserSettingService",
  // "loadUserDataSetSetting",
  // "String"
  // );
  // var _resultHandler = function (data) {

  // }
  // var _resultErrHandler = function (data) {
  //   if(flag ==='showLeftMenu'){
  //     ReactDOM.render(<TreeViewMainMenu data={window.got.MainMenu} dataSettings='' />, document.getElementById('mainMenu'));
  //   }
  //   if(flag ==='showLeftListMenu'){
  //     ReactDOM.render(<ListTreeViewMainMenu data={window.got.MainMenu} dataSettings=''/>, document.getElementById('listtree-mainMenu'));
  //   }
  // }
  // var remoteArg = {
  //   command: command, resultFunction: _resultHandler,
  //   faultFunction: _resultErrHandler,
  //   sync: false
  //   };
  //   ServiceHelper.addTokenWithCommand(remoteArg);
}

window.doAfterMainMenu = function()
{
      if (window.userSettingEntry.showToolMenu == true)
        ReactDOM.render(<ListMainMenu data={window.got.MainMenu} />, document.getElementById('listMainMenu'));
      //当有别的主页包含框架时 有时需要直接打开固定页面
      if (sessionStorage.getItem("openFixedFormArg")) 
      {
        let fixedOpenFormArgStr = sessionStorage.getItem("openFixedFormArg");
        let fixedOpenFormArg = JSON.parse(fixedOpenFormArgStr);
        sessionStorage.removeItem("openFixedFormArg");
        var ofa_paramObject = fixedOpenFormArg.paramObject;
        if (typeof (ofa_paramObject) == "object" && ofa_paramObject && !ofa_paramObject.hasOwnProperty("remoteClass"))
          ofa_paramObject = Object.assign({ remoteClass: "java.util.Map" }, ofa_paramObject);

        var addJoin = false;
        var _autoJoinParentArg = { autoJoinParent: false };


        FormLoadHelper.openMenuItemByAuthority({
          menuItemId: fixedOpenFormArg.menuItemId, parm: fixedOpenFormArg.paramString, fm: null,
          group: null, callerKey: fixedOpenFormArg.callerKey, paramObject: ofa_paramObject, popUp: fixedOpenFormArg.isPopUp, addJoin: addJoin,
          autoJoinParentArg: _autoJoinParentArg
        });
        //command.appendArg(fixedUserGroups.split(","),"String[]");
      }
      //登录后立即执行命令 一般是打开画面





      if (window.userInfos.clientCommandAfterLoginResult) 
      {
        CommandResolver.resolve(window.userInfos.clientCommandAfterLoginResult.tasks);
      }


      let fixedOpenForms = CommonUtil.getUrlParam("fixedOpenForms");
      if (fixedOpenForms) 
      {
        let fixedOpenFormsArray = [];
        if (fixedOpenForms && fixedOpenForms.indexOf("[") == 0) 
        {
          fixedOpenFormsArray = JSON.parse(fixedOpenForms);
        }
        else 
        {
          fixedOpenFormsArray = [fixedOpenForms];
        }
        for (let i = 0; i < fixedOpenFormsArray.length; i++) 
        {
          let fixedOpenForm = fixedOpenFormsArray[i] + "";
          let commandTask = { arg: fixedOpenForm, cmd: "openForm" };
          CommandResolver.resolve([commandTask]);
        }
      }

      // 从OS 搜索打开页面
      let fixedOpenMenuItem =  getQueryString("menuItem", window.location.search);
      if(fixedOpenMenuItem){
        setTimeout(function () {
          let commandTask = { arg: {menuItemId:fixedOpenMenuItem,onlyQuery:false,label:"",checkHas:false,fromMainMenu:true}, cmd: "openForm" };
          CommandResolver.resolve([commandTask]);
        }, 2000);
      }
      let fixedCommandResult = getQueryString("CommandResult", window.location.search);
      if(fixedCommandResult){
        setTimeout(function () {
          let obj = JSON.parse(fixedCommandResult)
          window.exeCommandResult(obj);
        }, 2000);
      }


      

      if(window.userInfos.licenseXML)
      {
        let domparse = new DOMParser();
        let doc = domparse.parseFromString(window.userInfos.licenseXML,"application/xml");
        let licenses = doc.getElementsByTagName("gongqiLicenses")[0];
        let license = licenses.getElementsByTagName("license")[0];
        let customer = license.getElementsByTagName("LicensedCustomer")[0];
        let customerStr = customer.textContent;
        let project = license.getElementsByTagName("LicensedProject")[0];
        let projectStr = project.textContent;
        $("#versionTxtDiv").html(customerStr+" "+projectStr).on("click", window.showLicenseModal);
      }
}
//TODO OS 搜索 直接打开 MenuItem
window.OSSearchOpenMenuItem = function(params) {
  let fixedOpenMenuItem = params?params:getQueryString("menuItem", window.location.search);
  if(fixedOpenMenuItem && !fixedOpenMenuItem.tasks){
    let commandTask = { arg: {menuItemId:fixedOpenMenuItem,onlyQuery:false,label:"",checkHas:false,fromMainMenu:true}, cmd: "openForm" };
    CommandResolver.resolve([commandTask]);
  }
  let fixedCommandResult = params?params:getQueryString("CommandResult", window.location.search);
  if(fixedCommandResult){
    try{
      let obj = JSON.parse(fixedCommandResult)
      window.exeCommandResult(obj);
    }catch(e){
    }
  }
}
//TODO OS消息 直接执行CommandResult
window.OSMessageLinkDoCommand = function(params) {
  let fixedCommandResult = params?params:getQueryString("CommandResult", window.location.search);
  if(fixedCommandResult){
    window.exeCommandResult(fixedCommandResult);
  }
}




window.gotErrorHandler = function (faultEvent) {
  var faultString;
  if (faultEvent && faultEvent.successButNot0) {
    faultString = faultEvent.errText;
  }
  else {
    faultString = "可能是网络错误 请检查网络是否正常";
  }
  Warning.show({ text: faultString, title: "获取GOT失败" })
}

//got
//var command = Command.createService("gongqi.erp.layers.sys.services.TestH5Service","getGOT","Object");// <=f8


window.relation1NSuccessHandler = function (data) {
  if (data.status == 0) {
    window.relation1N = data.result;
  }
  else {
    alert(JSON.stringify(data));
  }
}

window.relation1NErrorHandler = function (faultEvent) {

  var faultString;
  if (faultEvent && faultEvent.successButNot0) {
    faultString = faultEvent.errText;
  }
  else {
    faultString = "可能是网络错误 请检查网络是否正常";
  }
  Warning.show({ text: faultString, title: "获取表结构关系失败" })
}

//realation1N

if (fromOrig != "oshome") {
  var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", "getAllRelations", "List");
  var remoteArg = { command: command, sync: false, resultFunction: window.relation1NSuccessHandler, faultFunction: window.relation1NErrorHandler };
  ServiceHelper.addTokenWithCommand(remoteArg);
}

window.isCurrentWindow = function (formWindow) {
  var win; var iframe;
  //TODO弹出页面上又有弹出页面？之前根据经验由于需求过于繁琐采用栈来管理也并不好管理
  if (formWindow && formWindow.isPopUp) {
    var popIframes = $("#formModal iframe");
    if (popIframes.length > 0) {
      iframe = popIframes.get(popIframes.length - 1);
      win = iframe.window || iframe.contentWindow;
      if (win == formWindow)
        return true;
    }
    return false;
  }
  var arr = $("#g_tab_content>div.tab-pane.active iframe");
  if (arr.length > 0) {
    iframe = arr.get(0);
    win = iframe.window || iframe.contentWindow;
    return win == formWindow;
  }
  return false;
}


$("#search-btn").on("click", function () {
  doSearch();
})

$("#searchInput").on('input', function () {
  //todo  取当前值
  var thisword = $("#searchInput").val();
  var timerId = setTimeout(function () {
    //todo 取当前值 一样 执行函数
    var nowword = $("#searchInput").val();

    if (nowword == thisword) {
      doSearch();
      if (!nowword) {
        $(".sidebar-menu li.active").removeClass("active");
        $(".sidebar-menu ul.menu-open").removeClass("menu-open");
        $(".sidebar-menu ul.treeview-menu").css("display", "");

      }
    }



    clearTimeout(timerId);

  }, 500);
})





function doSearch () {
  var keyword = $("#searchInput").val().toLowerCase();

  $('.sidebar-menu li').show();
  //menuitem

  $('.sidebar-menu li.menuItem').each(function () {
    var dataword = $(this).attr("data-formlabel");

    if (dataword) {
      var datawordLow = dataword.toLowerCase();
      if (datawordLow.indexOf(keyword) == -1) {
        $(this).hide();
      }
      else {
        $(this).show();
        $(this).parent().addClass('menu-open');
        $(this).parent().parent().addClass('active');
      }
    }
  });

  $('.sidebar-menu ul.treeview-menu').each(function () {

    var menuItems = $(this).find(".menuItem");
    var hide = true;
    for (var i = 0; i < menuItems.length; i++) {
      var menuItem = menuItems.get(i);
      if ($(menuItem).css('display') != 'none') {
        hide = false;
      }

    }

    hide ? $(this).hide()
      :
      $(this).show()

  })

  //menuSub
  $('.sidebar-menu .menuSub').each(function () {

    var menuItems = $(this).find(".menuItem");
    var hide = true;
    for (var i = 0; i < menuItems.length; i++) {
      var menuItem = menuItems.get(i);
      if ($(menuItem).css('display') != 'none') {
        hide = false;
      }

    }

    hide ? $(this).hide()
      :
      $(this).show(),
      $(this).parent().addClass('menu-open'),
      $(this).parent().parent().addClass('active');

  })

  //menu
  $('.sidebar-menu>li.treeview').each(function () {
    var menuItems = $(this).find(".menuItem");
    var hide = true;
    for (var i = 0; i < menuItems.length; i++) {
      var menuItem = menuItems.get(i);
      if ($(menuItem).css('display') != 'none') {
        hide = false;
      }

    }

    hide ? $(this).hide() : $(this).show();
  })

}


window.showPasswordModal = function () {
  $("#passwordModal").show();
  $('#but_PasswordModalClose').css('display','');
  $('#but_PasswordModalCancel').css('display','');
}

window.hidePasswordModal = function () {
  $("#passwordModal").hide();
}

window.hideOverallSituationModel = function () {
  $("#overallSituationDialog").hide();
}

window.showLicenseModal = function () {

  if (!window.licenseIsShow) {
    var license = userInfos.licenseInfo;
    var doc = (new DOMParser()).parseFromString(license, "application/xml");
    var gongqiLicenses = doc.getElementsByTagName("license")[0].childNodes;
    if (gongqiLicenses.length > 0) {
      for (let i in gongqiLicenses) {
        if (gongqiLicenses[i].attributes) {
          var labelName = gongqiLicenses[i].attributes.display.nodeValue;
          var labelContext = gongqiLicenses[i].textContent;
          $("<p></p>").html(labelName + "：" + labelContext).appendTo($("#licenseModal .modal-body"))
        }
      }
    }
    window.licenseIsShow = true;
  }
  $("#licenseModal").show();
}


window.upDownLicenseModal =  function(){
  //ReactDOM.render(<LicenseUpLoad  />, document.getElementById('licenseUpLoadModal'));
  var task = {arg:{'url':window.parent.window.userInfos.serviceURL+'/web/platformlicense/upload'}}
  LicenseUpLoad.doFileUpload(task);
}




window.verificationLicenseModal = function(){
  var license = userInfos.licenseInfo;
  var doc = (new DOMParser()).parseFromString(license, "application/xml");
  var gongqiLicenses = doc.getElementsByTagName("license")[0].childNodes;
  var reData = {};
  if (gongqiLicenses.length > 0) {
    for (let i in gongqiLicenses) {
      if (gongqiLicenses[i].attributes) {
        var labelName = gongqiLicenses[i].attributes.display.nodeValue;
        var labelContext = gongqiLicenses[i].textContent;
        if(labelName == '数字签名'){
          //reData['secretKey'] = 'MCwCFFdqcFPeHtt/Y+lC3MxxdKtsV2bxAhQonKIzE8pRTsZrXzAQ4P+IFAjZsg==';
          reData['secretKey'] = labelContext;
        }
      }
    }
  }
  var url = 'http://ims.gongqi.info:55208/web/apps/gongqi.oa.yw/operation/originalEffectiveness?_dataarea=dynamic';
  $.ajax({
    type:'post',
    url:url,
    data:reData,
    //headers:{'_dataarea':'dynamic'},
    xhrFields:{withCredentials:true},
    success:function(data){
      console.log(data)
      if(data.content == null){
        alert('没有查询到License信息');
      }else{
        alert('验证成功');
      }
    },
    error:function(data){
     
      if(errorHandler != undefined)
      {
        errorHandler(data);
      }
      else
      {
        Warning.show({text:"网络链接出问题了喔,请稍后再试"});
      }
    }
});
}


window.hideLicenseModal = function () {
  $("#licenseModal").hide();
}

window.getLoginMsg = function () {
  if (!window.isGetLoginMsg) {
    var y = userInfos.loginDate.getFullYear();
    var m = userInfos.loginDate.getMonth() + 1;
    var d = userInfos.loginDate.getDate();

    let licenseInfo = window.got.licenseInfo;
    if (licenseInfo) {
      let infoArray = licenseInfo.split("|");
      let versionTxt = infoArray[0];
      let _arr = versionTxt.split(" ");
      $("#subSysIdPart").html(userInfos.userId + "&nbsp;" + userInfos.userName + '<br>' +
        '<div style="font-size:14px;">' + _arr[0] + '</div><div style="font-size:14px;">' + _arr[1] + '</div>');
    }
    else {
      $("#subSysIdPart").html(userInfos.userId + "&nbsp;" + userInfos.userName + '<br>' +
        userInfos.subSystem);
    }
    $("#subSysId")
      .append("<small><div style='float:left;margin-right:10px;font-family: STSongti-SC-Regular;font-size: 14px;color: #69727A;letter-spacing: 0;'>会话标记:</div><p style='font-size:11px;margin-bottom:0px;'>" + userInfos.userSessionId + "</p></small>")
      .append("<small><div style='float:left;margin-right:10px;font-family: STSongti-SC-Regular;font-size: 14px;color: #69727A;letter-spacing: 0;'>登录时间:</div>" + y + "年" + m + "月" + d + "日" + " " + userInfos.loginTime + "</small>")
      .append("<small><div style='float:left;margin-right:10px;font-family: STSongti-SC-Regular;font-size: 14px;color: #69727A;letter-spacing: 0;'>在线时间:</div><label id='hours'></label>小时<label id='minutes'></label>分钟<label id='seconds'></label>秒</small>");
    getLoginTime();
    var interval = setInterval(getLoginTime, 1000);
    window.isGetLoginMsg = true;

    $(".user.user-menu>ul.dropdown-menu>li.user-header").on("click", function (e) {
      e.preventDefault();
      e.stopPropagation();
    });

  }
}

window.getLoginTime = function () {
  var myDate = new Date();
  var y = userInfos.loginDate.getFullYear();
  var m = userInfos.loginDate.getMonth() + 1;
  var d = userInfos.loginDate.getDate();
  var logDate = y + '-' + m + '-' + d + ' ' + userInfos.loginTime;
  logDate = new Date(logDate);
  var time = myDate.getTime() - logDate.getTime();
  var hours = parseInt((time % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
  var minutes = parseInt((time % (1000 * 60 * 60)) / (1000 * 60));
  var seconds = parseInt((time % (1000 * 60)) / 1000);
  $("#hours").html(hours);
  $("#minutes").html(minutes);
  $("#seconds").html(seconds);
}

window.showQueryForm = function () {

  $("#queryFormDiv").load("query/queryForm.html");

}



window.showExportModal = function () {
  $("#exportModal").load('export/export.html');
}

window.listMainMenuState = function () {
  if ($("#listMainMenu").hasClass('listMainMenuShow')) {
    $('.main-header').css('top', '0');
    $('.main-sidebar').css('top', '0');

    if (window.userSettingEntry.showLeftListMenu == true) {
      if (window.userSettingEntry.hideToolBar == true) {
        $(".listtree-sidebar").css('top', '0px');
        $('.content-wrapper').css('top', '0px');
      }
      else {
        $(".listtree-sidebar").css('top', '42px');
        $('.content-wrapper').css('top', '42px');
      }
    }
    else {
      $('.content-wrapper').css('padding-top', '42px');
    }

    $("#listMainMenu").removeClass('listMainMenuShow').hide();
    $("#toolMenuControl>i.menuControl-i").removeClass('fa-long-arrow-up').addClass('fa-long-arrow-down');
  }
  else {
    $('.main-header').css('top', '30px');
    $('.main-sidebar').css('top', '30px');

    if (window.userSettingEntry.showLeftListMenu == true) {
      if (window.userSettingEntry.hideToolBar == true) {
        $(".listtree-sidebar").css('top', '30px');
        $('.content-wrapper').css('top', '30px');
      }
      else {
        $(".listtree-sidebar").css('top', '80px');
        $('.content-wrapper').css('top', '80px');
      }
    }
    else {
      $('.content-wrapper').css('padding-top', '80px');
    }

    $("#listMainMenu").addClass('listMainMenuShow').show();
    $("#toolMenuControl>i.menuControl-i").removeClass('fa-long-arrow-down').addClass('fa-long-arrow-up');
  }
}

window.logOut = function () {
  var command = Command.createService(
    "gongqi.erp.framework.services.UserSessionService",
    "logout",
    "void"
  );
  var _resultHandler = function (data) {
    window.location.href = loginPath;  
  };
  var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
  ServiceHelper.addTokenWithCommand(remoteArg);
}
var dataSetGlobalId = 0;
window.dataSettingClick = function (e) {
  var dataSetId = $(e.target).attr("data-SetId");
  var menuLabel = $(e.target).attr("data-menuLabel");
  var dataSetUniqueId = $(e.target).attr("data-SetUniqueId");
  if (!dataSetId) {
    dataSetId = $(e.target).parent().attr("data-SetId");
    menuLabel = $(e.target).parent().attr("data-menuLabel");
    dataSetUniqueId = $(e.target).parent().attr("data-SetUniqueId");
  }


  let _args = { label: menuLabel, formId: "DataSetForm", menuItemId: "DataSetmMenuItem_"+(++dataSetGlobalId), fixedUrl: "dsform.html?dataSetId=" + dataSetId + "&dataSetUid=" + dataSetUniqueId };
  testOpenForm(_args);
  return;


  if (!window.dataSetCache)
    window.dataSetCache = {};

  if (window.dataSetCache.hasOwnProperty(dataSetId)) {
    let _args = { label: menuLabel, formId: "DataSetForm", menuItemId: "DataSetmMenuItem", fixedUrl: "dsform.html?dataSetId=" + dataSetId + "&dataSetUid=" + dataSetUniqueId };
    testOpenForm(_args);
    return;
  }

  var command = Command.createService(
    "gongqi.erp.gotmodel.services.UserSettingService",
    "loadUserDataSet",
    "String"
  );

  //command.appendArg(window.userInfos.userId);
  command.appendArg("zyf");
  command.appendArg(dataSetId);

  ServiceHelper.addTokenWithCommand({
    command: command, resultFunction:
      function (event) {
        var datasetstr = event.result;
        let dataset = JSON.parse(datasetstr);
        window.dataSetCache[dataSetId] = dataset;
        //打开dsform页面
        var args = { label: menuLabel, formId: "DataSetForm", menuItemId: "DataSetmMenuItem", fixedUrl: "dsform.html?dataSetId=" + dataSetId + "&dataSetUid=" + dataSetUniqueId }
        testOpenForm(args);
        return;

        delete dataset.setRows;
        delete dataset.query;

        var command = Command.createService(
          "gongqi.erp.layers.sys.services.ExportService",
          "exportExcel",
          "String"
        );

        command.appendArg(datasetstr);

        ServiceHelper.addTokenWithCommand({
          command: command, resultFunction: function (data) {
            if (data) {
              var commandTask = new CommandTask();
              commandTask.cmd = Cmd.FileDownload;
              commandTask.arg = data.result;
              CommandResolver.downLoad(commandTask, null);
            }
          }
        });
      }
  });
}

window.rightSidebarClick = function () {
  if (window.rightSidebarClicked)
    return;

  var command = Command.createService(
    "gongqi.erp.gotmodel.services.UserSettingService",
    "loadUserDataSetSetting",
    "String"
  );
  var _resultHandler = function (data) {

    let dataSettings = data.result;
    if (!dataSettings) {
      return;
    }
    dataSettings = JSON.parse(dataSettings);

    /**
     * <li>
          <a href="javascript:void(0)" style="padding-top: 0px;">
            <h6 class="control-sidebar-heading" style="font-size:14px;cursor:pointer;margin-top: 0px;">9点前打卡次数</h6>
          </a>
       </li>
    */
    window.userDataSettings = dataSettings;
    for (let i = 0; i < dataSettings.length; i++) {
      let ds = dataSettings[i];
      let $h6 = $("<h6 class='control-sidebar-heading' style='font-size:14px;cursor:pointer;margin-top: 0px;'></h6>").html(ds.menuLabel);
      let $a = $("<a  style='padding-top: 0px;'>").attr("dataSetId", ds.dataSetId)
        .attr("menuLabel", ds.menuLabel).attr("dataSetUniqueId", ds.recId).append($h6)
        .click(window.dataSettingClick);
      $("#control-sidebar-home-tab .control-sidebar-menu").append(
        $("<li>").append($a)
      );
    }
    window.rightSidebarClicked = true;
  };
  var remoteArg = {
    command: command, resultFunction: _resultHandler,
    faultFunction: function () { },
    sync: false
  };
  ServiceHelper.addTokenWithCommand(remoteArg);
}


window.changePassword = function () {
  var orgPwd = $('#orgPwd').val();
  var newPwd = $('#newPwd').val();
  var finPwd = $('#finPwd').val();
  if (newPwd == '') {
    alert('请填写新密码！');
    return false;
  }
  if (newPwd != finPwd) {
    alert('两次输入的新密码不一致！');
    return false;
  }
  var command = Command.createService(
    "gongqi.erp.gotmodel.services.MixedService",
    "changePassword",
    "boolean"
  );
  command.appendArg(userInfos.userId);
  command.appendArg(orgPwd);
  command.appendArg(finPwd);
  var _resultHandler = function (data) {
    alert('密码修改成功！');
    $('#orgPwd').val('');
    $('#newPwd').val('');
    $('#finPwd').val('');
    $("#passwordModal").hide();
  };
  var remoteArg = { command: command, resultFunction: _resultHandler, sync: false };
  ServiceHelper.addTokenWithCommand(remoteArg);

  var data ={
    'dataArea':'dynamic',
    'userId':window.userInfos.userId,
    'userName':window.userInfos.userName,
    'clientSessionId':window.userInfos.userSessionId,
    'dateTime':new Date().getTime()+'',
    'operationId':'009',
    'formId':'',
    'formDataSourceName':'',
    'formItemName':'',
    'remark':''
  };
  window.setOperate(data);
}

window.updateAttachmentNum = function (num) {
  if (num > 9)
    num = "9+";
  $("#attachmentNum").html(num);
  $("#attachmentNum2").html(num);
  if(num ==0){
    $("#attachmentNum").css('display','none');
    $("#attachmentNum2").css('display','none');
  }
}

window.reInitForm = function () {
  var popIframes = $("#formModal iframe");
  if (popIframes.length > 0) {
    iframe = popIframes.get(popIframes.length - 1);
    win = iframe.window || iframe.contentWindow;
    if (win && typeof (win.reInit) == "function") {
      win.reInit();
    }
    return;
  }

  var arr = $("#g_tab_content>div.tab-pane.active iframe");
  if (arr.length > 0) {
    var iframe = arr.get(0);
    var win = iframe.window || iframe.contentWindow;
    if (win && typeof (win.reInit) == "function") {
      win.reInit();
    }
  }
}

window.reInitGlobal = function () {
  var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", "reInitGOT", "byte[]");
  command.appendArg("false", "boolean");
  var remoteArg = { command: command, resultFunction: rpc_result_reInitGlobal, sync: false, lockText: "正在全局初始化 请稍后..." };
  ServiceHelper.addTokenWithCommand(remoteArg);
}

window.rpc_result_reInitGlobal = function (data) {
  window.location.reload();
}

window.reInitAPP = function () {
  /*let list = ["生产","采购","销售222222222222222222"];
  $("#globalUserSetFormDiv").css("display", "flex");
  ReactDOM.render(<ReInitAPPComponent appList={list}/>,document.getElementById('globalUserSetFormDiv'));
  return;*/
  var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", "getInitSolutions", "List");

  var remoteArg = {
    command: command,
    resultFunction: window.rpc_result_getAppList,
    sync: false
  }
  ServiceHelper.addTokenWithCommand(remoteArg);
}

window.rpc_result_getAppList = function (data) {
  let list = data.result;
  $("#globalUserSetFormDiv").css("display", "flex");
  ReactDOM.render(<ReInitAPPComponent appList={list} />, document.getElementById('globalUserSetFormDiv'));
}

window.importManager = function () {
  FormLoadHelper.openMenuItemByAuthority({ menuItemId: "50000016", popUp: false });
}
window.showUniversalViewSet = function(){
  FormLoadHelper.openMenuItemByAuthority({ menuItemId: "50000034", popUp: false });
}

window.showUniversalView = function () {
  let userId = window.userInfos.userId;
  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
  var iframe = $("<iframe>").css("border", "none").attr("id", "iframeUniversalViewForm").css("width", "100%").css("height", "100%").css("background", "none");
  iframe.attr("src", "universalView.html?userId=" + userId);
  $("#universalModal").append(modalDiv.append(iframe));

  let remark ={"title":'打开万能视图查询器'}
  var data ={
    'dataArea':'dynamic',
    'userId':window.userInfos.userId,
    'userName':window.userInfos.userName,
    'clientSessionId':window.userInfos.userSessionId,
    'dateTime':new Date().getTime()+'',
    'operationId':'015',
    'formId':'',
    'formDataSourceName':'',
    'formItemName':'',
    'remark':JSON.stringify(remark)
  };
  window.setOperate(data);

}

window.showUniversalViewByForm = function()
{
  let currentWin = window.getCurrentWin();
  if(!currentWin)return;
  if(!currentWin.isDataSetView)
  {
    Warning.show({text:"当前页面不是数据集关联页面"});return;
  }
  let userId = window.userInfos.userId;
  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
  var iframe = $("<iframe>").css("border", "none").attr("id", "iframeUniversalViewForm").css("width", "100%").css("height", "100%").css("background", "none");
  iframe.attr("src", "universalView.html?userId=" + userId + "&dataSetId="+ currentWin.formId);
  $("#universalModal").append(modalDiv.append(iframe));

  let remark ={"title":'打开万能视图查询器'}
  var data ={
    'dataArea':'dynamic',
    'userId':window.userInfos.userId,
    'userName':window.userInfos.userName,
    'clientSessionId':window.userInfos.userSessionId,
    'dateTime':new Date().getTime()+'',
    'operationId':'015',
    'formId':'',
    'formDataSourceName':'',
    'formItemName':'',
    'remark':JSON.stringify(remark)
  };
  window.setOperate(data);
}

window.fromOSopenDataSetViewes = function(){
  var fileName = window.formOSopenDataSetViewId;
  var userId = window.userInfos.userId;
  var domain = window.didomain;
  var url = window.osUrl+"/manage/dataSetLoadOnePer";
  let _headers = {};
  if(!window.loginToken)
  {
    let _token = localStorage.getItem("userToken");
    if (_token)
    _headers.token = _token;
  }
  var that = this;
  $.ajax({
    type:'get',
    url:url,
    dataType:"json",
    data:{
      userId:userId,
      doMain:domain,
      datasetId:fileName
    },
    headers: _headers,
    sync:true, 
    xhrFields:{withCredentials:true},
    success:function(data){
      if(data.code ==0  ){
        let datar = JSON.parse(data.result);
        if(!datar.content){
          let text = "当前用户无使用权限";
          var options = {state: 'error',text:text};
          Fade.show(options);
        }
        var content = JSON.parse(datar.content);
        content.fileName= fileName;
        var queryTableUtil = new QueryTableUtil();
        queryTableUtil.getQueryTableParams(content.queryTable)
        var  tables = queryTableUtil.doMainTables;
        let domains = new Set();
        for(let inx in tables){
          if(window.didomain != tables[inx].doMain){
            domains.add(tables[inx].doMain);
          }
        }
        domains.forEach(function (element, sameElement, set) {
          window.initDoMainGotTable(element);
        })
        let _header = {"Content-type":"application/json"};
        if(!window.parent.window.loginToken)
        {
          let _token = localStorage.getItem("userToken");
          if (_token){
            _header.token = _token;
          }else{
            _header.token = window.parent.window.localStorage.getItem("userToken");
          }
        }	
        var param = {
          "queryTable":content,
          }; 
        $.ajax({
          type:'post',
          url:window.osUrl+"/"+"MIX"+"/web/apps/gongqi.tool.datasetDesign/dsDesign/getDirectGotTable",
          dataType:"json",
          headers: _headers,
          data:JSON.stringify(param),
          headers: _header,
          xhrFields:{withCredentials:true},
          success:function(data){
            if(data.errcode == 0){
              var con = data.content;
              for(let i in con){
                for(let k in con[i]){
                  window.got.DataDictionary.Tables[k]=con[i][k];
                }
              }
              var res ={"result":content};
              window.rpc_result_reInitDataSetView(res);
            }
          },
          error:function(data){

          }
        })
      }else{
        let text = data.errmsg?data.message:"加载失败";
        var options = {state: 'error',text:text};
        Fade.show(options);
      }
    },	
    error:function(data){

    }
  })
}

window.initDoMainGotTable = function(doMain){
  var url =window.osUrl+"/GongqiERP/"+doMain+"/ServiceController";
  var command = Command.createService("gongqi.erp.gotmodel.services.GOTService", "getGOT", "byte[]");
  var remoteArg = { command: command, resultFunction: window.gotDoMainSuccessHandler, sync: true,url: url,domain:doMain};
  ServiceHelper.addTokenWithCommand2(remoteArg);
}

window.gotDoMainSuccessHandler = function(data,domain){
  if(data.status == 0){
    let compressedByteArray = base64js.toByteArray(data.result);
    let s = pako.inflate(compressedByteArray, { to: 'string' });
    let got = JSON.parse(s);
    if(!window.doMainGot){
      window.doMainGot=[];
    }
    window.doMainGot.push({'doMain':domain,'got':got,'direct':false,'shortName':""});
    for(let key in got.DataDictionary.Tables){
      window.got.DataDictionary.Tables[key] = got.DataDictionary.Tables[key];
    }
    for(let key1 in got.DataDictionary.DataTypes){
      window.got.DataDictionary.DataTypes[key1] = got.DataDictionary.DataTypes[key1];
    }
    for(let key2 in got.DataDictionary.Enums){
      window.got.DataDictionary.Enums[key2] = got.DataDictionary.Enums[key2];
    }
  }
}


window.rpc_result_reInitDataSetView = function (data) {
  var args = {
    fixedUrl:"dsform.html?popUp=true&isPreview=true",
    formId:"DataSetForm",
    label:"预览",menuItemId:"DataSetmMenuItemYL_2",
    popUp:true,
    isDataSetPreview:true,
  }
  var dataset = data.result;
  var dataSetRes = {
    formObjectStandard:{formNodeList:[],formXML:JSON.stringify(dataset),listAggregateTable:[],listControlProperty:[],listRemoteMethods:[
      {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"beforeInit",prefetch:true},
      {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"afterInit",prefetch:true},
      {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"formClosing",prefetch:true},
      {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"formClosed",prefetch:true},
      {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"lookupRefresh",prefetch:true}
    ],
    listTmpTable:[],mapItemProperty:[],mapOverrideInners:null,mapQueryTable:{},md5:"8b04cf4ed82ddae2661d649344edda42",swf:null},
    formObjectUserSet:null,
    formPrefetchCommandResult:{commandResults:{afterInit:{tasks:[{arg:null,cmd:"executeQuery",control:null,group:"all"}]},beforeInit:{tasks:[],},formClosed:null,formClosing:null},md5:"f0b1e34c771933181212e940b8f4c3ae"},
    mapFormObjectAuthority:null,
    mapSameFormObjectAuthority:null,
    sameFormObjectStandard:false,
    sameFormObjectUserSet:false,
    sameFormPrefetchCommandResult:false
    };

  window.dataSetPreview = dataSetRes;
  window.dataSetPreviewFordataset = dataset;
  window.dataSetPreviewDataSet = DataSetUtil.strDataSet(dataset,[]);

  if(dataset.fileName && window.fromTB){
    window.pivotCacheDataSet = sessionStorage.getItem(dataset.fileName);
  }
  window.testOpenForm(args);

}

window.fromAppOpenDataSetViewes = function(domain,dataSetName,formModule){
  var userId = window.userInfos.userId;
  var fileName = dataSetName;
  var domain = window.didomain;
  window.prientAppdataSetName = dataSetName;
  let _headers = {};
  if(!window.loginToken)
  {
    let _token = localStorage.getItem("userToken");
    if (_token)
    _headers.token = _token;
  }
  var url = window.osUrl+"/manage/dataSetLoadOnePer";
  $.ajax({
    type:'get',
    url:url,
    dataType:"json",
    data:{
      doMain:domain,
      userId:userId,
      datasetId:fileName
    },
    headers: _headers,
    sync:true, 
    xhrFields:{withCredentials:true},
    success:function(data){
      if(data.code ==0  ){
        let datar = JSON.parse(data.result);
        if(!datar.content){
          let text = "当前用户无使用权限";
          var options = {state: 'error',text:text};
          Fade.show(options);
        }
        var content = JSON.parse(datar.content);
        content.fileName= fileName;
        var queryTableUtil = new QueryTableUtil();
        queryTableUtil.getQueryTableParams(content.queryTable)
        var  tables = queryTableUtil.doMainTables;
        let domains = new Set();
        for(let inx in tables){
          if(window.didomain != tables[inx].doMain){
            domains.add(tables[inx].doMain);
          }
        }
        domains.forEach(function (element, sameElement, set) {
          window.initDoMainGotTable(element);
        })


        let _header = {"Content-type":"application/json"};
        if(!window.parent.window.loginToken)
        {
          let _token = localStorage.getItem("userToken");
          if (_token){
            _header.token = _token;
          }else{
            _header.token = window.parent.window.localStorage.getItem("userToken");
          }
        }	
        var param = {
          "queryTable":content,
          }; 
        $.ajax({
          type:'post',
          url:window.osUrl+"/"+"MIX"+"/web/apps/gongqi.tool.datasetDesign/dsDesign/getDirectGotTable",
          dataType:"json",
          headers: _headers,
          data:JSON.stringify(param),
          headers: _header,
          xhrFields:{withCredentials:true},
          success:function(data){
            if(data.errcode == 0){
              var con = data.content;
              for(let i in con){
                for(let k in con[i]){
                  window.got.DataDictionary.Tables[k]=con[i][k];
                }
              }
              var args = {
                fixedUrl:"dsform.html?popUp=true&isPreview=true",
                formId:"DataSetForm",
                label:"预览",menuItemId:"DataSetmMenuItemYL_2",
                popUp:true,
                isDataSetPreview:true,
              }
              var dataSetRes = {
                formObjectStandard:{formNodeList:[],formXML:JSON.stringify(content),listAggregateTable:[],listControlProperty:[],listRemoteMethods:[
                  {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"beforeInit",prefetch:true},
                  {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"afterInit",prefetch:true},
                  {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"formClosing",prefetch:true},
                  {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"formClosed",prefetch:true},
                  {commandResult:{tasks:[]},editors:null,fetchOption:false,groups:null,joinGroup:null,methodName:"lookupRefresh",prefetch:true}
                ],
                listTmpTable:[],mapItemProperty:[],mapOverrideInners:null,mapQueryTable:{},md5:"8b04cf4ed82ddae2661d649344edda42",swf:null},
                formObjectUserSet:null,
                formPrefetchCommandResult:{commandResults:{afterInit:{tasks:[{arg:null,cmd:"executeQuery",control:null,group:"all"}]},beforeInit:{tasks:[],},formClosed:null,formClosing:null},md5:"f0b1e34c771933181212e940b8f4c3ae"},
                mapFormObjectAuthority:null,
                mapSameFormObjectAuthority:null,
                sameFormObjectStandard:false,
                sameFormObjectUserSet:false,
                sameFormPrefetchCommandResult:false
                };
            
              window.dataSetPreview = dataSetRes;
              window.printAppformModuleInstance = formModule;
              window.dataSetPreviewForPrintApp = true;
              window.testOpenForm(args);
            }
          },
          error:function(data){

          }
        })
    }else{
      let text = data.errmsg?data.message:"加载失败";
      var options = {state: 'error',text:text};
      Fade.show(options);
    }
    },	
    error:function(data){

    }
  })
}



window.jobsOpen = function () {
  // ReactDOM.render( < JobsForm / > , document.getElementById('JobsFormDiv'));
  $("#JobsFormDiv").css("display", "flex");
  window.jobsresult = [];
  $(function () {
    ReactDOM.render(<JobsForm />, document.getElementById('JobsFormDiv'));
  });
  // {/* var command: Command = Command.createService(
  //   "gongqi.erp.gotmodel.services.JobService",
  //   "jobs",
  //   "List"
  // );
  // var _resultHandler = function(data) {
  //       window.jobsresult = data.result;
  //       ReactDOM.render(<JobsForm />,document.getElementById('JobsFormDiv'));
  //       $("#JobsFormDiv").css("display","flex");
  // };
  // var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
  //   ServiceHelper.addTokenWithCommand(remoteArg); */}


}

window.showOnLineUser = function () {
  ServiceHelper.call("gongqi.erp.framework.services.UserSessionService",
    "findAllDetail", "List", window.rpc_result_getUserList, false, null
  );
}

window.showMenuSetting = function () {
  //userInfos.menuCustomObject = JSON.parse(localStorage.getItem("tempTest"));

  /*{
    customItems:{"50112317.10034":{groupId:""},"50120019.10089":{groupId:""}},
    groups:{"111":{name:"日常办公"},"111":{name:"日常办公"},"111":{name:"日常办公"},"111":{name:"日常办公"},"111":{name:"日常办公"}}//{uuid:{name:xxx}}
  };*/
  let menuCustomObject = window.userSettingEntryOrig.menuCustomObject;
  ReactDOM.render(<CustomMenu extrals={[]} menuCustomObject={menuCustomObject} />, document.getElementById('exportModal'));
}

window.rpc_result_getUserList = function (data) {
  let list = data.result;
  OnLineUser.show(list, "在线用户");
}

window.globalUserSetOpen = function () {
  $("#globalUserSetFormDiv").css("display", "flex");
  $(function () {
    ReactDOM.render(<GlobalUserSetForm />, document.getElementById('globalUserSetFormDiv'));
  });
  
  var data ={
    'dataArea':'dynamic',
    'userId':window.userInfos.userId,
    'userName':window.userInfos.userName,
    'clientSessionId':window.userInfos.userSessionId,
    'dateTime':new Date().getTime()+'',
    'operationId':'002',
    'formId':'',
    'formDataSourceName':'',
    'formItemName':'',
    'remark':''
  };
  window.setOperate(data);
}
window.sysAuthoritySetupOpen = function () {
  // alert("1");
  // window.SysmoduleListCollection =Object.assign({},window.got.MainMenu);
  // $("#sysAuthoritySetupFormDiv").css("display", "flex");
  // $(function() {
  //   ReactDOM.render(<SysaAuthoritySetupFrom />,document.getElementById('sysAuthoritySetupFormDiv'));
  // });

  $("#sysAuthoritySetupFormDiv").load('sysAuthoritySetup/sysAuthoritySetupForm.html').css("display", "flex");
}


//查找当前画面并做定位
window.globalCurrentFormFocus = function () {
  var popIframes = $("#formModal iframe");
  if (popIframes.length > 0) {
    iframe = popIframes.get(popIframes.length - 1);
    win = iframe.window || iframe.contentWindow;
    if (win && typeof (win.globalModalFormCloseToCurrent) == "function") {
      win.globalModalFormCloseToCurrent();
    }
    return;
  }

  var arr = $("#g_tab_content>div.tab-pane.active iframe");
  if (arr.length > 0) {
    var iframe = arr.get(0);
    var win = iframe.window || iframe.contentWindow;
    if (win && typeof (win.globalModalFormCloseToCurrent) == "function") {
      win.globalModalFormCloseToCurrent();
    }
  }
}

window.getCurrentIframe = function()
{
  var popIframes = $("#formModal iframe");
  if (popIframes.length > 0) {
    iframe = popIframes.get(popIframes.length - 1);
    return iframe;
  }

  var arr = $("#g_tab_content>div.tab-pane.active iframe");
  if (arr.length > 0) {
    var iframe = arr.get(0);
    return iframe;
  }
}

window.getCurrentWin = function () {
  var popIframes = $("#formModal iframe");
  if (popIframes.length > 0) {
    iframe = popIframes.get(popIframes.length - 1);
    win = iframe.window || iframe.contentWindow;
    return win;
  }

  var arr = $("#g_tab_content>div.tab-pane.active iframe");
  if (arr.length > 0) {
    var iframe = arr.get(0);
    var win = iframe.window || iframe.contentWindow;
    return win;
  }
}

//TODO
window.getCurrentWinContent = function () {
  var popIframes = $("#formModal iframe");
  if (popIframes.length > 0) {
    iframe = popIframes.get(popIframes.length - 1);
    if(iframe.src.substr(0,4) == "form"){
      win = iframe.window || iframe.contentWindow;
      return win;
    }
  }

  var arr = $("#g_tab_content>div.tab-pane.active iframe");
  if (arr.length > 0) {
    var iframe = arr.get(0);
    var win = iframe.window || iframe.contentWindow;
    return win;
  }
}

window.onGlobalKeyDown = function (e) {
  //ctrl+s
  if (e.ctrlKey && e.keyCode == 83) {
    var arr = $("#g_tab_content>div.tab-pane.active iframe");
    if (arr.length > 0) {
      var iframe = arr.get(0);
      var win = iframe.window || iframe.contentWindow;
      if (win && typeof (win.recordSave) == "function") {
        win.recordSave();
      }
    }
  }
  else if (e.ctrlKey && e.keyCode == 70) {
    var arr = $("#g_tab_content>div.tab-pane.active iframe");
    if (arr.length > 0) {
      var iframe = arr.get(0);
      var win = iframe.window || iframe.contentWindow;
      if (win && typeof (win.find) == "function") {
        win.find();
      }
    }
  }
  else if (e.ctrlKey && e.keyCode == 79) {
    window.toobarFunc(e, 'groupExport', '');
    e.preventDefault();
  }
  //Ctrl + I
  else if (e.ctrlKey && e.keyCode == 73) {
    window.toobarFunc(e, 'da', '');
    e.preventDefault();

  }
  //Ctrl + Q
  else if (e.ctrlKey && e.keyCode == 81) {
    window.toobarFunc(e, 'queryOpen', '');
    e.preventDefault();
  }
  //Ctrl + P
  else if (e.ctrlKey && e.keyCode == 80) {
    //alert("打印");
    window.toobarFunc(e, 'print', '');
    e.preventDefault();
  }
  //Ctrl + W
  else if (e.ctrlKey && e.keyCode == 69) {
    //alert("删除");
    window.toobarFunc(e, 'queryRemove', '');
    e.preventDefault();
    e.stopPropagation();
  }
  else if (e.ctrlKey && e.keyCode == 82) {
    window.toobarFunc(e, 'recordRestore', '');
    e.preventDefault();
    e.stopPropagation();
  }
  else if (e.keyCode == 27) {
    if ($("#globalUserSetFormDiv").is(":visible")) {
      let $reactComponentContainer = $("#globalUserSetFormDiv");
      ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
      $("#globalUserSetFormDiv").empty().css("display", "none");
      window.globalCurrentFormFocus();
      return;
    }

    if ($("#exportModal #customMenuModalContainer").length > 0) {
      $("#exportModal").empty();
      window.globalCurrentFormFocus();
      return;
    }

    if ($("#netWorkErrorInfoModal").is(":visible")) {
      let $reactComponentContainer = $("#netWorkErrorInfoModal");
      ReactDOM.unmountComponentAtNode($reactComponentContainer[0]);
      $("#netWorkErrorInfoModal").css("display", "none");
      window.globalCurrentFormFocus();
      return;
    }

    if ($("#passwordModal").is(":visible")) {
      $("#passwordModal").hide();
      window.globalCurrentFormFocus();
      return;
    }

    if ($("#licenseModal").is(":visible")) {
      $("#licenseModal").hide();
      window.globalCurrentFormFocus();
      return;
    }

    let globalCurrentWin = window.getCurrentWin();

    if (globalCurrentWin && globalCurrentWin.closeDialogFormIfExsist) {
      if (globalCurrentWin.closeDialogFormIfExsist())
        return;
    }

    if (globalCurrentWin && globalCurrentWin.closeAttachmentIfExsist) {
      if (globalCurrentWin.closeAttachmentIfExsist())
        return;
    }

    if (globalCurrentWin && globalCurrentWin.closeQueryFormIfExsist) {
      if (globalCurrentWin.closeQueryFormIfExsist())
        return;
    }
  }
  else {
    //alert(e.keyCode);
  }
}

window.FormsWholeObjectCache = {};

window.getFormWholeObjectStore = function (key) {
  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
    return window.FormsWholeObjectCache[key];
  }
  return null;
}

window.getFormWholeObjectCache = function (menuItemId, formId) {
  var key = menuItemId + "." + formId;
  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
    return window.FormsWholeObjectCache[key];
  }
  return null;
}

window.clearFormWholeObjectCache = function (menuItemId, formId) {
  let key = menuItemId + "." + formId;
  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
    window.FormsWholeObjectCache[key] = null;
    delete window.FormsWholeObjectCache[key];
    return true;
  }
  return false;
}

window.setFormWholeObjectCache = function (menuItemId, formId, obj) {
  var key = menuItemId + "." + formId;
  window.FormsWholeObjectCache[key] = obj;
  addFormWholeObjectData({ id: key, data: obj });
}

$('body').keydown(window.onGlobalKeyDown);


window.addDBPivotData = function (data) {
  IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name2,
    data
  );
}

window.addClientLogNetWorkErrorData = function (data) {
  IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name3,
    data
  );
}

window.getClientLogNetWorkErrorData = function (callBack) {
  IndexedDBUtil.getAllDataAndDelete(IndexedDBUtil.DB.name3,
    callBack
  );
}

window.addFormWholeObjectData = function (data) {
  IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name, data);
}

window.getFormWholeObjectDataById = function (id, callBack) {
  IndexedDBUtil.getDataById(id, IndexedDBUtil.DB.name, callBack);
}

window.initFormWholeObjectCache = function (menuItemId, formId, callBack) {
  var key = menuItemId + "." + formId;
  if (window.FormsWholeObjectCache.hasOwnProperty(key)) {
    callBack();
  }
  else {
    let _window = window;
    IndexedDBUtil.getDataById(key, IndexedDBUtil.DB.name, function (e) {
      var data = e.target.result;
      if (data)
        _window.FormsWholeObjectCache[key] = data.data;
      callBack();
    });
  }
}

window.openMessageCenter = function (e, type) {
  if(type == 'unreadedAll'){
    var arg = new CommandArg();
    var command = CommandHelper.createFormInstance("Form_SysMessageCenter", "buttonOK_ButtonMarkAll", "CommandResult");
    command.appendArg(arg, "CommandArg");

    ServiceHelper.addTokenWithCommand({
      command: command,
      sync:true,
      resultFunction: window.readunReadMessagesResultHandler
    });
  }else{
    var command = Command.createService("gongqi.erp.gotmodel.services.MixedService", "openForm", "void");
    command.appendArg(null); command.appendArg(window.userInfos.userId);
    command.appendArg(window.userInfos.userSessionId);
    command.appendArg("50000027");
    command.appendArg(type);
    // ServiceHelper.addTokenWithCommand({ command: command, resultFunction: window.readAllMessagGOT.DWINDOesResultHandler });
    ServiceHelper.addTokenWithCommand({ command: command, resultFunction: window.readAllMessagesResultHandler });
  }

}

window.readAllMessagesResultHandler = function (data) {
  if(data.result && data.result.task){
    WebSocketManager.getUnReadCounts();
    WebSocketManager.getUnReadList();
  }
}
window.readunReadMessagesResultHandler = function (data) {

}

window.openDoMainAppInfo =  function(){
  if(window.parent.window.allAppList){
    var param = {
      "version":"",
      "clientVersion":"",
      "frameworkVersion":""
    }
    for(let i in window.parent.window.allAppList){
      let appinfo = window.parent.window.allAppList[i];
      let app_Id = window.appId.replace(/[\.]/g,"_");
      if(appinfo.doMain == window.didomain && (appinfo.appId == app_Id || appinfo.appId == window.appId || appinfo.appId == app_Id+"_osdev" || appinfo.appId == window.appId+"_osdev")){
        param.version = appinfo.version;
        param.clientVersion = appinfo.clientVersion;
        param.frameworkVersion = appinfo.doMainframework;
      }
    }
    ReactDOM.render(<DoMainAppInfo param={param} />, document.getElementById('doMainAppInfoModel'));
  } 
}

window.setFirstForm = function (form) {
  window.got.DataDictionary["Forms"] = [form];
}

window.openNetWorkLogErrorLogCallBack = function (datas) {
  NetWorkErrorLog.show(datas, "网络错误日志");
}

window.openNetWorkLogErrorLog = function () {
  IndexedDBUtil.getAllData(IndexedDBUtil.DB.name3,
    window.openNetWorkLogErrorLogCallBack
  );
}

window.changeToCaculator = function () {
  $("#jqCalculatorDiv .container").removeAttr("style");
  $("#jqCalculatorDiv_titleBar").show();
  $("#jqCalculatorDiv_content_firstLine").show();
  $("#jqCalculatorDiv_content_secondLine").show();

  $("#jqCalculatorDiv #jqcalculator_multiply").show();
  $("#jqCalculatorDiv #jqcalculator_subtract").show();
  $("#jqCalculatorDiv #jqcalculator_add").show();
  $("#jqCalculatorDiv #jqcalculator_equal").show();

  $("#jqCalculatorDiv form.form-light").removeAttr("style");
  $("#jqCalculatorDiv #jqcalculator_display1").removeAttr("style");
  $("#jqCalculatorDiv #jqcalculator_display2").removeAttr("style");

  $("#jqcalculator_backspace2").hide();
}

window.changeToNumKeyBoard = function (offset1, offset2, _inputwidth, _inputheight) {

  var _gwidth = $("body").width();
  var _gheight = $("body").height();

  var _y = offset1.top + offset2.top;
  var _x = offset1.left + offset2.left;
  var _top = _y;
  var _iframeheight = 350;
  let _center = false;
  //下方屏幕放不下
  if ((_top + _iframeheight) > _gheight) {
    //上下都放不下 考虑考虑放中间
    if (_iframeheight > _y) {
      _center = true;
    }
    else//下拉框置于上方
    {
      _top = _y - _iframeheight;
    }
  }
  if (!_center) {
    var _iframewidth = 250;
    var _left = _x - ((_iframewidth - _inputwidth) / 2);
    if (_left + _iframewidth > _gwidth)
      _left = _gwidth - _iframewidth - 5;
    if (_left < 0) _left = 0;
    $("#jqCalculatorDiv .container").css({ position: 'absolute', top: _top + _inputheight + "px", left: _left + "px", width: '249px' });
  }

  $("#jqCalculatorDiv_titleBar").hide();
  $("#jqCalculatorDiv_content_firstLine").hide();
  $("#jqCalculatorDiv_content_secondLine").hide();

  $("#jqCalculatorDiv #jqcalculator_multiply").hide();
  $("#jqCalculatorDiv #jqcalculator_subtract").hide();
  $("#jqCalculatorDiv #jqcalculator_add").hide();
  $("#jqCalculatorDiv #jqcalculator_equal").hide();

  $("#jqCalculatorDiv form.form-light").css("width", "222px");
  $("#jqCalculatorDiv #jqcalculator_display1").css("width", "222px").css("height", "20px");
  $("#jqCalculatorDiv #jqcalculator_display2").css("width", "222px");

  $("#jqcalculator_backspace2").show();

}

window.showNumKeyBoard = function (value, offset1, offset2, _inputwidth, _inputheight, callback) {
  window.cacResultCallBack = callback;
  changeToNumKeyBoard(offset1, offset2, _inputwidth, _inputheight);
  if (value == "clear") {
    jqcalculator_display1.operation = "",
      jqcalculator_display1.evaluation = "",
      $('#jqcalculator_display1').val("");
    $('#jqcalculator_display2').val("");
  }
  else {
    $("#jqcalculator_display1").val(value);
  }
  $("#jqCalculatorDiv").css("display", "flex");
}

window.showCaculator = function (value, callback) {
  window.cacResultCallBack = callback;
  changeToCaculator();
  if (value == "clear") {
    jqcalculator_display1.operation = "",
      jqcalculator_display1.evaluation = "",
      $('#jqcalculator_display1').val("");
    $('#jqcalculator_display2').val("");
  }
  else {
    $("#jqcalculator_display1").val(value);
  }
  $("#jqCalculatorDiv").css("display", "flex");
}

window.closeCaculator = function (e) {
  $("#jqCalculatorDiv").css("display", "none");
  if (window.cacResultCallBack && typeof (window.cacResultCallBack) == "function") {
    window.cacResultCallBack(null);
  }
  window.cacResultCallBack = null;
}

window.returnCacResult = function () {
  if (window.cacResultCallBack && typeof (window.cacResultCallBack) == "function") {
    var result = $("#jqcalculator_display2").val();
    if (!result)
      result = $("#jqcalculator_display1").val();
    window.cacResultCallBack(result);
    window.cacResultCallBack = null;
  }
  $("#jqCalculatorDiv").css("display", "none");
}

window.delay500backforward = function () {
  let scrollLeft = $("#g_nav_tabs").scrollLeft();
  if (!scrollLeft) scrollLeft = 0;
  $("#g_nav_tabs").scrollLeft(scrollLeft - 5);
  let _id = setTimeout(function () {
    clearTimeout(_id);
    if (window.tabs_forward_pressing == true) {
      window.delay500backforward();
    }

  }, 10);
}

window.delay500forward = function () {
  let scrollLeft = $("#g_nav_tabs").scrollLeft();
  if (!scrollLeft) scrollLeft = 0;
  $("#g_nav_tabs").scrollLeft(scrollLeft + 5);
  let _id = setTimeout(function () {
    clearTimeout(_id);
    if (window.tabs_forward_pressing == true) {
      window.delay500forward();
    }

  }, 10);
}

window.g_navtabs_backforward = function () {
  let scrollLeft = $("#g_nav_tabs").scrollLeft();
  if (!scrollLeft) scrollLeft = 0;
  $("#g_nav_tabs").scrollLeft(scrollLeft - 10);

  $('body').one("mouseup", function () {

    window.tabs_forward_pressing = false;

  });
  window.tabs_forward_pressing = true;

  let _id = setTimeout(function () {
    clearTimeout(_id);
    if (window.tabs_forward_pressing == true) {
      window.delay500backforward();
    }

  }, 500);

}

window.g_navtabs_forward = function () {
  let scrollLeft = $("#g_nav_tabs").scrollLeft();
  if (!scrollLeft) scrollLeft = 0;
  $("#g_nav_tabs").scrollLeft(scrollLeft + 10);

  $('body').one("mouseup", function () {

    window.tabs_forward_pressing = false;

  });
  window.tabs_forward_pressing = true;

  let _id = setTimeout(function () {
    clearTimeout(_id);
    if (window.tabs_forward_pressing == true) {
      window.delay500forward();
    }

  }, 500);
}

window.g_nav_tabs_childChanges = function (e) {
  let removeChild = false;
  if (e && e.data && e.data.removeChild == true)
    removeChild = true;
  let element = document.getElementById("g_nav_tabs");
  let _scrollWidth = $("#g_nav_tabs").outerWidth(true);
  if (removeChild)
    _scrollWidth += ($(e.target).width());
  if (element.scrollWidth > _scrollWidth) {
    if(window.userSettingEntry.showToolMenu == true){
      $("#g_nav_tabs").css({ marginLeft: '20px', marginRight: '20px' });
    }else{
      $("#g_nav_tabs").css({ marginLeft: '50px', marginRight: '20px' });
    }
    $("#g_nav_tabs_backforward").show();
    $("#g_nav_tabs_forward").show();
  }
  else {
    if(window.userSettingEntry.showToolMenu == true){
      $("#g_nav_tabs").css({ marginLeft: '0px', marginRight: '0px' });
    }else{
      $("#g_nav_tabs").css({ marginLeft: '30px', marginRight: '0px' });
    }
    $("#g_nav_tabs_backforward").hide();
    $("#g_nav_tabs_forward").hide();
  }
}

$("#g_nav_tabs").bind("DOMNodeInserted", g_nav_tabs_childChanges);
$("#g_nav_tabs").bind("DOMNodeRemoved", { removeChild: true }, g_nav_tabs_childChanges);

Date.prototype.Format = function (fmt) {
  var o = {
    "M+": this.getMonth() + 1, //月份
    "d+": this.getDate(), //日
    "h+": this.getHours(), //小时
    "m+": this.getMinutes(), //分
    "s+": this.getSeconds(), //秒
    "q+": Math.floor((this.getMonth() + 3) / 3), //季度
    "S": this.getMilliseconds() //毫秒
  };
  if (/(y+)/.test(fmt)) fmt = fmt.replace(RegExp.$1, (this.getFullYear() + "").substr(4 - RegExp.$1.length));
  for (var k in o)
    if (new RegExp("(" + k + ")").test(fmt)) fmt = fmt.replace(RegExp.$1, (RegExp.$1.length == 1) ? (o[k]) : (("00" + o[k]).substr(("" + o[k]).length)));
  return fmt;
}

$('body').contextPopup({});

document.body.ondragstart = function (e) {
  //二级弹出页面拖动
  if ($(e.target).parent().hasClass("modal-header"))
    return true;
  if ($(e.target).hasClass("ui-draggable"))
    return true;
  if ($.contains(document.getElementById("g_nav_tabs"), e.target))//如果拖动的是全局标签页
    return true;
  return false;
}
//didomain有两种情况 一种是操作系统 一种是通过操作系统在域里自动登录
//总共有三种情况 一种是操作系统 一种是单体应用 一种是在操作系统环境中使用工位机 
//操作系统 有didomain 没有loginToken 需要hook  单体应用 没有domain不需要hook 工位机 都有 不需要hook
try {
  if (window.didomain && !loginToken && !loginDataArea) 
  {
    HookUtil.hookAJAX();
    HookUtil.hookOpen();
    HookUtil.hookImg();
    $("#indexLoginDiv").hide();
    $("#mainFooterId").css("display","none");
    $("#contentWrapper").css("bottom","0px");
    $("#messagesSuccess").removeAttr("style");
    var node = document.getElementById("messagesSuccess");

    // $("#indexRightSideBar").removeAttr("style");
    let appInfo = sessionStorage.getItem("appInfo");
    appInfo = JSON.parse(appInfo)
    let applabel = appInfo['label']
    let appDoMain = sessionStorage.getItem('doMainInfo')?sessionStorage.getItem('doMainInfo'):"";
    appDoMain = appDoMain.replace(/\"/g, "")
    let appIcon = appInfo['icon'];
    let imgReg = /<img.*?(?:>|\/>)/gi //匹配图片中的img标签
    let srcReg = /src=[\'\"]?([^\'\"]*)[\'\"]?/i // 匹配图片中的src
    let arr = appIcon.match(imgReg)  //筛选出所有的img
    let srcArr = []
    for (let i = 0; i < arr.length; i++) {
      let src = arr[i].match(srcReg)
        // 获取图片地址
      srcArr.push(src[1])
    }
    var titlearea ="";
    if(srcArr && srcArr[0].indexOf("default.png") != -1){
      appIcon = "<div class='winui-icon winui-icon-img' ><img src='/osweb/appIcons/img/gongqi.tool.datasetDesign.png'></img></div>";
    }
    if(!window.formOSopenDataSetView && srcArr.length > 0){
      //titlearea ="<div style='width: 30%;height: 80%;background-size: cover;background-image:url("+srcArr[0]+")'></div>"+"<div style='display: flex;align-items: center;'><span style='font-size: 1.4rem;color: #000;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;margin-left:10px'>"+applabel+"</span></div>";
      titlearea ="<div style='display: flex; padding-left: 10px;align-items: center;'>"+
      "<span class='appSpan' style='text-align: start;font-size: 1.4rem;color: white;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;margin-left:5px;font-weight: 400;width:80px' title="+applabel+">"+applabel+"</span>"+"</div>"+
      "<div style='display: flex;width: 100%;align-items: center;justify-content: flex-end;padding-right: 10px;'>"+
      "<span class='doMainSpan' style='padding-top:2px;font-size:0.5rem;color:#eae4e4db;overflow: hidden;text-overflow: ellipsis;width: 65px;height: 50px;white-space:nowrap;' title="+appDoMain+">"+appDoMain+"</span>"+
      "<div title='点此查看版本信息' style='display: flex; padding-top:4px;align-items: center;margin-Left:5px;cursor: pointer;' class='winui-icon ' onClick='openDoMainAppInfo(event)' ><i class='iconfont icon-xinxi' style='color:white'></i></div>"
      "</div>"
      ;
    }
    if(titlearea){
      window.titlearea=titlearea
      window.appIcon=appIcon
      window.applabel=applabel
      window.appDoMain=appDoMain
    };
    $("#g_title_area").html(titlearea);

    let tabsClass =  $('#g_nav_tabs').attr('class');
    if(tabsClass.indexOf('OSNav_tabs')== -1){
      $('#g_nav_tabs').addClass('OSNav_tabs');
    }
    $("#g_main_header").mousedown(function(e){
      if($(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin')[0] !=null){
        window.mainHeaderisDown = false
        return;
      }
      window.mainHeaderisDown = true
      window.mainHeadermoveLocation = {
        x: e.clientX,
        y: e.clientY
      }
    });
    $("#g_main_header").mouseup(function(e){
      window.mainHeaderisDown = false
    });
    $("#g_main_header").mousemove(function(e){
      if($(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin')[0] !=null){
        return;
      }
      if (window.mainHeaderisDown) {
        let newappId = window.appId.replaceAll(".","_");
        let domain_appId =window.didomain+"-"+newappId;
        let layer = window.parent.document.getElementById(domain_appId).parentNode
        let layerTop = Number(layer.style.top.split('px')[0]) 
        let layerLeft;
        if(layer.style.left.indexOf("%") != -1){
          layerLeft = window.parent.document.body.offsetWidth*Number(layer.style.left.split('%')[0])/100;
        }else if(layer.style.left.indexOf("px") != -1){
           layerLeft = Number(layer.style.left.split('px')[0])
        }
        let x = layerLeft + (e.clientX - window.mainHeadermoveLocation.x)
        let y = layerTop + (e.clientY - window.mainHeadermoveLocation.y)
        if (layerTop <= 0 && y <= 0) {
          layer.style.left = x + 'px'
        } else {
          layer.style.top = y + 'px'
          layer.style.left = x + 'px'
        }
      }
    });
    $("#g_main_header").mouseleave(function(e){
      window.mainHeaderisDown = false
    });

  }
}
catch (e) { }



window.measureNetDownSpeed = function (e) {
  return navigator.connection.downlink * 1024 / 8;   //单位为KB/sec
}

setInterval(function (e) {

  $("#netDownLoadSpeed").text("网络下载速度:" + measureNetDownSpeed() + "KB/秒");

}, 5000);

window.netSpeedTest = function (e) {
  FormLoadHelper.openHtml('./netspeedtest/index.html', "");
}

window.showPerformanceTiming = function(e){
  let userId = window.userInfos.userId;
  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
  var iframe = $("<iframe>").css("border", "none").attr("id", "iframePerformanceTimingForm").css("width", "100%").css("height", "100%").css("background", "none");
  iframe.attr("src", "./externals/performanceTiming/PerformanceTimingView.html?userId=" + userId);
  $("#performanceTimingModel").append(modalDiv.append(iframe));
};
window.showPerformanceMemory = function(e){
  let userId = window.userInfos.userId;
  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
  var iframe = $("<iframe>").css("border", "none").attr("id", "iframePerformanceMemoryForm").css("width", "100%").css("height", "100%").css("background", "none");
  iframe.attr("src", "./externals/performanceTiming/PerformanceMemoryView.html?userId=" + userId);
  $("#performanceMemoryModel").append(modalDiv.append(iframe));
};
window.showPerformanceResource = function(e){
  let userId = window.userInfos.userId;
  var modalDiv = $("<div>").addClass("modal").css("display", "flex").css("z-index", "1049").css("align-items", "center").css("justify-content", "center");
  var iframe = $("<iframe>").css("border", "none").attr("id", "iframePerformanceResourceForm").css("width", "100%").css("height", "100%").css("background", "none");
  iframe.attr("src", "./externals/performanceTiming/PerformanceHttpRequest.html?userId=" + userId);
  $("#performanceResourceModel").append(modalDiv.append(iframe));
};

window.treeViewMainMenuKeyDownHandler = function(e)
{
  if(e.keyCode == 13)
  {
    e.preventDefault();
  }
}

window.addIndexedDBData = function(data)
{
  IndexedDBUtil.addData(IndexedDBUtil.DB.db, IndexedDBUtil.DB.name4,data);
	
}



/////////////////////////////////////////////////////////////
var allMenuLength;
var testAllMenuNumTag = 0;
window.testOpenAllWindowAndDelayClose = function()
{
  var menuItemList = [];
  listAllMenuItem(window.got.MainMenu,menuItemList);
  allMenuLength = menuItemList.length;
  window.openAllMenuItem(menuItemList);
}

window.openAllMenuItem = function(menuItemList)
{
  if(testAllMenuNumTag>=allMenuLength||testAllMenuNumTag>=30)
  {
    closeAllMenuItem();
    testAllMenuNumTag = 0;
    return;
  }
    
  let menuItem = menuItemList[testAllMenuNumTag];
  let label = menuItem.Properties.Label.V?menuItem.Properties.Label.V:menuItem.name;
  FormLoadHelper.openMenuItem({menuItemId:menuItem.id,label:label,checkHas:true,fromMainMenu:true});
    
  testAllMenuNumTag++;
  var _id = setTimeout(
    function()
    {
      clearTimeout(_id);
      window.openAllMenuItem(menuItemList);

    },10000
  );
}
window.listAllMenuItem = function(menu,menuItemList)
{
  if(menu.qname == "MenuItem")
  {
    menuItemList.push(menu);
  }
  if(menu.items)
  {
    for(let i = 0;i<menu.items.length;i++)
    {
      let subItem = menu.items[i];
      listAllMenuItem(subItem,menuItemList);
    }
  }
}

window.closeAllMenuItem = function()
{
  window.closeAllForm();
}


setInterval(function(){
  if(window.formOSopenDataSetViewId){
    return;
  }
  PerformanceTiming.deletePerformeTiming();
 },300000)


 window.performanceData = {'tim':[],'mem':[]};
 
 setInterval(function(){
  if(window.formOSopenDataSetViewId){
    return;
  }
  PerformanceTiming.sendTimingAndMemoryToServer(performanceData['tim'],performanceData['mem'])
 },120000)
//module.exports.testlayer = function(){alert('222')};


//Warning.show({text:"您现在使用的是任务系统 飞速体验版",state:"info"})

window.onePrintReropt=function(e){
  if(!e)return;
  let id = $(e.target).attr("taskid");
  let reid = $(e.target).attr("reportid");
  if(!id){
    id = $(e.target)[0].parentElement.attributes[1].value
    reid = $(e.target)[0].parentElement.attributes[2].value
  }
  if(id && reid){
    var command = Command.createService("gongqi.erp.layers.sys.services.PrintService", "preparePrint", "CommandResult");
    command.appendArg(id);
    command.appendArg(reid);
    var remoteArg = { command: command, resultFunction: window.rpc_doPrintReportSuccess, faultFunction: window.rpc_doPrintReportError, sync: false };
    ServiceHelper.addTokenWithCommand(remoteArg)
    window.printReportTaskId = id;
  }
}

window.dropPrintReport=function(task,formModule){
  $('#toolbarPrintLi .dropdown-menu').remove();
  let _content="<li style='line-height: 25px; display: flex;justify-content: flex-start;font-size: 12px;border-bottom: 1px solid rgb(205,205,205);padding-left: 12px;'>报表方案</li>";
  if(task.arg && task.arg.reportList.length >= 1){
    for(let i in task.arg.reportList){
      _content=_content+" <li style=' display: flex;justify-content: flex-start;'>"+
      "<a style='width:100%' onclick='onePrintReropt(event)' taskId="+task.arg.printTaskId+" reportId="+task.arg.reportList[i]['id']+">"+
        "<i class='iconfont icon-fangan3'></i>"+
        "<span class='menubtnLable' title="+task.arg.reportList[i]['name']+">"+ task.arg.reportList[i]['name']+"</span>"+
      "</a>"+
    "</li>"
    }
    if($('#toolbarPrintLi .dropdown-menu').length==0){
      let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarPrintLiDrop');
      let aHeight=$('#toolbar_print').outerHeight()+1.5;
      menuDrop.css({top:aHeight});
      let liDrop = $("<li >");
      let menuDrop2 = $("<ul>").addClass('menu').html(_content);
      $('#toolbarPrintLi').append(menuDrop.append(liDrop.append(menuDrop2)));
    }else{
      $('#toolbarPrintLi .dropdown-menu').remove();
      $('#toolbarPrintLi').append(menuDrop.append(liDrop.append(menuDrop2)));
    }
  }else{
    let aHeight=$('#toolbar_print').outerHeight()+1.5;
    let menuDrop = $("<ul>").addClass('dropdown-menu').css({
      display:'flex',
      justifyContent: 'center',
      alignItems: 'center',
      top:aHeight
    }).attr('id','toolbarPrintLiDrop');
    let liDrop = $("<span>").css('color','gray').html('暂无数据');
    let menuDrop2 = $("<ul>").addClass('menu');
    $('#toolbarPrintLi').append(menuDrop.append(_content).append(liDrop.append(menuDrop2)));
  }
  $('#toolbarPrintLi .dropdown-menu').show();
  if(window.toolPrintDrop){
    window.toolPrintDrop=false;
  }else{
    window.toolPrintDrop=true;
  }
}
window.dropPrintReportError=function(data){
  $('#toolbarPrintLi .dropdown-menu').remove();
  let _content="<li style='line-height: 25px; display: flex;justify-content: flex-start;font-size: 12px;border-bottom: 1px solid rgb(205,205,205);padding-left: 12px;'>报表方案</li>";

  let aHeight = $("#toolbar_print").outerHeight(); 
  if($('#toolbar_print').hasClass("toolbarBig"))
  {
    let innerDivHeight = $("#toolbar_print div.toolbar_print_big").outerHeight();
    aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
  }
  else
  {
    aHeight += 0.5;
  }
    let menuDrop = $("<ul>").addClass('dropdown-menu').css('top',aHeight).attr('id','toolbarPrintLiDrop');
    let liDrop = $("<span>").css('color','gray').html('暂无数据');
    let menuDrop2 = $("<ul>").addClass('menu');
    let menuDrop3 = $("<div>").css({
      display:'flex',
      justifyContent: 'center',
      alignItems: 'center',
      minHeight:'175px'
    })
    $('#toolbarPrintLi').append(menuDrop.append(_content).append(menuDrop3.append(liDrop.append(menuDrop2))));
  
  $('#toolbarPrintLi .dropdown-menu').show();
  if(window.toolPrintDrop){
    window.toolPrintDrop=false;
  }else{
    window.toolPrintDrop=true;
  }
}

window.doPrintReport = function(task,formModule){
  if(task.arg && task.arg.reportList.length > 1){
    ReactDOM.render(<PrintReportDialog reportList={task.arg.reportList} printTaskId={task.arg.printTaskId} />, document.getElementById('printReportDialogModel'));
  }else if(task.arg && task.arg.reportList.length == 1){
    var command = Command.createService("gongqi.erp.layers.sys.services.PrintService", "preparePrint", "CommandResult");
    command.appendArg(task.arg.printTaskId);
    command.appendArg(task.arg.reportList[0]['id']);
    var remoteArg = { command: command, resultFunction: window.rpc_doPrintReportSuccess, faultFunction: window.rpc_doPrintReportError, sync: false };
    ServiceHelper.addTokenWithCommand(remoteArg)
    window.printReportTaskId = task.arg.printTaskId;
  }
  if(task.taskId && task.reportId){
    var command = Command.createService("gongqi.erp.layers.sys.services.PrintService", "preparePrint", "CommandResult");
    command.appendArg(task.taskId);
    command.appendArg(task.reportId);
    var remoteArg = { command: command, resultFunction: window.rpc_doPrintReportSuccess, faultFunction: window.rpc_doPrintReportError, sync: false };
    ServiceHelper.addTokenWithCommand(remoteArg)
    window.printReportTaskId = task.taskId;
  }
}

window.rpc_doPrintReportSuccess = function(data){
  let tasks = data.result.tasks;
  for(let i =0;i<tasks.length;i++){
    let task = tasks[i];
    if(task.cmd == "refreshPlugin" && task.control == "SupcanPrint"){
      let funcName = task.arg.arg;
      let funcArg = task.arg.iframeFuncArg;
      var  iframe  = document.getElementById('SupcanFrame');
      var  iframeWin = iframe.contentWindow;
      var  func=iframeWin.eval(funcName);
      if(funcArg.length ==0){
        new func();
      }else if(funcArg.length == 1){
        new func(funcArg[0]);
      }else{
        new func(funcArg[0],funcArg[1]);
      }
      delete tasks[i];
    }
  }
  CommandResolver.resolve(tasks);
}
window.rpc_doPrintReportError= function(data){
  console.log("发生错误",data);
}

window.doFinishPrint = function(){
  var command = Command.createService("gongqi.erp.layers.sys.services.PrintService", "finishPrint", "CommandResult");
  command.appendArg(window.printReportTaskId);
  var remoteArg = { command: command, resultFunction: window.rpc_doFinishPrintSuccess, faultFunction: window.rpc_doFinishPrintError, sync: false };
  ServiceHelper.addTokenWithCommand(remoteArg)
}

window.doOnReady = function(data){
  var command = Command.createService("gongqi.erp.layers.sys.services.PrintService", "onReady", "CommandResult");
  command.appendArg(data);
  var remoteArg = { command: command, resultFunction: window.rpc_doFinishPrintSuccess, faultFunction: window.rpc_doFinishPrintError, sync: false };
  ServiceHelper.addTokenWithCommand(remoteArg)
}

window.rpc_doFinishPrintSuccess= function(data){
  let tasks = data.result.tasks;
  for(let i =0;i<tasks.length;i++){
    let task = tasks[i];
    if(task.cmd == "refreshPlugin" && task.control == "SupcanPrint"){
      let funcName = task.arg.arg;
      let funcArg = task.arg.iframeFuncArg;
      var  iframe  = document.getElementById('SupcanFrame');
      var  iframeWin = iframe.contentWindow;
      var  func=iframeWin.eval(funcName);
      if(funcArg.length ==0){
        new func();
      }else if(funcArg.length == 1){
        new func(funcArg[0]);
      }else{
        new func(funcArg[0],funcArg[1]);
      }
      delete tasks[i];
    }
  }
  CommandResolver.resolve(tasks);
}
window.rpc_doFinishPrintError= function(data){
  console.log("发生错误",data);
}

window.toolbarOpen=function(data){
  if(window.toolbarBig){
    $(".toolbar_print_sml").css('display','flex');
    $(".toolbar_print_big").css('display','none');
    $(".toolbar_print_big2").css('display','none');
    $("#messagesSuccess").removeClass('big');
    $('#indexLoginDiv').removeClass('big');

    $('#toolbarMoreLi').removeClass('big');

    $("#main-header-div").css('height','42px');
    $("#g_title_area").css('height','42px');
    $("#g_title_area").removeClass("bigTool")
    $("#toolbarShowBigLi").removeClass("bigTool")
    $("#g_main_header #main-header-div .toolbar ").css("height","42px");
    $(".navbar.navbar-static-top").removeClass('navbar-static-top-bigIcon-height');
    $("#main-sidebar-seadiv").css("marginTop","42px");
    $(".dropdown-toggle.toolbarA").removeClass('toolbarBig')
    $("#contentWrapper").css('paddingTop','42px')
    if(!window.formOSopenDataSetView &&  window.titlearea){
      $("#g_title_area").html( window.titlearea);
    }
    if(window.appId && window.didomain){
      if($(window.frameElement).is('iframe')){
        $(window.frameElement).parent().parent().find('.layui-layer-setwin ').css('display','block');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display','inline-block').css('height','42px');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin').css('display','inline-block').css('height','42px').addClass('layui-layer-ico');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-closetrue').css('display','inline-block').css('height','42px').addClass('layui-layer-ico');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display','inline-block').css('height','42px').addClass('layui-layer-ico');
      }
    }
    window.toolbarBig=false;
  }else{
    $(".toolbar_print_sml").css('display','none');
    $(".toolbar_print_big").css({'display':'flex','flex-direction':'column','justify-content':'center','align-items':'stretch'});
    $(".toolbar_print_big2").css('display','flex');
    $("#messagesSuccess").addClass('big');
    $('#indexLoginDiv').addClass('big');

    $('#toolbarMoreLi').addClass('big');

    $("#main-header-div").css('height','58px');
    $(".navbar.navbar-static-top").addClass('navbar-static-top-bigIcon-height');
    $("#g_title_area").css('height','58px');
    $("#g_title_area").addClass("bigTool");
    $("#toolbarShowBigLi").addClass("bigTool")
    $("#g_main_header #main-header-div .toolbar ").css("height","58px");
    $("#main-sidebar-seadiv").css("marginTop","58px");
    $(".dropdown-toggle.toolbarA").addClass('toolbarBig')
    $("#contentWrapper").css('paddingTop','58px')

    if(window.appId && window.didomain){
      if($(window.frameElement).is('iframe')){
        $(window.frameElement).parent().parent().find('.layui-layer-setwin ').css('display','flex');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-min').css('display','flex').css('align-items','center').css('height','58px');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-maxmin').css('display','flex').css('align-items','center').css('height','58px').removeClass('layui-layer-ico');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-closetrue').css('display','flex').css('align-items','center').css('height','58px').removeClass('layui-layer-ico');
        $(window.frameElement).parent().parent().find('.layui-layer-setwin .layui-layer-max').css('display','flex').css('align-items','center').css('height','58px').removeClass('layui-layer-ico');
      }
    }
    if(!window.formOSopenDataSetView &&  window.titlearea){
      //titlearea ="<div style='width: 30%;height: 80%;background-size: cover;background-image:url("+srcArr[0]+")'></div>"+"<div style='display: flex;align-items: center;'><span style='font-size: 1.4rem;color: #000;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;margin-left:10px'>"+applabel+"</span></div>";
      let titlearea ="<div style='display: flex;flex-flow: column;line-height: normal;align-items: flex-start;margin-left: 10px;'>"+
      "<span style='text-align: start;font-size: 1.6rem;color: white;white-space: nowrap; display: inline-block; overflow: hidden; text-overflow: ellipsis;font-weight: 400;line-height: normal;width:160px' title="+window.applabel+">"+window.applabel+"</span>"+
      "<span style='text-align: start;padding-top:2px;font-size:1.2rem;color:#eae4e4db;width: 160px;white-space: nowrap;overflow: hidden;text-overflow: ellipsis;' title="+window.appDoMain+">"+window.appDoMain+"</span>"+"</div>"+
      "<div title='点此查看版本信息' style='display: flex; padding-top:4px;align-items: center;width: 100%;justify-content: flex-end;cursor: pointer;    margin-right: 10px;' class='winui-icon ' onClick='openDoMainAppInfo(event)' ><i class='iconfont icon-xinxi' style='color:white'></i></div>"
      ;
      $("#g_title_area").html( titlearea);
    }
    window.toolbarBig=true;
  }
}
window.toolbar_extendLiHover=function(data){
    $("#toolbarMoreLi .menu2").css('display','block');

}
window.toolbar_extendLiLeave=function(data){
  $("#toolbarMoreLi .menu2").css('display','none');
}

window.toolbar_Sort_SelfBtn=function(data){
  if (event && event.isTrigger == 3)
   return;
  var popIframes = $("#formModal iframe");
  var _id_;
  if (popIframes.length > 0) {
    var iframe = popIframes.get(popIframes.length - 1);
    _id_ = $(iframe).attr("id");

  }
  else {
    _id_ = $("#g_tab_content>.active>iframe").attr("id");
  }
  if (_id_) {
    callIFrameFunc(_id_,'queryOpen' , {sortSelf:true});
  }
}
window.toobarDropFunc = function (event, funcName, funcArg) {
  // if($(event.target).hasClass("menubtnLable")||$(event.target).hasClass("icon-container")){
  //   return;
  // }
  try{
    if(("#g_tab_content>.active>iframe")[0] && $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0]){
      $("#g_tab_content>.active>iframe")[0].contentWindow.document.getElementsByClassName("contextMenuPlugin")[0].remove();
    }
  }catch(err){

  }

  if (event && event.isTrigger == 3)
    return;
  var popIframes = $("#formModal iframe");
  var _id_;
  if (popIframes.length > 0) {
    var iframe = popIframes.get(popIframes.length - 1);
    _id_ = $(iframe).attr("id");

  }
  else {
    _id_ = $("#g_tab_content>.active>iframe").attr("id");
  }
  if (_id_) {

    if(funcName=="groupExport"){
      if(window.toolbarBig ){
        $("#toolbar_export .toolbar_print_big").addClass('drop');
        $("#toolbar_export .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
      }else{
        $("#toolbar_export .toolbar_print_sml .icon-drop").addClass('drop');
        $("#toolbar_export .toolbar_print_sml").addClass('drop');
      }


      callIFrameFunc(_id_, funcName, 'drop');
    }
    if(funcName=='da'){
      if(window.toolbarBig ){
        $("#toolbar_Da .toolbar_print_big").addClass('drop');
        $("#toolbar_Da .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
      }else{
        $("#toolbar_Da .toolbar_print_sml .icon-drop").addClass('drop');
        $("#toolbar_Da .toolbar_print_sml").addClass('drop');
      }

      
      callIFrameFunc(_id_, funcName, 'drop');
    }
    if(funcName=='queryOpen'){

      if(window.toolbarBig ){
        $("#toolbar_Queryopen .toolbar_print_big").addClass('drop');
        $("#toolbar_Queryopen .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
      }else{
        $("#toolbar_Queryopen .toolbar_print_sml .icon-drop").addClass('drop');
        $("#toolbar_Queryopen .toolbar_print_sml").addClass('drop');
      }


      callIFrameFunc(_id_, funcName, 'drop');
    }
    if(funcName=='find'){


      if(window.toolbarBig ){
        $("#toolbar_find .toolbar_print_big").addClass('drop');
        $("#toolbar_find .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
      }else{
        $("#toolbar_find .toolbar_print_sml .icon-drop").addClass('drop');
        $("#toolbar_find .toolbar_print_sml").addClass('drop');
      }
    
      let aHeight = $("#toolbar_find").outerHeight(); 
      if($('#toolbar_find').hasClass("toolbarBig"))
      {
        let innerDivHeight = $("#toolbar_find div.toolbar_print_big").outerHeight();
        aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
      }
      else
      {
        aHeight += 0.5;
      }
      $('#selectT .dropdown-menu').css('display','block').css('top',aHeight)

      if( window.openFindDrop) {window.openFindDrop=false}else{window.openFindDrop=true};

    }

    if(funcName ==  'attchment'){
      if( $("#toolbar_Attchment").hasClass('disable'))return;

      if(window.toolbarBig ){
        $("#toolbar_Attchment .toolbar_print_big").addClass('drop');
        $("#toolbar_Attchment .toolbar_print_big .toolbar_print_big_Icon").addClass('drop');
      }else{
        $("#toolbar_Attchment .toolbar_print_sml .icon-drop").addClass('drop');
        $("#toolbar_Attchment .toolbar_print_sml").addClass('drop');
      }
      callIFrameFunc(_id_, 'dropAttcheMnet', '');
    }
  }
}

window.toolbarExportDrop=function(key){
  if(window.toolExportDrop){
    window.toolExportDropRemove=true;
    window.toolExportDrop=false;
    return;
  }
  var command = Command.createService( 
    "gongqi.erp.gotmodel.services.UserSettingService", 
    "getUserFormExportsWithDefault", 
    "List"
  );
  command.appendArg(key);
  command.appendArg(window.userInfos.userId);
  var _resultHandler = function(data) {window.initExportDropList(data,key);};
  var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
  ServiceHelper.addTokenWithCommand(remoteArg);
}
window.initExportDropList=function(data,key){

  $('#toolbarExportLi .dropdown-menu').remove();
  var result=data.result;
    let _content="<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>导出方案</li>";
    if(result.length>0)
    {
        var item=result[0];
        var defName='';
        if( item){
          var itemArr=item.split(" ")
          _content=_content+" <li style=' display: flex;justify-content:  flex-start;'>"+
          "<a style='width:100%' onclick='toobarExportDropFunc(event)' fileName="+itemArr[1]+" label="+itemArr[1]+">"+
            "<i class='iconfont  icon-Micon-querenfangan'></i>"+
            "<span class='menubtnLable' title="+itemArr[1]+">"+ itemArr[1]+"</span>"+
          "</a>"+
        "</li>"
          defName = itemArr[1];
        }
    
      var command = Command.createService( 
        "gongqi.erp.gotmodel.services.UserSettingService", 
        "getUserFormExports", 
        "List"
      );
      command.appendArg(key);
      command.appendArg(window.userInfos.userId);
      var _resultHandler = function(data) {
        var result=data.result;
        if(result.length>0)
        {
          for(let i in result){
            var item=result[i];
            var itemArr=item.split(" ")
            if(defName==itemArr[1]){continue};
            _content=_content+" <li style=' display: flex;justify-content:  flex-start;'>"+
              "<a style='width:100%' onclick='toobarExportDropFunc(event)' fileName="+itemArr[1]+" label="+itemArr[1]+">"+
                "<i class='iconfont icon-fangan3'></i>"+
                "<span class='menubtnLable' title="+itemArr[1]+">"+ itemArr[1]+"</span>"+
              "</a>"+
            "</li>"
          }
          let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarExportLiDrop');
          let aHeight = $("#toolbar_export").outerHeight();
          if($('#toolbar_export').hasClass("toolbarBig"))
          {
            let innerDivHeight = $("#toolbar_export div.toolbar_print_big").outerHeight();
            aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
          }
          else
          {
            aHeight += 0.5;
          }
          

          menuDrop.css({top:aHeight});
          let liDrop = $("<li>");
          let menuDrop2 = $("<ul>").addClass('menu').html(_content);
          if($('#toolbarExportLi .dropdown-menu').length==0){
            $('#toolbarExportLi').append(menuDrop.append(liDrop.append(menuDrop2)));
          }else{
            $('#toolbarExportLi .dropdown-menu').remove();
            $('#toolbarExportLi').append(menuDrop.append(liDrop.append(menuDrop2)));
          }
        }else{
          let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarExportLiDrop');
          let aHeight = $("#toolbar_export").outerHeight();
          if($('#toolbar_export').hasClass("toolbarBig"))
          {
            let innerDivHeight = $("#toolbar_export div.toolbar_print_big").outerHeight();
            aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
          }
          else
          {
            aHeight += 0.5;
          }
          menuDrop.css({top:aHeight});
          let liDrop = $("<span>").css('color','gray').html('暂无方案');
          let menuDrop2 = $("<div>").css({
            display:'flex',
            justifyContent: 'center',
            alignItems: 'center',
            minHeight:'175px'
          })
          
          $('#toolbarExportLi').append(menuDrop.append(_content).append(menuDrop2.append(liDrop)));
        }
        $('#toolbarExportLi .dropdown-menu').show();
        if(window.toolExportDrop){
          window.toolExportDrop=false;
        }else{
          window.toolExportDrop=true;
        }
        }
      
      };
      var remoteArg = {command:command,resultFunction:_resultHandler,sync:false};
      ServiceHelper.addTokenWithCommand(remoteArg);

}
window.toobarExportDropFunc=function(event){
  if(!event)return;
  let fileName = $(event.target).attr("filename");
  let label = $(event.target).attr("label");
  if(!fileName){
    fileName = $(event.target)[0].parentElement.attributes[1].value
    label = $(event.target)[0].parentElement.attributes[2].value
  }
  if (event && event.isTrigger == 3)
    return;
  var popIframes = $("#formModal iframe");
  var _id_;
  if (popIframes.length > 0) {
    var iframe = popIframes.get(popIframes.length - 1);
    _id_ = $(iframe).attr("id");
  }
  else {
    _id_ = $("#g_tab_content>.active>iframe").attr("id");
  }
  if (_id_) {
    callIFrameFunc(_id_, "groupExport", fileName);
  }
}





window.toolbarPivotDrop=function(key){
  if(window.toolPivotDrop){
    window.toolPivotDrop=false;
    window.toolPivotDropRemove=true;
    return;
  }
  var serviceURL = key.serviceURL;
  var _dataarea = window.userInfos.subSysId;
  var configkey= key.configKey;
  var userId =window.userInfos.userId;

  if(window.didomain && window.appId){
    let _header = {"Content-type":"application/json"};
    if(!window.parent.window.loginToken)
    {
      let _token = localStorage.getItem("userToken");
      if (_token){
        _header.token = _token;
      }else{
        _header.token = window.parent.window.localStorage.getItem("userToken");
      }
    }	
    $.ajax({
      type: "get",
      url:  window.osUrl+"/"+"MIX"+"/web/apps/gongqi.tool.dataAnalysis/dataAnalysis/getAnalysisScheme",
      data: { 
          key:configkey,
          userId:userId
      },
      dataType: "json",
      headers:_header,
      success: function(data){
          window.initPivotDropList(data,true) 
      },
      error:function(data){
        window.initPivotDropList(data,true) 
      }
  });
  }else{
    $.ajax({
      type: "get",
      url: serviceURL+"/web/sys/pivot/allConfigWithDefault",
      data: {_dataarea:_dataarea, 
          key:configkey,
          userId:userId
      },
      dataType: "json",
      success: function(data){
          window.initPivotDropList(data,false) 
      }
  });

  }
}

window.initPivotDropList=function(data,isOS=null){
  $('#toolbarPivotLi .dropdown-menu').remove();



  if(isOS){
    if(!data|| !data.content || data.content.length ==0){
      let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarPivotLiDrop');
      let aHeight = $("#toolbar_Da").outerHeight();
      if($('#toolbar_Da').hasClass("toolbarBig"))
      {
        let innerDivHeight = $("#toolbar_Da div.toolbar_print_big").outerHeight();
        aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
      }
      else
      {
        aHeight += 0.5;
      }
      menuDrop.css({top:aHeight});
      let menuDrop2 = $("<div>").css({
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight:'175px'
      })
      let liDrop = $("<span>").css('color','gray').html('暂无方案');
      $('#toolbarPivotLi').append(menuDrop.append(_content).append(menuDrop2.append(liDrop)));
    
    }else{
      let _content="<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>图表方案</li>";
      var result=data.content;
      for(var i= 0,l=result.length;i<l;i++){
            if(i==0&& result[0]){
              var item=[result[i].id,result[i].name];
              if(item[1]==undefined || item[1]=='undefined' ){continue}
              _content=_content+" <li style=' display: flex;justify-content:  flex-start;'>"+
              "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName="+item[1]+" user="+item[0]+">"+
              "<i class='iconfont  icon-Micon-querenfangan' style='margin-left:12px'></i>"+
                "<span class='menubtnLable' title="+item[1]+">"+ item[1]+"</span>"+
              "</a>"+
            "</li>"
            }else{
              var item=[result[i].id,result[i].name];
              if(item[1]==undefined || item[1]=='undefined' ){continue}
              _content=_content+" <li style=' display: flex;justify-content:  flex-start;'>"+
              "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName="+item[1]+" user="+item[0]+">"+
              "<i class='iconfont icon-fangan3' style='margin-left:12px'></i>"+
                "<span class='menubtnLable'>"+ item[1]+"</span>"+
              "</a>"+
            "</li>"
            }
  
      }
            let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarPivotLiDrop');
            //let aHeight=$('#toolbar_Da').outerHeight()+0.5;
  
  
            let aHeight = $("#toolbar_Da").outerHeight();
            if($('#toolbar_Da').hasClass("toolbarBig"))
            {
              let innerDivHeight = $("#toolbar_Da div.toolbar_print_big").outerHeight();
              aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
            }
            else
            {
              aHeight += 0.5;
            }
  
            menuDrop.css({top:aHeight});
            let liDrop = $("<li>");
            let menuDrop2 = $("<ul>").addClass('menu').html(_content);
            if($('#toolbarPivotLi .dropdown-menu').length==0){
              $('#toolbarPivotLi').append(menuDrop.append(liDrop.append(menuDrop2)));
            }else{
              $('#toolbarPivotLi .dropdown-menu').remove();
              $('#toolbarPivotLi').append(menuDrop.append(liDrop.append(menuDrop2)));
            }
      }
    
  }else{
    var result=data.result;
    let _content="<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>图表方案</li>";
    if(data.ReturnCode=="101"){
      var result=data.ReturnValue.result;
      for(var i= 0,l=result.length;i<l;i++){
            if(i==0&& result[0]){
              var item=result[i].split(" ");
              if(item[1]==undefined || item[1]=='undefined' ){continue}
              _content=_content+" <li style=' display: flex;justify-content:  flex-start;'>"+
              "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName="+item[1]+" user="+item[0]+">"+
              "<i class='iconfont  icon-Micon-querenfangan' style='margin-left:12px'></i>"+
                "<span class='menubtnLable' title="+item[1]+">"+ item[1]+"</span>"+
              "</a>"+
            "</li>"
            }else{
              var item=result[i].split(" ");
              if(item[1]==undefined || item[1]=='undefined' ){continue}
              _content=_content+" <li style=' display: flex;justify-content:  flex-start;'>"+
              "<a style='width:100%' onclick='toobarPivotDropFunc(event)' fileName="+item[1]+" user="+item[0]+">"+
              "<i class='iconfont icon-fangan3' style='margin-left:12px'></i>"+
                "<span class='menubtnLable'>"+ item[1]+"</span>"+
              "</a>"+
            "</li>"
            }
  
            }
            let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarPivotLiDrop');
            //let aHeight=$('#toolbar_Da').outerHeight()+0.5;
  
  
            let aHeight = $("#toolbar_Da").outerHeight();
            if($('#toolbar_Da').hasClass("toolbarBig"))
            {
              let innerDivHeight = $("#toolbar_Da div.toolbar_print_big").outerHeight();
              aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
            }
            else
            {
              aHeight += 0.5;
            }
  
            menuDrop.css({top:aHeight});
            let liDrop = $("<li>");
            let menuDrop2 = $("<ul>").addClass('menu').html(_content);
            if($('#toolbarPivotLi .dropdown-menu').length==0){
              $('#toolbarPivotLi').append(menuDrop.append(liDrop.append(menuDrop2)));
            }else{
              $('#toolbarPivotLi .dropdown-menu').remove();
              $('#toolbarPivotLi').append(menuDrop.append(liDrop.append(menuDrop2)));
            }
            
          
    }
    if(!result ||result.length==0){

      let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarPivotLiDrop');
      let aHeight = $("#toolbar_Da").outerHeight();
      if($('#toolbar_Da').hasClass("toolbarBig"))
      {
        let innerDivHeight = $("#toolbar_Da div.toolbar_print_big").outerHeight();
        aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
      }
      else
      {
        aHeight += 0.5;
      }
      menuDrop.css({top:aHeight});
      let menuDrop2 = $("<div>").css({
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight:'175px'
      })
      let liDrop = $("<span>").css('color','gray').html('暂无方案');
      $('#toolbarPivotLi').append(menuDrop.append(_content).append(menuDrop2.append(liDrop)));
    
    }
  }

    $('#toolbarPivotLi .dropdown-menu').show();
    if(window.toolPivotDrop){
      window.toolPivotDrop=false;
    }else{
      window.toolPivotDrop = true;
    }
}
window.toobarPivotDropFunc=function(event){
  if(!event)return;
  let fileName = $(event.target).attr("filename")
  let user = $(event.target).attr("label");
  if(!fileName){
    fileName = $(event.target)[0].parentElement.attributes[1].value
    user = $(event.target)[0].parentElement.attributes[2].value
  }
  if (event && event.isTrigger == 3)
    return;
  var popIframes = $("#formModal iframe");
  var _id_;
  if (popIframes.length > 0) {
    var iframe = popIframes.get(popIframes.length - 1);
    _id_ = $(iframe).attr("id");
  }
  else {
    _id_ = $("#g_tab_content>.active>iframe").attr("id");
  }
  if (_id_) {
    callIFrameFunc(_id_, "da", {fileName:fileName,user:user});
  }
}




window.toolbarQueryDrop=function(key){
  try{
    $('#toolbarQueryLi .dropdown-menu').remove();
  }catch(e){}
  var command = Command.createService( 
    "gongqi.erp.gotmodel.services.UserSettingService", 
    "getUserFormQueriesWithDefault", 
    "List"
  );
  command.appendArg(key);
  command.appendArg(window.userInfos.userId);
  ServiceHelper.addTokenWithCommand({command:command,resultFunction:window.initQueryDropList.bind(this)});
}
window.initQueryDropList=function(data){
  var ac = data.result;
  if(!ac)return;
  var array = [];
  var index = 0;
  for(let i = 0;i<ac.length;i++)
  {
    let _key = ac[i];
    if(_key == null)continue;
    var has = false;
    var _arr = _key.split(" ");
    var _userId = _arr[0];
    if(_userId != window.userInfos.userId)
      continue;
    var _label = _arr[1];
    for(let k = 0;k<array.length;k++)
    {
      let item = array[k];
      if(item.label == _label){has=true;break;}
    }
    if(has)
      continue;
    var o = {};
    o.label = _label;
    o.childIndex = index;
    array.push(o);
    index ++ ;
  }
  let _content="<li style='display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>筛选方案</li>";
    if((ac.length>0 && ac[0]) || (ac.length>1))
    {
      let defName='';
      for(let i in ac){
        if(i==0 && ac[0]){
          let res = ac[i].split(" ");
          let item={label:res[1]}
          defName=item.label;
          _content=_content+" <li style=' display: flex;justify-content: flex-start;'>"+
          "<a style='width:100%' onclick='toobarQueryDropFunc(event)' fileName="+item.label+" label="+item.label+">"+
          "<i class='iconfont icon-Micon-querenfangan'></i>"+
            "<span class='menubtnLable' title="+item.label+">"+item.label+"</span>"+
          "</a>"+
        "</li>"
        }else{
          if(!ac[i])continue;
          let res = ac[i].split(" ");
          let item={label:res[1]}
          if(defName==item.label){
            continue;
          }
          _content=_content+" <li style=' display: flex;justify-content: flex-start;'>"+
          "<a style='width:100%' onclick='toobarQueryDropFunc(event)' fileName="+item.label+" label="+item.label+">"+
          "<i class='iconfont icon-fangan3'></i>"+
            "<span class='menubtnLable' title="+item.label+">"+item.label+"</span>"+
          "</a>"+
        "</li>"
        }

      }
      if($('#toolbarQueryLi .dropdown-menu').length==0){
        let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarQueryLiDrop');
        //let aHeight=$('#toolbar_Queryopen').outerHeight()+0.5;

        let aHeight = $("#toolbar_Queryopen").outerHeight();
        if($('#toolbar_Queryopen').hasClass("toolbarBig"))
        {
          let innerDivHeight = $("#toolbar_Queryopen div.toolbar_print_big").outerHeight();
          aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
        }
        else
        {
          aHeight += 0.5;
        }


        menuDrop.css({top:aHeight});
        let liDrop = $("<li>");
        let menuDrop2 = $("<ul>").addClass('menu').html(_content);
        $('#toolbarQueryLi').append(menuDrop.append(liDrop.append(menuDrop2)));
      }else{
        $('#toolbarQueryLi .dropdown-menu').remove();
        $('#toolbarQueryLi').append(menuDrop.append(liDrop.append(menuDrop2)));
      }
    }else{
      
      //_content += "暂无方案";

      let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarQueryLiDrop');
      let aHeight = $("#toolbar_Queryopen").outerHeight();
      if($('#toolbar_Queryopen').hasClass("toolbarBig"))
      {
        let innerDivHeight = $("#toolbar_Queryopen div.toolbar_print_big").outerHeight();
        aHeight = aHeight-((aHeight-innerDivHeight)/2)-0.5;
      }
      else
      {
        aHeight += 0.5;
      }
      menuDrop.css({top:aHeight});
      let liDrop = $("<span>").css('color','gray').html("暂无方案");
      let menuDrop2 = $("<ul>").css({
        display:'flex',
        justifyContent: 'center',
        alignItems: 'center',
        minHeight:'175px',
        paddingLeft: '0px'
      })
      $('#toolbarQueryLi').append(menuDrop.append(_content).append(menuDrop2.append(liDrop)));
    }
    $('#toolbarQueryLi .dropdown-menu').show();
    if(window.toolQueryDrop){
      window.toolQueryDrop=false;
    }else{
      window.toolQueryDrop=true;
    }
  
}
window.toobarQueryDropFunc=function(event){
  if(!event)return;
  let fileName = $(event.target).attr("filename");
  let label = $(event.target).attr("label");
  if(!fileName){
    fileName = $(event.target)[0].parentElement.attributes[1].value
    label = $(event.target)[0].parentElement.attributes[2].value
  }
  if (event && event.isTrigger == 3)
    return;
  var popIframes = $("#formModal iframe");
  var _id_;
  if (popIframes.length > 0) {
    var iframe = popIframes.get(popIframes.length - 1);
    _id_ = $(iframe).attr("id");
  }
  else {
    _id_ = $("#g_tab_content>.active>iframe").attr("id");
  }
  if (_id_) {
    callIFrameFunc(_id_, "queryOpen", {fileName:fileName});
  }
}

window.toobarMenuDropFunc=function(e,funcN,args){
  if(funcN == 'sort'){
    //let aHeight=$('#toolbar_Sort').outerHeight()+0.5;

    let aHeight = $("#toolbar_Sort").outerHeight();
    if($('#toolbar_Sort').hasClass("toolbarBig"))
    {
      let innerDivHeight = $("#toolbar_Sort div.toolbar_print_big").outerHeight();
      aHeight = aHeight-((aHeight-innerDivHeight)/2);
    }
      /*else
      {
        aHeight += 0.5;
      }*/

    $("#toolbarSortLi .dropdown-menu").css('top',aHeight);
  }
  if(funcN =='action'){
    //let aHeight=$('#toolbar_Action').outerHeight()+0.5;

    let aHeight = $("#toolbar_Action").outerHeight();
    if($('#toolbar_Action').hasClass("toolbarBig"))
    {
      let innerDivHeight = $("#toolbar_Action div.toolbar_print_big").outerHeight();
      aHeight = aHeight-((aHeight-innerDivHeight)/2);
    }

    $("#toolbarActionLi .dropdown-menu").css('top',aHeight);
  }

}
window.toolbarAttachmentDrop=function(tableId,recId,formId,aukey){
  
  var title = "附件:"+tableId+"/"+recId;
  window.AttachmentTableId = tableId;
  window.AttachmentRecId = recId;
  var command = Command.createService( 
    "gongqi.erp.gotmodel.services.AttachmentService", 
    "listAttachments", 
    "List"
  );
  command.appendArg(tableId+"/"+recId	);
  var remoteArg = {command:command,resultFunction:window.rpc_result_getAttachmentHandler.bind(this),sync:false};
  ServiceHelper.addTokenWithCommand(remoteArg);
}
window.getFileTypeIcon=function(type,url){

}
window.rpc_result_getAttachmentHandler=function(data){
  if(window.toolAttachmentDrop )return;
  var tableId=window.AttachmentTableId;
  var recId=  window.AttachmentRecId
  var base=window.userInfos.resourceURL;
  $('#toolbarAttchmentLi .dropdown-menu').remove();
  var fileList=data.result;
  let _content="<li style=' display: flex;justify-content: flex-start;font-size: 12px;padding-left:12px;border-bottom: 1px solid rgb(205,206,205);line-height: 25px;'>附件列表</li>";
  for(var i= 0,l=fileList.length;i<l;i++){
    var item=fileList[i];
    let fileType;
    if(item)
    {
      fileType = item.substr(item.indexOf(".")+1,fileType);
    }
    let dataOriginal=base+"/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(item);
    let fileTypeIcon = this.getFileTypeIcon(fileType,dataOriginal);
    _content=_content+" <li style=' display: flex;justify-content:  flex-start;'>"+
    "<a style='width:100%' onclick='toobarAttachmentDropFunc(event)' fileName="+item+" >"+
    fileTypeIcon+
      "<span class='menubtnLable' title="+item+">"+ item+"</span>"+
    "</a>"+
  "</li>"
  }


        
    
    if(!fileList ||fileList.length==0){

        let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarAttachmentLiDrop');
        let aHeight=$('#toolbar_Attchment').outerHeight()-0.5;
        menuDrop.css({top:aHeight});
        let menuDrop2 = $("<div>").css({
          display:'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight:'175px'
        })
        let liDrop = $("<span>").css('color','gray').html('暂无附件');
        $('#toolbarAttchmentLi').append(menuDrop.append(_content).append(menuDrop2.append(liDrop)));
      
    }else{
      let menuDrop = $("<ul>").addClass('dropdown-menu').attr('id','toolbarAttachmentLiDrop');
      let aHeight=$('#toolbar_Attchment').outerHeight()-0.5;
      menuDrop.css({top:aHeight});
      let liDrop = $("<li>");
      let menuDrop2 = $("<ul>").addClass('menu').html(_content);
      if($('#toolbarAttchmentLi .dropdown-menu').length==0){
          $('#toolbarAttchmentLi').append(menuDrop.append(liDrop.append(menuDrop2)));
      }else{
          $('#toolbarAttchmentLi .dropdown-menu').remove();
          $('#toolbarAttchmentLi').append(menuDrop.append(liDrop.append(menuDrop2)));
      }
    }
    $('#toolbarAttchmentLi .dropdown-menu').show();
    if(window.toolAttachmentDrop){
      window.toolAttachmentDrop=false;
    }else{
      window.toolAttachmentDrop = true;
    }
}
window.getFileTypeIcon=function(fileType,dataOriginal = null)
{
  if(!fileType)
  {
    return "<div style=background:url(images/doccopy.png);width:20px;height:20px;margin:5px;margin-right:20px;background-size:cover></div>"
  }
  if(fileType.indexOf("xls") != -1)
  {
    return "<svg t='1685321168118' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4584' xmlns:xlink='http://www.w3.org/1999/xlink' width='21' height='25'><path d='M901.851653 926.484607a48.255937 48.255937 0 0 1-14.274541 34.442195 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.220097 48.220097 0 0 1-34.457555-14.279661 48.844737 48.844737 0 0 1-14.279662-34.442195V48.846068a48.317377 48.317377 0 0 1 14.279662-34.467795A48.844737 48.844737 0 0 1 170.419644 0.001331h418.800096a48.742337 48.742337 0 0 1 34.662355 14.131182l263.858857 263.910057a48.844737 48.844737 0 0 1 14.110701 34.667475z' fill='#EBECF0' p-id='4585'></path><path d='M901.851653 926.484607v48.767936a48.317377 48.317377 0 0 1-14.274541 34.467796 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.844737 48.844737 0 0 1-48.788417-48.844737v-48.721856a48.204737 48.204737 0 0 0 14.279662 34.442195 48.844737 48.844737 0 0 0 34.457555 14.279661h682.648713a48.844737 48.844737 0 0 0 48.773056-48.783296z' fill='#C1C7D0' p-id='4586'></path><path d='M24.167034 536.423034h975.153932v243.849923a48.921536 48.921536 0 0 1-48.721856 48.844736H73.011771a48.342977 48.342977 0 0 1-34.467796-14.274541 48.844737 48.844737 0 0 1-14.376941-34.570195z' fill='#0AC905' p-id='4587'></path><path d='M121.733627 536.412794V438.856441L24.167034 536.412794z m780.118026 0l0.926719-97.556353 97.039234 97.556353z' fill='#168E2D' p-id='4588'></path><path d='M901.851653 312.628125v6.860791h-263.833257a48.844737 48.844737 0 0 1-48.844736-48.844737V0.001331a48.732097 48.732097 0 0 1 34.662355 14.115822l264.268456 263.751337a49.459136 49.459136 0 0 1 13.701102 34.754515z' fill='#C1C7D0' p-id='4589'></path><path d='M265.190721 764.037458H136.346088v-153.94284h126.335836v35.978193H187.382182v21.749732h63.590317v35.973073h-63.590317v24.268769h77.808539zM358.05716 720.532875l-25.098207 43.504583H276.065587l54.384569-80.322456-49.366976-73.620384h56.893366l21.754852 39.321549 22.589411-39.321549h56.888246L386.508963 683.725242l52.705212 80.317336H382.320809zM599.843726 668.662222h-47.682498q-3.353596-24.268768-27.612124-25.103327-27.612124 0.839679-28.446683 45.178821 0 41.845706 30.120921 41.830345 22.584291 0 25.937886-25.932766h48.522177q-8.376309 59.417523-73.625505 61.91096-78.648218-2.508797-81.151894-79.482777 4.177915-76.124061 76.96886-81.151894 69.43735 0.839679 76.96886 62.750638zM752.112328 764.037458h-128.844633v-153.94284h126.335836v35.978193H674.303789v21.749732h63.590317v35.973073H674.303789v24.268769h77.808539zM897.694219 764.037458H777.215655v-153.94284h51.036094v117.964647h69.44247z' fill='#FFFFFF' p-id='4590'></path></svg>"
  }
  else if(fileType.indexOf("pdf") != -1)
  {
    return "<svg t='1685259963555' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4613' width='21' height='25'><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='4614'></path><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='4615'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#FF5630' p-id='4616'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#DE350B' p-id='4617'></path><path d='M267.946434 585.143275h84.845634a57.051374 57.051374 0 0 1 41.935198 15.603795 55.1009 55.1009 0 0 1 16.091413 40.959961 55.588518 55.588518 0 0 1-16.091413 40.959961 59.001849 59.001849 0 0 1-43.398054 16.091413h-48.761858v76.556118H267.946434z m32.670446 81.919922h43.885672a42.422817 42.422817 0 0 0 25.843785-6.339041 23.893311 23.893311 0 0 0 7.801897-19.992362q0-24.868548-32.670445-24.868548h-44.860909zM434.71199 588.068987H511.755726a73.142787 73.142787 0 0 1 58.51423 25.356166 100.937047 100.937047 0 0 1 21.942836 68.266602 110.689418 110.689418 0 0 1-20.967599 69.729457A71.679932 71.679932 0 0 1 511.755726 780.190708H434.71199z m32.670445 158.963658H511.755726a43.398054 43.398054 0 0 0 36.083775-17.066651A75.093262 75.093262 0 0 0 560.517584 682.666992a70.704695 70.704695 0 0 0-13.65332-48.761859 48.761858 48.761858 0 0 0-37.546631-16.579031h-41.935198zM755.565018 618.788957h-100.937047v45.348529H755.565018v31.207589h-100.937047v81.919922h-32.670445v-190.171248H755.565018z' fill='#FFFFFF' p-id='4618'></path><path d='M901.850593 312.564487v6.82666h-263.801654a48.761858 48.761858 0 0 1-48.761858-48.761858V0.000975a48.761858 48.761858 0 0 1 34.620919 14.140939l264.289272 263.801654a48.761858 48.761858 0 0 1 13.653321 34.620919z' fill='#C1C7D0' p-id='4619'></path></svg>"
  }
  else if(fileType.indexOf("ppt") != -1)
  {
    return "<svg t='1685668273836' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='12012' width='21' height='25'><path d='M901.851653 926.484607a48.255937 48.255937 0 0 1-14.274541 34.442195 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.220097 48.220097 0 0 1-34.457555-14.279661 48.844737 48.844737 0 0 1-14.279662-34.442195V48.846068a48.317377 48.317377 0 0 1 14.279662-34.467795A48.844737 48.844737 0 0 1 170.419644 0.001331h418.800096a48.742337 48.742337 0 0 1 34.662355 14.131182l263.858857 263.910057a48.844737 48.844737 0 0 1 14.110701 34.667475z' fill='#EBECF0' p-id='12013'></path><path d='M901.851653 926.484607v48.767936a48.317377 48.317377 0 0 1-14.274541 34.467796 48.844737 48.844737 0 0 1-34.457555 14.279661H170.419644a48.844737 48.844737 0 0 1-48.788417-48.844737v-48.721856a48.204737 48.204737 0 0 0 14.279662 34.442195 48.844737 48.844737 0 0 0 34.457555 14.279661h682.648713a48.844737 48.844737 0 0 0 48.773056-48.783296z' fill='#C1C7D0' p-id='12014'></path><path d='M24.167034 536.423034h975.153932v243.849923a48.921536 48.921536 0 0 1-48.721856 48.844736H73.011771a48.342977 48.342977 0 0 1-34.467796-14.274541 48.844737 48.844737 0 0 1-14.376941-34.570195z' fill='#1B8ADD' p-id='12015'></path><path d='M121.733627 536.412794V438.856441L24.167034 536.412794z m780.118026 0l0.926719-97.556353 97.039234 97.556353z' fill='#425AE8' p-id='12016'></path><path d='M901.851653 312.628125v6.860791h-263.833257a48.844737 48.844737 0 0 1-48.844736-48.844737V0.001331a48.732097 48.732097 0 0 1 34.662355 14.115822l264.268456 263.751337a49.459136 49.459136 0 0 1 13.701102 34.754515z' fill='#C1C7D0' p-id='12017'></path><path d='M314.240257 780.119357h-59.033523V599.091752h86.579087q75.755422 0.988159 77.731739 60.999601-0.993279 62.970798-75.760541 63.948717h-29.516762z m0-98.385792h24.601568q23.608289 0 23.608289-21.642212 0-18.687976-31.482839-18.698216h-16.727018zM495.278102 780.119357h-59.033524V599.091752h86.584208q75.750302 0.988159 77.721499 60.999601-0.988159 62.970798-75.760542 63.948717h-29.511641z m0-98.385792h24.591328q23.623649 0 23.618529-21.642212 0-18.687976-31.487959-18.698216h-16.721898zM610.390912 646.313451v-47.221699h166.266664v47.221699h-53.130171v133.805906h-60.006322v-133.805906z' fill='#FFFFFF' p-id='12018'></path></svg>"
  }
  else if(fileType.indexOf("doc") != -1)
  {
    return "<svg t='1685260317135' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4911' width='21' height='25'><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='4912'></path><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='4913'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#0747A6' p-id='4914'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#063266' p-id='4915'></path><path d='M236.251227 592.457554H311.832107a71.192313 71.192313 0 0 1 56.563756 24.868548A97.523717 97.523717 0 0 1 389.85108 682.666992a107.763707 107.763707 0 0 1-20.47998 67.778983 69.729457 69.729457 0 0 1-58.51423 26.331403H236.251227zM267.946434 747.032645h41.44758a41.935198 41.935198 0 0 0 35.596157-15.603795 73.142787 73.142787 0 0 0 12.678083-48.761858 68.75422 68.75422 0 0 0-13.653321-45.348528 44.86091 44.86091 0 0 0-36.571393-16.091414H267.946434zM511.755726 585.143275a83.870396 83.870396 0 0 1 65.34089 26.819022 97.523717 97.523717 0 0 1 23.893311 70.704695 103.37514 103.37514 0 0 1-24.380929 70.704694A82.407541 82.407541 0 0 1 511.755726 780.190708a83.870396 83.870396 0 0 1-65.34089-27.30664A100.937047 100.937047 0 0 1 421.546288 682.666992a100.449428 100.449428 0 0 1 24.868548-70.217076A83.382778 83.382778 0 0 1 511.755726 585.143275z m0 163.839844a52.662807 52.662807 0 0 0 42.422817-18.041888 73.142787 73.142787 0 0 0 15.116176-48.761858 70.217076 70.217076 0 0 0-16.091413-48.761858 53.638044 53.638044 0 0 0-41.935199-18.041888 52.662807 52.662807 0 0 0-41.935198 18.041888 71.192313 71.192313 0 0 0-15.603794 48.761858 70.704695 70.704695 0 0 0 16.091413 48.761858 53.150426 53.150426 0 0 0 41.935198 18.529507zM787.260226 701.196498a155.062709 155.062709 0 0 1-28.281878 58.026611 69.241839 69.241839 0 0 1-56.076137 20.967599 74.605643 74.605643 0 0 1-59.977086-25.356166 106.300851 106.300851 0 0 1-22.430455-72.16755 104.837995 104.837995 0 0 1 22.918074-71.679932A78.506592 78.506592 0 0 1 706.803159 585.143275q57.051374 0 76.556118 67.291365h-32.670445a48.761858 48.761858 0 0 0-43.885673-35.596157 48.761858 48.761858 0 0 0-39.009486 17.06665 69.729457 69.729457 0 0 0-14.628558 48.761859q0 66.803746 51.68757 66.803746a40.472342 40.472342 0 0 0 30.719971-11.215228 85.820871 85.820871 0 0 0 17.554269-35.596156z' fill='#FFFFFF' p-id='4916'></path><path d='M905.263923 312.564487v6.82666h-264.289272a48.761858 48.761858 0 0 1-48.761859-48.761858V0.000975a48.761858 48.761858 0 0 1 34.62092 14.140939l264.289272 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919z' fill='#C1C7D0' p-id='4917'></path></svg>";
  }
  else if(fileType.indexOf(".png") !=-1 || fileType=="png")
  {
    // let src = 'images/jpg.png';
    // return <img data-original={dataOriginal}   src={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></img>
    return "<svg t='1685260081356' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='4762' width='21' height='25'><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='4763'></path><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='4764'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#5E6C84' p-id='4765'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#172B4D' p-id='4766'></path><path d='M792.62403 752.884068a120.44179 120.44179 0 0 1-78.506592 29.257115 93.622768 93.622768 0 0 1-97.523717-97.523717 97.523717 97.523717 0 0 1 97.523717-97.523717 101.912284 101.912284 0 0 1 72.655169 25.356167l-20.967599 24.868548a74.118025 74.118025 0 0 0-52.662807-19.992362A63.878034 63.878034 0 0 0 650.727022 682.666992a62.902797 62.902797 0 0 0 63.878035 67.778983 77.043736 77.043736 0 0 0 45.348528-14.140939v-35.108538h-40.472342a7.801897 7.801897 0 0 1-7.801898-7.801897V682.666992a7.801897 7.801897 0 0 1 7.801898-7.801898h65.34089a7.801897 7.801897 0 0 1 7.801897 7.801898z m-249.173096-32.182827v-122.392264a7.801897 7.801897 0 0 1 7.801897-7.801897h17.066651a7.801897 7.801897 0 0 1 7.801897 7.801897v173.104597a7.801897 7.801897 0 0 1-7.801897 7.801897h-16.091414a7.801897 7.801897 0 0 1-6.339041-2.925711l-101.912284-131.169399v126.293213a7.801897 7.801897 0 0 1-7.801897 7.801897H419.108195a7.801897 7.801897 0 0 1-7.801897-7.801897v-173.104597a7.801897 7.801897 0 0 1 7.801897-7.801897h19.504744a7.801897 7.801897 0 0 1 6.339041 2.925711z m-199.436001-65.828508c0-22.430455-16.091413-34.133301-40.472342-34.133301h-39.009487v67.778983h38.521868c25.356166 0 40.959961-13.65332 40.959961-33.645682z m33.645683 0a66.316127 66.316127 0 0 1-75.580881 63.878034h-37.546631v52.662807a7.801897 7.801897 0 0 1-7.801897 7.801897h-17.554269a7.801897 7.801897 0 0 1-7.801897-7.801897v-173.104597a7.801897 7.801897 0 0 1 7.801897-7.801897h66.803746a63.390416 63.390416 0 0 1 71.679932 63.390415z' fill='#FFFFFF' p-id='4767'></path><path d='M901.850593 313.052106v6.82666h-263.801654a48.761858 48.761858 0 0 1-48.761858-48.761858V0.000975a48.761858 48.761858 0 0 1 34.620919 14.628558l264.289272 263.801653a48.761858 48.761858 0 0 1 13.653321 34.62092z' fill='#C1C7D0' p-id='4768'></path></svg>"
  }
  else if(fileType == "jpg" || fileType.indexOf(".jpg") != -1)
  {
    // return <img data-original={dataOriginal} src={dataOriginal} style={{background:'url(images/jpg.png)',width:'24px',height:'27px',marginRight:'10px'}}></img>
    return "<svg t='1685260377506' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5060' width='21' height='25'><path d='M901.850593 926.476283a48.761858 48.761858 0 0 1-48.761859 48.761859H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761859V48.762834a48.761858 48.761858 0 0 1 48.761858-48.761859h418.864363a48.761858 48.761858 0 0 1 34.620919 14.140939l263.801654 263.801654a48.761858 48.761858 0 0 1 14.140939 34.620919V926.476283z' fill='#EBECF0' p-id='5061'></path><path d='M901.850593 926.476283v48.761859a48.761858 48.761858 0 0 1-48.761859 48.761858H170.422718a48.761858 48.761858 0 0 1-48.761858-48.761858v-48.761859a48.761858 48.761858 0 0 0 48.761858 48.761859h682.666016a48.761858 48.761858 0 0 0 48.761859-48.761859z' fill='#C1C7D0' p-id='5062'></path><path d='M24.137143 536.381417h975.237166v243.809291a48.761858 48.761858 0 0 1-48.761858 48.761859H72.899001a48.761858 48.761858 0 0 1-48.761858-48.761859v-243.809291z' fill='#FFAB00' p-id='5063'></path><path d='M121.66086 536.381417V438.8577l-97.523717 97.523717h97.523717zM901.850593 536.381417l0.975237-97.523717 97.036098 97.523717H901.850593z' fill='#FF8B00' p-id='5064'></path><path d='M770.681194 750.933593a120.44179 120.44179 0 0 1-78.506592 29.257115 93.622768 93.622768 0 0 1-97.523717-97.523716 97.523717 97.523717 0 0 1 97.523717-97.523717 101.912284 101.912284 0 0 1 72.655169 25.356166l-20.967599 24.868548a74.118025 74.118025 0 0 0-52.662807-19.992362A63.878034 63.878034 0 0 0 628.784186 682.666992a62.902797 62.902797 0 0 0 63.878034 67.778983 77.043736 77.043736 0 0 0 45.348529-14.140939v-35.108538h-34.62092a7.314279 7.314279 0 0 1-7.314278-7.314279v-14.628557a7.314279 7.314279 0 0 1 7.314278-7.314279h59.489467a7.314279 7.314279 0 0 1 7.314279 7.314279z m-235.519776-97.523716c0-22.430455-16.091413-34.133301-40.472342-34.133301h-39.009487v67.778983h38.521868c24.868548-0.487619 40.472342-14.140939 40.472342-34.620919z m33.645682 0a66.316127 66.316127 0 0 1-75.58088 64.853271h-37.546631v53.638044a7.314279 7.314279 0 0 1-7.314279 7.314279h-18.529506a7.314279 7.314279 0 0 1-7.314279-7.314279v-176.517927a7.314279 7.314279 0 0 1 7.314279-7.314278H497.127169a63.390416 63.390416 0 0 1 71.679931 63.390415z m-191.634103 59.489467A59.489467 59.489467 0 0 1 313.782581 780.190708a71.192313 71.192313 0 0 1-60.464704-30.232352l21.942836-22.430455a48.761858 48.761858 0 0 0 38.03425 21.942837c17.554269 0 29.744734-11.702846 29.744733-37.059013v-117.02846a7.314279 7.314279 0 0 1 7.314279-7.314278h19.504743a7.314279 7.314279 0 0 1 7.314279 7.314278z' fill='#FFFFFF' p-id='5065'></path><path d='M901.850593 312.564487v6.82666h-263.801654a48.761858 48.761858 0 0 1-48.761858-48.761858V0.000975a48.761858 48.761858 0 0 1 34.620919 14.140939l264.289272 263.801654a48.761858 48.761858 0 0 1 13.653321 34.620919z' fill='#C1C7D0' p-id='5066'></path></svg>"
  } 
  else if(fileType == "bpm")
  {
    return "<div style=background:'url(images/jpg.png)';width:'24px';height:'27px';margin-right:'10px'></div>"
  }
  else if(fileType.indexOf("txt") != -1)
  {
    return "<svg t='1685260439242' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='5209' width='21' height='25'><path d='M901.632 926.72c0 12.8-5.12 25.088-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.304V48.64c0-12.8 5.12-25.6 14.336-34.304C144.896 5.12 157.696 0 170.496 0h418.816c12.8 0 25.6 5.12 34.816 14.336l263.68 263.68c9.216 9.216 14.336 21.504 14.336 34.816V926.72z' fill='#EBECF0' p-id='5210'></path><path d='M901.632 926.72v48.64c0 12.8-5.12 25.6-14.336 34.304-9.216 9.216-21.504 14.336-34.304 14.336H170.496c-27.136 0-48.64-22.016-48.64-48.64V926.72c0 12.8 5.12 25.088 14.336 34.304 9.216 9.216 21.504 14.336 34.304 14.336h682.496c27.136 0 48.64-22.016 48.64-48.64z' fill='#C1C7D0' p-id='5211'></path><path d='M24.064 536.576h975.36v243.712c0 27.136-22.016 48.64-48.64 48.64H73.216c-12.8 0-25.6-5.12-34.304-14.336-9.216-9.216-14.336-21.504-14.336-34.816v-243.2z' fill='#A8A1A0' p-id='5212'></path><path d='M121.856 536.576V438.784L24.064 536.576h97.792z m779.776 0l1.024-97.792 97.28 97.792h-98.304z' fill='#777777' p-id='5213'></path><path d='M901.632 312.832v6.656h-263.68c-27.136 0-48.64-22.016-48.64-48.64V0c12.8 0 25.6 5.12 34.816 14.336l264.192 263.68c8.704 9.216 13.824 21.504 13.312 34.816z' fill='#C1C7D0' p-id='5214'></path><path d='M228.864 629.76v-49.152h173.568v49.152H347.136v139.776H284.16V629.76H228.864zM512.512 715.776l-30.72 53.248H411.648l66.56-98.816-60.416-90.624h69.632l26.624 48.128 27.648-48.128h70.144L547.328 670.72l64.512 98.816h-70.144l-29.184-53.76zM622.592 629.76v-49.152h173.568v49.152h-55.296v139.776h-62.464V629.76h-55.808z' fill='#FFFFFF' p-id='5215'></path></svg>"
  }
  else
  {
    return "<svg t='1685260598593' class='icon' viewBox='0 0 1024 1024' version='1.1' xmlns='http://www.w3.org/2000/svg' p-id='6403' width='21' height='25'><path d='M887.6 911.3c0 12.5-4.9 24.4-13.8 33.2-8.8 8.8-20.8 13.8-33.2 13.8H182.9c-12.5 0-24.4-4.9-33.2-13.8-8.8-8.8-13.8-20.8-13.8-33.2V65.7c0-12.5 4.9-24.4 13.8-33.2 8.8-8.8 20.8-13.8 33.2-13.8h403.5c12.5-0.1 24.5 4.8 33.4 13.6l254.1 254.1c8.8 8.9 13.7 20.9 13.6 33.4v591.5z m0 0' fill='#EBECF0' p-id='6404'></path><path d='M887.6 911.3v47c0 12.5-4.9 24.4-13.8 33.2-8.8 8.8-20.8 13.8-33.2 13.8H182.9c-25.9 0-47-21-47-47v-47c0 12.5 4.9 24.4 13.8 33.2 8.8 8.8 20.8 13.8 33.2 13.8h657.7c12.5 0 24.4-4.9 33.2-13.8 8.8-8.8 13.8-20.7 13.8-33.2z m0 0' fill='#C1C7D0' p-id='6405'></path><path d='M42.5 535.1H982V770c0 12.5-5 24.4-13.8 33.2-8.8 8.8-20.8 13.8-33.2 13.8H89.5c-12.5 0-24.4-4.9-33.2-13.8-8.8-8.8-13.8-20.8-13.8-33.2V535.1z m0 0' fill='#59A6FD' p-id='6406'></path><path d='M136 535.5v-94l-94 94h94z m751.6 0l0.9-94 93.5 94h-94.4z m0 0' fill='#318AD3' p-id='6407'></path><path d='M887.6 319.9v6.6H633.4c-25.9 0-47-21-47-47V18.8c12.5-0.1 24.5 4.8 33.4 13.6l254.6 254.1c8.6 9 13.4 21 13.2 33.4z m0 0' fill='#C1C7D0' p-id='6408'></path><path d='M523.7 720.6h-32c-0.1-4.6-0.1-7.4-0.1-8.4 0-10.4 1.7-18.9 5.2-25.6 3.4-6.7 10.3-14.2 20.6-22.6 10.3-8.4 16.4-13.8 18.5-16.4 3.1-4.1 4.7-8.6 4.7-13.6 0-6.9-2.7-12.7-8.2-17.6-5.5-4.9-12.9-7.3-22.2-7.3-9 0-16.5 2.5-22.5 7.7-6 5.1-10.2 12.9-12.4 23.4l-32.4-4c0.9-15 7.3-27.7 19.2-38.2 11.8-10.5 27.4-15.7 46.7-15.7 20.3 0 36.4 5.3 48.3 15.9 12 10.6 18 22.9 18 37 0 7.8-2.2 15.2-6.6 22.1-4.4 6.9-13.8 16.4-28.2 28.4-7.5 6.2-12.1 11.2-13.9 15-2 3.4-2.8 10.2-2.7 19.9z m-32 47.4v-35.3H527V768h-35.3z' fill='#FFFFFF' p-id='6409'></path></svg>"
  }
}
window.toobarAttachmentDropFunc=function(event){
  if(!event)return;
  let fileName = $(event.target).attr("fileName");
  if(!fileName){
    fileName = $(event.target)[0].parentElement.attributes[2].value
  }

  var tableId=window.AttachmentTableId;
  var recId=  window.AttachmentRecId
  var base=window.userInfos.resourceURL;


  var url=base+"/attachments/" + tableId + "/" + recId + "/" + encodeURIComponent(fileName);

  window.open(url);
}

window.logOutTets=function(){
  var browser = {
    ie: 0,
    firefox: 0,
    safari: 0,
    konq: 0,
    opera: 0,
    chrome: 0,
  }
  var ua = navigator.userAgent
  if (window.opera) {
    browser.opera = window.opera.version()
  } else if (/AppleWebKit\/(\S+)/.test(ua)) {
    // 判断是 Chrome 还是 safari
    if (/Chrome\/(\S+)/.test(ua)) {
      browser.chrome = RegExp['$1']
    } else if (/Version\/(\S+)/.test(ua)) {
      // 仅使用于 safari 3 及其更高版本
      browser.safari = RegExp['$1']
    } else {
      // 个别情况-未获取到 safari 版本号的处理
    }
  } else if (/KHTML\/(\S+)/.test(ua) || /Konqueror\/([^;]+)/.test(ua)) {
    browser.konq = RegExp['$1']
  } else if (/rv:([^\)]+)\) Gecko\/\d{8}/.test(ua)) {
    if (/Firefox\/(\S+)/.test(ua)) {
      // 火狐浏览器
      browser.firefox = RegExp['$1']
    } else {
      // 其他情况
    }
  } else if (/MSIE ([^;]+)/.test(ua)) {
    browser.ie = RegExp['$1']
  }
  console.log("浏览器信息："+JSON.stringify(browser));

}



// window.dataSetViewDSExp = function(){
//   alert("1111");
// }

// window.dataSetViewRSelect = function(){
//   alert("2222");
// }

//在线表格 与 自主数据分析 所用到的 DATASET构造 
// window.structureDataSet = function(data){
//   var dataSet = {'id':CommonUtil.guid(),"dataTables":[]};
//   var dataTable ={'schema':{},'data':[]};
//   dataTable.schema.id = CommonUtil.guid();
//   dataTable.schema.name = data.queryTable.tableName.substr(data.queryTable.tableName.lastIndexOf(".")+1);
//   dataTable.schema.label = 'columnsArray';
//   dataTable.schema.type = 'Simple';
//   dataTable.schema.columns = [];
//   for(let i in data.dataColumn.columnsArray){
//     let column = data.dataColumn.columnsArray[i];
//     let schemaCol = {
//       name:dataTable.schema.name+"."+column.columnId,
//       label:column.label,
//       visible:true,
//       helpText:column.helpText,
//       displayLength:column.displayLength,
//       alignment:'left',
//       stringSize:column.stringSize,
//     };
//     dataTable.schema.columns.push(schemaCol);
//   }
//   if(window.osDataSetViewRecords){
//     dataTable.data = window.osDataSetViewRecords;
//   }
//   dataSet.dataTables.push(dataTable);
//   return dataSet;
// }


// WEBPACK FOOTER //
// ./src/index.js